<template>
  <!-- 开单(联城) -->
  <div class="contentBox" v-loading="loading">
    <div style="height: 60px; width: 100%" v-if="editable"></div>
    <div class="topBtns" v-if="editable">
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="submit('', 'k85')"
        ref="k85"
        >保存</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="saveAndPrintIt('套打', 'k86')"
        ref="k86"
        >保存并套打</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="saveAndPrintIt('全打', 'k87')"
        ref="k87"
        >保存并全打</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="saveAndPrintIt('标签打印', 'k88')"
        ref="k88"
        >打印标签</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="saveAndPrintIt('回扣打印', 'k89')"
        ref="k89"
        >打印回扣凭证</el-button
      >
      <el-button
        style="margin-top: 10px"
        class="glo_bg"
        @click="saveAndPrintIt('信封打印', 'k90')"
        ref="k90"
        >打印信封</el-button
      >
      <el-button
        ref="k91"
        style="margin-top: 10px"
        class="glo_bg"
        @click="submitAndPosting"
        v-if="!waybillNumberEditable"
        >保存并过账</el-button
      >

      <el-button style="margin-top: 10px" class="glo_bg" @click="setEnter"
        >界面光标设置</el-button
      >
    </div>
    <div class="form_head" v-loading="loadingDetail">
      <div class="waybill_Type">{{ waybillStatus }}</div>
      <el-form
        label-width="100px"
        class="head_formBox glo_formBox"
        ref="form1"
        :model="baseInfo"
        :rules="feeCheckIn ? {} : rule1"
      >
        <el-form-item label="运单号:" prop="waybillNumber">
          <el-input
            :disabled="disabledSee || feeCheckIn || !waybillNumberEditable"
            v-model="baseInfo.waybillNumber"
            placeholder="不录入则自动生成"
            clearable
            ref="k1"
            @keyup.enter.native="enterFns($event, 'k1')"
          ></el-input>
        </el-form-item>
        <el-form-item label="中转单号:" prop="transferNumber">
          <el-input
            :disabled="disabledSee || feeCheckIn"
            v-model="baseInfo.transferNumber"
            placeholder="请输入"
            clearable
            ref="k2"
            @keyup.enter.native="enterFns($event, 'k2')"
          ></el-input>
        </el-form-item>
        <el-form-item label="客户单号:" prop="customerOrderNumber">
          <el-input
            :disabled="disabledSee || feeCheckIn"
            v-model="baseInfo.customerOrderNumber"
            placeholder="请输入"
            clearable
            ref="k3"
            @keyup.enter.native="enterFns($event, 'k3')"
          ></el-input>
        </el-form-item>
        <el-form-item label="业务日期:" prop="businessDate">
          <el-date-picker
            v-model="baseInfo.businessDate"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="datetime"
            placeholder="选择日期"
            :disabled="disabledSee || feeCheckIn"
            ref="k4"
            @blur="enterFns(baseInfo.businessDate, 'k4', 'datetime')"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开单网点:" prop="businessDeptId">
          <el-select
            filterable
            clearable
            v-model="baseInfo.businessDeptId"
            placeholder="请选择"
            ref="k5"
            @keyup.enter.native="
              enterFns(baseInfo.businessDeptId, 'k5', 'select')
            "
          >
            <el-option
              v-for="dept in businessDepts"
              :key="dept.deptId"
              :label="dept.deptName"
              :value="dept.deptId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="all_div" v-loading="loadingDetail">
      <!-- 收发信息 -->
      <div class="infoDiv">
        <div class="h3title">收发信息</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form7"
            :model="baseInfo"
            :rules="feeCheckIn ? {} : rule7"
            style="margin-bottom: 0"
          >
            <!-- <el-form-item label="客户类型:" :required="!feeCheckIn">
              <el-radio-group
                :disabled="disabledSee || feeCheckIn"
                v-model="baseInfo.customerType"
                @change="changeCustomerType"
              >
                <el-radio :label="0">散客</el-radio>
                <el-radio :label="1">常客</el-radio>
              </el-radio-group>
            </el-form-item> -->
            <el-form-item
              label="开单客户:"
              :required="baseInfo.customerType == 1"
              v-show="baseInfo.customerType == 1"
              prop="customerName"
              style="width: 49%"
            >
              <el-select
                :disabled="disabledSee || feeCheckIn"
                clearable
                filterable
                remote
                allow-create
                :remote-method="remoteMethodCustomer"
                v-model="baseInfo.customerName"
                placeholder="请选择"
                @visible-change="changeCustomer"
                ref="k16"
                @change="changeMethodCustomer($event, 'k16')"
                @keyup.enter.native="
                  enterFns(baseInfo.customerName, 'k16', 'select')
                "
                default-first-option
              >
                <!-- @focus="focusMethodCustomer" -->
                <el-option
                  v-for="(item, index) in CustomerLists"
                  :key="index"
                  :label="
                    (item.phone || '') +
                    ' / ' +
                    (item.customerNumber || '') +
                    ' / ' +
                    item.customerName
                  "
                  :value="item.customerName"
                ></el-option>
              </el-select>
            </el-form-item>

            <div class="lookBJ" v-if="baseInfo.customerId" @click="getCBJ">
              看客户报价
            </div>

            <!-- <div class="checkBox" v-if="baseInfo.customerType === 0">
                  <el-checkbox
                    v-model="isAddCustomer"
                    >收录客户档案</el-checkbox
                  >
            </div> -->
            <!-- <el-form-item
              label="收录客户档案:"
              style="width: 49%"
              class="double_item"
              v-if="baseInfo.customerType === 0"
            >
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="baseInfo.isAddCustomer"
                placeholder="请选择"
                @change="changeisAddCustomer($event, 'k161')"
                @keyup.enter.native="
                  enterFns(transportInfo.isAddCustomer, 'k161', 'select')
                "
                ref="k161"
              >
                <el-option :value="1" label="自动收录"></el-option>
                <el-option :value="0" label="不收录"></el-option>
              </el-select>
              <el-input
                class="second_ipt"
                v-model="baseInfo.customerName"
                placeholder="客户名称"
                clearable
                ref="k162"
                @keyup.enter.native="enterFns(baseInfo.customerName, 'k162')"
              ></el-input>
              <el-input
                class="second_ipt"
                v-model="baseInfo.customerContacts"
                placeholder="客户联系人"
                clearable
                ref="k163"
                @keyup.enter.native="
                  enterFns(baseInfo.customerContacts, 'k163')
                "
              ></el-input>

              <el-input
                class="second_ipt"
                v-model="baseInfo.customerPhone"
                placeholder="客户手机号"
                clearable
                ref="k164"
                @keyup.enter.native="enterFns(baseInfo.customerPhone, 'k164')"
                @change="changeCustomerManual"
              ></el-input>
            </el-form-item> -->
          </el-form>
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form3"
            :model="sendAddr"
            style="margin: 0"
          >
            <!-- <template v-for="(sendAddr, index) in sendAddrs">
              <div :key="index"> -->
            <el-form-item label="发货单位:" prop="company">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="sendAddr.company"
                placeholder="请输入"
                clearable
                ref="k18"
                @keyup.enter.native="enterFns(sendAddr.company, 'k18')"
              ></el-input>
            </el-form-item>
            <el-form-item label="发货人:" prop="contacts">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="sendAddr.contacts"
                placeholder="请输入"
                clearable
                ref="k17"
                @keyup.enter.native="enterFns(sendAddr.contacts, 'k17')"
              ></el-input>
            </el-form-item>

            <el-form-item label="联系电话:" prop="tel">
              <!-- <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="sendAddr.tel"
                placeholder="请输入"
                clearable
                ref="k19"
                @keyup.enter.native="enterFns(sendAddr.tel, 'k19')"
              ></el-input> -->
              <el-select
                :disabled="disabledSee || feeCheckIn"
                clearable
                filterable
                remote
                allow-create
                :remote-method="remoteMethodPhoneJJ"
                v-model="sendAddr.tel"
                value-key="id"
                placeholder="请选择"
                ref="k19"
                @visible-change="changePhone"
                @change="changeMethodPhone($event, 'k19')"
              >
                <!-- @focus="focusMethodCustomer" -->
                <el-option
                  v-for="(item, index) in sendPhoneLists"
                  :key="index"
                  :label="item.addrPhone"
                  :value="item"
                  >{{ item.addrPhone }} / {{ item.customerName }} /
                  {{ item.personnelName }} / {{ item.provinceName
                  }}{{ item.cityName }}{{ item.areaName
                  }}{{ item.address }}</el-option
                >
              </el-select>
            </el-form-item>
            <el-form-item label="身份证号码:" prop="idNumber">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="sendAddr.idNumber"
                placeholder="请输入"
                clearable
                ref="k20"
                @keyup.enter.native="enterFns(sendAddr.idNumber, 'k20')"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%; border: 0" label="发货地址:">
              <div class="disFlexs">
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="sendAddr.provinceName"
                  placeholder="请选择省"
                  clearable
                  filterable
                  ref="k21"
                  @change="changeProvince('', sendAddr.provinceName, 'k21')"
                  @keyup.enter.native="
                    enterFns(sendAddr.provinceName, 'k21', 'select')
                  "
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="sendAddr.cityName"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @focus="getCityName(sendAddr.provinceName)"
                  ref="k22"
                  @change="changeCity('', sendAddr.cityName, 'k22')"
                  @keyup.enter.native="
                    enterFns(sendAddr.cityName, 'k22', 'select')
                  "
                >
                  <el-option
                    v-for="(item, index) in cityNameList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="sendAddr.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName(sendAddr.cityName)"
                  ref="k23"
                  @change="changeArea(sendAddr.areaName, 'k23')"
                  @keyup.enter.native="
                    enterFns(sendAddr.areaName, 'k23', 'select')
                  "
                >
                  <el-option
                    v-for="(item, index) in areaNameList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress addressDetails"
                  v-model="sendAddr.address"
                  placeholder="请输入详细地址"
                  clearable
                  @keyup.enter.native="geocode(sendAddr.address, '', 'k24')"
                  ref="k24"
                ></el-input>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-full-screen"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #409eff;
                    font-weight: bold;
                  "
                  @click="go2AddressAI(1)"
                ></i>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-map-location"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #ff0000;
                    font-weight: bold;
                  "
                  @click="go2Map(1)"
                ></i>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-search"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    color: #7f7f7f;
                    font-weight: bold;
                  "
                  @click="changeRecAddress(1)"
                ></i>
                <div class="checkBox">
                  <el-checkbox disabled v-model="isAutoAddr_jj"
                    >收录发货地址</el-checkbox
                  >
                </div>
              </div>
            </el-form-item>
            <div class="Divider"></div>
            <!-- </div>
            </template> -->
            <el-form-item label="收货单位:">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="receiveAddr.company"
                placeholder="请输入"
                clearable
                ref="k26"
                @keyup.enter.native="enterFns(receiveAddr.company, 'k26')"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货人:">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="receiveAddr.contacts"
                placeholder="请输入"
                clearable
                ref="k25"
                @keyup.enter.native="enterFns(receiveAddr.contacts, 'k25')"
              ></el-input>
            </el-form-item>

            <el-form-item label="联系电话:">
              <el-select
                :disabled="disabledSee || feeCheckIn"
                clearable
                filterable
                remote
                allow-create
                :remote-method="remoteMethodPhoneSJ"
                v-model="receiveAddr.tel"
                value-key="id"
                placeholder="请选择"
                ref="k27"
                @visible-change="changePhoneSJ"
                @change="changeMethodPhoneSJ($event, 'k27')"
              >
                <!-- @focus="focusMethodCustomer" -->
                <el-option
                  v-for="(item, index) in SJPhoneLists"
                  :key="index"
                  :label="item.addrPhone"
                  :value="item"
                  >{{ item.addrPhone }} / {{ item.customerName }} /
                  {{ item.personnelName }} / {{ item.provinceName
                  }}{{ item.cityName }}{{ item.areaName
                  }}{{ item.address }}</el-option
                >
              </el-select>
              <!-- <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="receiveAddr.tel"
                placeholder="请输入"
                clearable
                ref="k27"
                @keyup.enter.native="enterFns(receiveAddr.tel, 'k27')"
              ></el-input> -->
            </el-form-item>
            <el-form-item label="身份证号码:">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="receiveAddr.idNumber"
                placeholder="请输入"
                clearable
                ref="k28"
                @keyup.enter.native="enterFns(receiveAddr.idNumber, 'k28')"
              ></el-input>
            </el-form-item>
            <el-form-item style="width: 100%; border: 0" label="收货地址:">
              <div class="disFlexs">
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="receiveAddr.provinceName"
                  placeholder="请选择省"
                  clearable
                  filterable
                  @change="changeProvince(1, receiveAddr.provinceName, 'k29')"
                  @keyup.enter.native="
                    enterFns(receiveAddr.provinceName, 'k29', 'select')
                  "
                  ref="k29"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="receiveAddr.cityName"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @focus="getCityName(receiveAddr.provinceName, 1)"
                  @change="changeCity(1, receiveAddr.cityName, 'k30')"
                  @keyup.enter.native="
                    enterFns(receiveAddr.cityName, 'k30', 'select')
                  "
                  ref="k30"
                >
                  <el-option
                    v-for="(item, index) in cityNameList_1"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="receiveAddr.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName(receiveAddr.cityName, 1)"
                  @change="changeArea('', receiveAddr.areaName, 'k31')"
                  @keyup.enter.native="
                    enterFns(receiveAddr.areaName, 'k31', 'select')
                  "
                  ref="k31"
                >
                  <el-option
                    v-for="(item, index) in areaNameList_1"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress addressDetails"
                  v-model="receiveAddr.address"
                  placeholder="请输入详细地址"
                  clearable
                  @keyup.enter.native="geocode(receiveAddr.address, '', 'k32')"
                  ref="k32"
                ></el-input>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-full-screen"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #409eff;
                    font-weight: bold;
                  "
                  @click="go2AddressAI(2)"
                ></i>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-map-location"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #ff0000;
                    font-weight: bold;
                  "
                  @click="go2Map(2)"
                ></i>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-search"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    color: #7f7f7f;
                    font-weight: bold;
                  "
                  @click="changeRecAddress(2)"
                ></i>
                <div class="checkBox">
                  <el-checkbox disabled v-model="isAutoAddr_sj"
                    >收录收货人信息</el-checkbox
                  >
                </div>
              </div>
            </el-form-item>
            <div class="Divider"></div>
            <el-form-item label="自提电话:">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="takeAddr.tel"
                placeholder="请输入"
                clearable
                ref="k33"
                @keyup.enter.native="enterFns(takeAddr.tel, 'k33')"
              ></el-input>
            </el-form-item>
            <el-form-item style="flex: 1; border: 0" label="自提地址:">
              <div class="disFlexs">
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="takeAddr.provinceName"
                  placeholder="请选择省"
                  clearable
                  filterable
                  @change="changeProvince(2, takeAddr.provinceName, 'k34')"
                  @keyup.enter.native="
                    enterFns(takeAddr.provinceName, 'k34', 'select')
                  "
                  ref="k34"
                >
                  <el-option
                    v-for="(item, index) in SuperiorRegionList"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="takeAddr.cityName"
                  placeholder="请选择市"
                  clearable
                  filterable
                  @focus="getCityName(takeAddr.provinceName, 2)"
                  @change="changeCity(2, takeAddr.cityName, 'k35')"
                  @keyup.enter.native="
                    enterFns(takeAddr.cityName, 'k35', 'select')
                  "
                  ref="k35"
                >
                  <el-option
                    v-for="(item, index) in cityNameList_2"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress"
                  v-model="takeAddr.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                  @focus="getAreaName(takeAddr.cityName, 2)"
                  @change="changeArea('', takeAddr.areaName, 'k36')"
                  @keyup.enter.native="
                    enterFns(takeAddr.areaName, 'k36', 'select')
                  "
                  ref="k36"
                >
                  <el-option
                    v-for="(item, index) in areaNameList_2"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  ></el-option>
                </el-select>
                <el-input
                  :disabled="disabledSee || feeCheckIn"
                  class="selectAddress addressDetails"
                  v-model="takeAddr.address"
                  placeholder="请输入详细地址"
                  clearable
                  @keyup.enter.native="geocode(takeAddr.address, '', 'k37')"
                  ref="k37"
                ></el-input>
                <i
                  v-if="!disabledSee && !feeCheckIn"
                  class="el-icon-map-location"
                  style="
                    font-size: 20px;
                    cursor: pointer;
                    margin-right: 5px;
                    color: #ff0000;
                    font-weight: bold;
                  "
                  @click="go2Map(3)"
                ></i>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 基本信息 -->
      <div class="infoDiv">
        <div class="h3title">基础信息</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form2"
            :model="baseInfo"
            :rules="feeCheckIn ? {} : rule2"
            show-message
          >
            <el-form-item label="目的城市:" prop="destCity">
              <el-select
                clearable
                placeholder="请输入并选择"
                filterable

                remote
                allow-create
                v-model="baseInfo.destCity"
                :remote-method="getDestCities"
                :loading="destCityLoading"
                @change="changeDestCity"
                @clear="clearDestCity"
                :disabled="disabledSee || feeCheckIn"
                ref="k6"
                @keyup.enter.native="
                  enterFns(baseInfo.destCity, 'k6', 'select')
                "
              >
                <el-option
                  v-for="(city, index) in destCitys"
                  :key="index"
                  :label="city.destCity"
                  :value="city.cityName"
                >
                  <span style="float: left">{{ city.destCity }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    city.adCode
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="运输路线:" prop="transportLineId">
              <el-select
                clearable
                placeholder="请输入并选择"
                filterable
                remote
                v-model="baseInfo.transportLineId"
                :loading="transportLineLoading"
                :disabled="disabledSee || feeCheckIn"
                @change="changeTransportLine($event, 'k7')"
                ref="k7"
                @keyup.enter.native="
                  enterFns(baseInfo.transportLineId, 'k7', 'select')
                "
              >
                <el-option
                  v-for="line in lines"
                  :key="line.id"
                  :label="line.lineName"
                  :value="line.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="终端网点:" prop="endDeptId">
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="baseInfo.endDeptId"
                placeholder="请选择"
                @change="changeEndDept($event, 'k8')"
                ref="k8"
                @keyup.enter.native="
                  enterFns(baseInfo.endDeptId, 'k8', 'select')
                "
              >
                <el-option
                  v-for="dept in businessDepts"
                  :key="dept.deptId"
                  :label="dept.deptName"
                  :value="dept.deptId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="发货方式:"
              :required="!feeCheckIn"
              prop="receiveMethodConfDictId"
            >
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="baseInfo.receiveMethodConfDictId"
                placeholder="请选择"
                @change="changeSelectKey($event, 'k9')"
                ref="k9"
                @keyup.enter.native="
                  enterFns(baseInfo.receiveMethodConfDictId, 'k9', 'select')
                "
              >
                <el-option
                  v-for="item in receMethods"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="运输方式:"
              :required="!feeCheckIn"
              prop="transportMethodConfDictId"
            >
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="baseInfo.transportMethodConfDictId"
                placeholder="请选择"
                ref="k10"
                @change="changeSelectKey($event, 'k10')"
                @keyup.enter.native="
                  enterFns(baseInfo.transportMethodConfDictId, 'k10', 'select')
                "
              >
                <el-option
                  v-for="item in transportMethods"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="交货方式:"
              :required="!feeCheckIn"
              prop="sendMethodConfDictId"
            >
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="baseInfo.sendMethodConfDictId"
                placeholder="请选择"
                @change="changeSendMethod_Fn($event, 'k11')"
                ref="k11"
                @keyup.enter.native="
                  enterFns(baseInfo.sendMethodConfDictId, 'k11', 'select')
                "
              >
                <el-option
                  v-for="item in sendMethods"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="回单要求:" prop="rnRequireCount">
              <div class="glo_disFlex" style="padding-right: 3px">
                <el-select
                  style="flex"
                  v-model="baseInfo.rnRequireConfDictId"
                  placeholder="请选择"
                  filterable
                  clearable
                  :disabled="disabledSee || feeCheckIn"
                  @change="changeRnRquireConf($event, 'k12')"
                  ref="k12"
                  @keyup.enter.native="
                    enterFns(baseInfo.rnRequireConfDictId, 'k12', 'select')
                  "
                >
                  <el-option
                    v-for="item in rnRequirements"
                    :key="item.id"
                    :label="item.val"
                    :value="item.id"
                  ></el-option>
                </el-select>
                <el-input
                  class="miniInput"
                  v-model="baseInfo.rnRequireCount"
                  placeholder="份数"
                  type="number"
                  @mousewheel.native.prevent
                  :disabled="disabledSee || feeCheckIn"
                  ref="k13"
                  @keyup.enter.native="enterFns(baseInfo.rnRequireCount, 'k13')"
                ></el-input
                >份
              </div>
            </el-form-item>
            <el-form-item label="订单指令:" prop="commandId">
              <el-select
                v-model="baseInfo.commandId"
                placeholder="请输入或选择"
                clearable
                filterable
                :disabled="disabledSee || feeCheckIn"
                ref="k14"
                @change="changeSelectKey($event, 'k14')"
                @keyup.enter.native="
                  enterFns(baseInfo.commandId, 'k14', 'select')
                "
              >
                <el-option
                  v-for="item in commands"
                  :key="item.commandId"
                  :label="item.number"
                  :value="item.commandId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否外提:" prop="isOutTake">
              <el-select
                clearable
                placeholder="请输入并选择"
                filterable
                v-model="baseInfo.isOutTake"
                :disabled="disabledSee || feeCheckIn"
                @change="changeisOutTake($event, 'k97')"
                ref="k97"
                @keyup.enter.native="
                  enterFns(baseInfo.isOutTake, 'k97', 'select')
                "
              >
                <el-option :value="1" label="是"></el-option>
                <el-option :value="0" label="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提货人员:" prop="driverOneName">
              <el-input
                disabled
                v-model="baseInfo.driverOneName"
                placeholder=""
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="收件员:" prop="receiveObjectName">
              <el-input
                disabled
                v-model="baseInfo.receiveObjectName"
                placeholder=""
                clearable
              ></el-input>
            </el-form-item>
            <!-- <el-form-item  class="textArea" style="width: 100%" label="备注:" prop="remarks">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                placeholder="请输入"
                clearable
                v-model="baseInfo.remarks"
                type="textarea"
                ref="k15"
                @keyup.enter.native="
                  enterFns(baseInfo.remarks, 'k15', 'textarea')
                "
              ></el-input>
            </el-form-item> -->
          </el-form>
        </div>
      </div>
      <!-- 货物信息 -->
      <div class="infoDiv" id="tables">
        <div class="h3title">货物信息</div>
        <div class="formbox goodsItmes">
          <div class="glo_Table goodsTable">
            <el-table
              :data="sendAddrs_1"
              border
              show-summary
              ref="mytable1"
              :summary-method="getSummaries"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column prop="goodsNumber" label="货物编号">
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="text"
                    v-model="sendAddrs_1[scope.$index].goodsNumber"
                    placeholder="请输入"
                    @keyup.enter.native="
                      enterFns(sendAddrs_1[scope.$index].goodsNumber, 'k38')
                    "
                    ref="k38"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                prop="goodsName"
                label="品名"
              >
                <template slot-scope="scope">
                  <el-select
                    :disabled="disabledSee || feeCheckIn"
                    clearable
                    filterable
                    remote
                    allow-create
                    default-first-option
                    placeholder="请选择"
                    v-model="sendAddrs_1[scope.$index].goodsName"
                    :remote-method="
                      (e) => {
                        remoteMethodCategory(e, scope.$index);
                      }
                    "
                    @change="
                      (e) => {
                        changeMethodCategory(e, scope.$index, 'k39');
                      }
                    "
                    @focus="focusMethodCategory(scope.$index)"
                    @clear="remoteMethodCategory('', scope.$index)"
                    @keyup.enter.native="
                      enterFns(
                        sendAddrs_1[scope.$index].goodsName,
                        'k39',
                        'select'
                      )
                    "
                    ref="k39"
                  >
                    <el-option
                      v-for="(item2, index2c) in goodsList"
                      :key="index2c"
                      :label="item2.itemName"
                      :value="item2.itemName"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="packageName" label="包装">
                <template slot-scope="scope">
                  <el-select
                    @change="
                      onInputHW(
                        scope.$index,
                        sendAddrs_1[scope.$index].packageName,
                        'k40'
                      )
                    "
                    :disabled="disabledSee || feeCheckIn"
                    v-model="sendAddrs_1[scope.$index].packageName"
                    filterable
                    allow-create
                    clearable
                    placeholder="请选择"
                    @keyup.enter.native="
                      enterFns(
                        sendAddrs_1[scope.$index].packageName,
                        'k40',
                        'select'
                      )
                    "
                    ref="k40"
                  >
                    <el-option
                      v-for="(item2, index2c) in packageNameList"
                      :key="index2c"
                      :label="item2.val"
                      :value="item2.val"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="packageCout" label="*件数" sortable>
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].packageCout"
                    placeholder="请输入"
                    @keyup.enter.native="
                      enterFns(sendAddrs_1[scope.$index].packageCout, 'k41')
                    "
                    ref="k41"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="grossWeight" label="*毛重/KG" sortable>
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].grossWeight"
                    placeholder="请输入"
                    @keyup.enter.native="
                      enterFns(sendAddrs_1[scope.$index].grossWeight, 'k42')
                    "
                    ref="k42"
                    @change="calcGoodsFreight(sendAddrs_1[scope.$index])"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="netWeight" label="净重/KG" sortable>
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].netWeight"
                    placeholder="请输入"
                    @keyup.enter.native="
                      enterFns(sendAddrs_1[scope.$index].netWeight, 'k43')
                    "
                    ref="k43"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="volume"
                label="*体积/m³"
                sortable
                width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    @change="calcVolumeWeight(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].volume"
                    placeholder="请输入"
                    @keyup.enter.native="
                      enterFns(sendAddrs_1[scope.$index].volume, 'k44')
                    "
                    ref="k44"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="volumeDivisor"
                label="*体积系数"
                sortable
                width="100"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    @change="calcVolumeWeight(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].volumeDivisor"
                    placeholder="请输入"
                    @keyup.enter.native="
                      enterFns(sendAddrs_1[scope.$index].volumeDivisor, 'k45')
                    "
                    ref="k45"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="volumeWeight"
                label="体积重量/KG"
                sortable
                width="120"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="disabledSee || feeCheckIn"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].volumeWeight"
                    placeholder="请输入"
                    @keyup.enter.native="
                      enterFns(sendAddrs_1[scope.$index].volumeWeight, 'k46')
                    "
                    ref="k46"
                    @change="calcGoodsFreight(sendAddrs_1[scope.$index])"
                  >
                    <template #suffix>
                      <el-image
                        style="width: 18px; height: 100%"
                        :src="calculator"
                        fit="contain"
                        @click="calcVolumeWeight(scope.$index)"
                      ></el-image>
                    </template>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column
                prop="billingWeight"
                label="计费重量"
                sortable
                width="120"
              >
                <template slot-scope="scope">
                  <el-input
                    @input="onInputHW(scope.$index)"
                    :disabled="true"
                    type="number"
                    v-model="sendAddrs_1[scope.$index].billingWeight"
                    placeholder="请输入"
                    @keyup.enter.native="
                      enterFns(sendAddrs_1[scope.$index].billingWeight, 'k47')
                    "
                    ref="k47"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="specs" label="规格">
                <template slot-scope="scope">
                  <div
                    class="linkTabel"
                    ref="k48"
                    @click="clickSet(scope.$index)"
                  >
                    规格
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="packageName" label="重/泡货">
                <template slot-scope="scope">
                  <el-select
                    @change="
                      onInputHW(
                        scope.$index,
                        sendAddrs_1[scope.$index].heavyCargoConfDictId,
                        'k49'
                      )
                    "
                    :disabled="disabledSee || feeCheckIn"
                    v-model="sendAddrs_1[scope.$index].heavyCargoConfDictId"
                    filterable
                    clearable
                    placeholder="请选择"
                    @keyup.enter.native="
                      enterFns(
                        sendAddrs_1[scope.$index].heavyCargoConfDictId,
                        'k49',
                        'select'
                      )
                    "
                    ref="k49"
                  >
                    <el-option
                      v-for="(item2, index2c) in heavyCargos"
                      :key="index2c"
                      :label="item2.val"
                      :value="item2.id"
                    ></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                v-if="false && !disabledSee && !feeCheckIn"
              >
                <template slot-scope="scope">
                  <div class="iconList">
                    <i
                      v-if="scope.$index == 0"
                      class="el-icon-circle-plus iconSize"
                      @click="AddGoods(scope.$index)"
                    ></i>
                    <el-popconfirm
                      v-else
                      title="确定删除该行货物信息吗"
                      @confirm="delGoods(scope.$index)"
                    >
                      <i slot="reference" class="el-icon-remove iconSize"></i>
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 运输要求 -->
      <div class="infoDiv">
        <div class="h3title">运输要求</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form4"
            :rules="rule4"
            :model="transportInfo"
          >
            <el-form-item label="预计提货时间:">
              <el-date-picker
                :disabled="disabledSee || feeCheckIn"
                v-model="transportInfo.takeTime"
                value-format="yyyy-MM-dd  HH:mm:ss"
                default-time="23:59:59"
                type="datetime"
                placeholder="请选择"
                ref="k50"
                @blur="enterFns(transportInfo.takeTime, 'k50', 'datetime')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="预计送货时间:">
              <el-date-picker
                :disabled="disabledSee || feeCheckIn"
                v-model="transportInfo.deliveryTime"
                value-format="yyyy-MM-dd  HH:mm:ss"
                default-time="23:59:59"
                type="datetime"
                placeholder="请选择"
                ref="k51"
                @blur="enterFns(transportInfo.deliveryTime, 'k51', 'datetime')"
              ></el-date-picker>
            </el-form-item>
            <el-form-item
              label="是否入仓:"
              style="width: 48%"
              class="double_item"
            >
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="transportInfo.isIntoStorage"
                placeholder="请选择"
                @change="changeIntoStorage($event, 'k52')"
                @keyup.enter.native="
                  enterFns(transportInfo.isIntoStorage, 'k52', 'select')
                "
                ref="k52"
              >
                <el-option :value="1" label="是"></el-option>
                <el-option :value="0" label="否"></el-option>
              </el-select>
              <el-input
                :disabled="disabledSee || feeCheckIn"
                class="second_ipt"
                v-model="transportInfo.intoStorageName"
                placeholder="仓库名"
                clearable
                ref="531"
                @keyup.enter.native="
                  enterFns(transportInfo.intoStorageName, '531')
                "
              ></el-input>
              <el-input
                :disabled="disabledSee || feeCheckIn"
                class="second_ipt"
                v-model="transportInfo.intoStorageNumber"
                placeholder="入仓号"
                clearable
                ref="k53"
                @keyup.enter.native="
                  enterFns(transportInfo.intoStorageNumber, 'k53')
                "
              ></el-input>

              <el-input
                :disabled="disabledSee || feeCheckIn"
                class="second_ipt"
                v-model="transportInfo.markNumber"
                placeholder="唛头"
                clearable
                ref="532"
                @keyup.enter.native="enterFns(transportInfo.markNumber, '532')"
              ></el-input>
            </el-form-item>
            <el-form-item label="收货仓号:">
              <el-input
                :disabled="disabledSee || feeCheckIn"
                v-model="transportInfo.receiveStorageNumber"
                placeholder="请输入"
                clearable
                ref="k54"
                @keyup.enter.native="
                  enterFns(transportInfo.receiveStorageNumber, 'k54')
                "
              ></el-input>
            </el-form-item>
            <div style="width: 100%; display: flex; align-items: center">
              <el-form-item label="特殊要求:">
                <el-select
                  :disabled="disabledSee || feeCheckIn"
                  clearable
                  filterable
                  remote
                  allow-create
                  default-first-option
                  v-model="transportInfo.specialRequire"
                  @change="changeSpecialRequire($event, 'k55')"
                  placeholder="请输入或选择"
                  @keyup.enter.native="
                    enterFns(transportInfo.specialRequire, 'k55', 'select')
                  "
                  ref="k55"
                >
                  <el-option
                    v-for="(item, index) in specialRequirements"
                    :key="index"
                    :label="item.val"
                    :value="item.val"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-checkbox
                v-model="transportInfo.isUrgent"
                :true-label="1"
                :false-label="0"
                :disabled="disabledSee || feeCheckIn"
                >加急</el-checkbox
              >
              <el-checkbox
                v-model="transportInfo.isWaitNoticeSend"
                :true-label="1"
                :false-label="0"
                :disabled="disabledSee || feeCheckIn"
                >等通知放货</el-checkbox
              >
              <el-checkbox
                v-model="transportInfo.isValuable"
                :true-label="1"
                :false-label="0"
                :disabled="disabledSee || feeCheckIn"
                >贵重</el-checkbox
              >
            </div>
          </el-form>
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form8"
            :rules="baseEdit ? {} : rule8"
            :model="financeInInfo"
          >
            <div style="width: 100%; display: flex">
              <el-form-item
                label="是否投保:"
                class="double_item"
                prop="isInsure"
              >
                <el-select
                  :disabled="disabledSee || baseEdit"
                  filterable
                  clearable
                  v-model="financeInInfo.isInsure"
                  placeholder="请选择"
                  @change="changeInsure($event, 'k56')"
                  @keyup.enter.native="
                    enterFns(financeInInfo.isInsure, 'k56', 'select')
                  "
                  ref="k56"
                >
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="声明价值:"
                prop="declaredValue"
                :required="financeInInfo.isInsure === 1"
              >
                <div style="position: relative">
                  <el-row>
                    <el-col :span="16"
                      ><el-input
                        :disabled="disabledSee || baseEdit"
                        v-model="financeInInfo.declaredValue"
                        type="number"
                        placeholder="请输入"
                        clearable
                        ref="k57"
                        @keyup.enter.native="
                          enterFns(financeInInfo.declaredValue, 'k57')
                        "
                      ></el-input>
                    </el-col>
                    <el-col :span="8">
                      <el-input
                        :disabled="disabledSee"
                        v-model="financeInInfo.declaredValueRate"
                        type="number"
                        placeholder="请输入"
                        suffix-icon=""
                        ref="k58"
                        @keyup.enter.native="
                          enterFns(financeInInfo.declaredValueRate, 'k58')
                        "
                      ></el-input>
                    </el-col> </el-row
                  ><span style="position: absolute; right: 2px; top: 0">‰</span>
                </div>
              </el-form-item>
            </div>
          </el-form>

          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form2"
            :model="baseInfo"
            :rules="feeCheckIn ? {} : rule2"
            show-message
          >
            <div style="width: 100%; display: flex">
              <el-form-item
                style="width: 100%"
                label="备注:"
                prop="remarks"
                class="special-remark double_item"
              >
                <!-- <el-select v-if="!disabledSee && !feeCheckIn"
                  style="width:100px"
                  :disabled="disabledSee || feeCheckIn"
                  filterable
                  remote
                  default-first-option
                  v-model="baseInfo.remarksTemp"
                  @change="changeremarks($event, 'k15')"
                  placeholder="请选择"
                  @keyup.enter.native="
                    enterFns(baseInfo.remarksTemp, 'k15', 'select')
                  "
                  ref="k15"
                  @visible-change="getRemarkList"
                >
                  <el-option
                    v-for="(item, index) in baseInfoRemarksList"
                    :key="index"
                    :label="item.val"
                    :value="item.val"
                  ></el-option>
                </el-select>
                <el-input v-model="baseInfo.remarks" :disabled="disabledSee || feeCheckIn"></el-input> -->
                <el-autocomplete
                  style="width: 100%"
                  class="inline-input"
                  v-model="baseInfo.remarks"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入内容"
                  value-key="val"
                  :trigger-on-focus="true"
                  ref="k15"
                  @change="changeremarks($event, 'k15')"
                  @keyup.enter.native="
                    enterFns(baseInfo.remarks, 'k15', 'select')
                  "
                ></el-autocomplete>
              </el-form-item>
            </div>
          </el-form>

          <!-- 运单图片 -->
          <div class="upload_pic" style="margin-bottom: 10px">
            <div
              style="
                margin-bottom: 10px;
                font-size: 13px;
                color: #303133;
                line-height: 1.769230769230769;
              "
            >
              上传图片: (支持上传jpg/png文件)
            </div>
            <my-image-upload
              @input="changeFileList"
              :fileNameLists="fileNameLists"
              :disabled="disabledSee || feeCheckIn"
            ></my-image-upload>
          </div>
        </div>
      </div>
      <!-- 财务应收 -->
      <div class="infoDiv">
        <div class="h3title">财务应收</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            :model="financeInInfo"
            ref="form5"
            :rules="baseEdit ? {} : rule5"
          >
            <el-form-item
              label="计费方式:"
              :required="!baseEdit"
              prop="formulaBillingWeightId"
            >
              <el-select
                v-model="financeInInfo.formulaBillingWeightId"
                placeholder="请选择"
                clearable
                filterable
                @change="changeBILLMethode($event, 'k59')"
                :disabled="disabledSee || baseEdit"
                @keyup.enter.native="
                  enterFns(
                    financeInInfo.formulaBillingWeightId,
                    'k59',
                    'select'
                  )
                "
                ref="k59"
              >
                <el-option
                  v-for="item in formulasBillingWeight"
                  :key="item.formulaBillingWeightId"
                  :label="item.formulaBillingWeightName"
                  :value="item.formulaBillingWeightId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单价:">
              <el-input
                :disabled="disabledSee || baseEdit"
                type="number"
                @mousewheel.native.prevent
                v-model="financeInInfo.unitPrice"
                placeholder="请输入"
                @input="getGoodsTable(0, 0)"
                ref="k60"
                @keyup.enter.native="enterFns(financeInInfo.unitPrice, 'k60')"
              ></el-input>
            </el-form-item>
            <el-form-item label="基本运费:" prop="basicFreight">
              <div class="disFlexs jsInput">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.basicFreight"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @mousewheel.native.prevent
                  @change="getTotalFreight()"
                  ref="k61"
                  @keyup.enter.native="
                    enterFns(financeInInfo.basicFreight, 'k61')
                  "
                ></el-input>
                <el-button
                  class="jsBtns glo_bgcMainColor"
                  @click="getBasicFreight()"
                  >计算</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="提货费:" prop="takeFee">
              <el-input
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.takeFee"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
                ref="k62"
                @keyup.enter.native="enterFns(financeInInfo.takeFee, 'k62')"
              ></el-input>
            </el-form-item>
            <el-form-item label="送货费:" prop="sendFee">
              <el-input
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.sendFee"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
                ref="k63"
                @keyup.enter.native="enterFns(financeInInfo.sendFee, 'k63')"
              ></el-input>
            </el-form-item>
            <el-form-item label="中转费:" prop="transferFee">
              <el-input
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.transferFee"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
                ref="k64"
                @keyup.enter.native="enterFns(financeInInfo.transferFee, 'k64')"
              ></el-input>
            </el-form-item>
            <el-form-item label="代收货款:" prop="agentAmount">
              <el-input
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.agentAmount"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="calcAgentService"
                ref="k65"
                @keyup.enter.native="enterFns(financeInInfo.agentAmount, 'k65')"
              ></el-input>
            </el-form-item>
            <el-form-item label="贷款手续费:" prop="agentServiceRate">
              <div class="glo_disFlex" style="padding-right: 3px">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  class="miniInput"
                  v-model="financeInInfo.agentServiceRate"
                  placeholder="费率"
                  type="number"
                  @mousewheel.native.prevent
                  @change="calcAgentService"
                  ref="k66"
                  @keyup.enter.native="
                    enterFns(financeInInfo.agentServiceRate, 'k66')
                  "
                ></el-input
                >‰
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.agentServiceFee"
                  placeholder="请输入"
                  readonly
                  type="number"
                  @mousewheel.native.prevent
                  @change="calcAgentService"
                  ref="k67"
                  @keyup.enter.native="
                    enterFns(financeInInfo.agentServiceFee, 'k67')
                  "
                  getSblur="FrvGe_Me_get_method"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item label="保险费:" prop="insuranceFee">
              <div class="disFlexs jsInput">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.insuranceFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @mousewheel.native.prevent
                  @change="getTotalFreight()"
                  ref="k68"
                  @keyup.enter.native="
                    enterFns(financeInInfo.insuranceFee, 'k68')
                  "
                ></el-input>
                <el-button
                  v-if="financeInInfo.isInsure"
                  class="jsBtns glo_bgcMainColor"
                  @click="getBXFee"
                  >计算</el-button
                >
              </div>
            </el-form-item>
            <el-form-item label="其他费用:" prop="allOtherFee">
              <div class="disFlexs jsInput">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.allOtherFee"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @mousewheel.native.prevent
                  @change="getTotalFreight()"
                  ref="k69"
                  @keyup.enter.native="
                    enterFns(financeInInfo.allOtherFee, 'k69')
                  "
                ></el-input>
                <el-button class="jsBtns glo_bgcMainColor" @click="AddFeiXian"
                  >明细</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              label="服务费:"
              prop="serviceFee"
              :required="!baseEdit"
            >
              <div class="disFlexs jsInput">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.serviceFee"
                  placeholder="自动计算"
                  type="number"
                  @mousewheel.native.prevent
                  @change="getTotalFreight()"
                  ref="k70"
                  @keyup.enter.native="
                    enterFns(financeInInfo.serviceFee, 'k70')
                  "
                ></el-input>
                <el-button
                  style="color: #889eff"
                  class="jsBtns"
                  @click="AddServiceFee"
                  >明细</el-button
                >
                <el-button class="jsBtns glo_bgcMainColor" @click="getService()"
                  >计算</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              label="运费合计:"
              prop="totalFreight"
              :required="!baseEdit"
            >
              <div class="disFlexs jsInput">
                <el-input
                  :disabled="disabledSee || baseEdit"
                  v-model="financeInInfo.totalFreight"
                  placeholder="请输入"
                  clearable
                  type="number"
                  ref="k71"
                  @keyup.enter.native="
                    enterFns(financeInInfo.totalFreight, 'k71')
                  "
                ></el-input>
                <el-button
                  class="jsBtns glo_bgcMainColor"
                  @click="getTotalFreight()"
                  >计算</el-button
                >
              </div>
            </el-form-item>
            <el-form-item
              :required="!baseEdit"
              label="结算方式:"
              prop="settlementMethodConfDictId"
            >
              <el-select
                :disabled="disabledSee || baseEdit"
                filterable
                clearable
                v-model="financeInInfo.settlementMethodConfDictId"
                placeholder="请选择"
                @change="changeSettlementMethod(false, 'k72')"
                @keyup.enter.native="
                  enterFns(
                    financeInInfo.settlementMethodConfDictId,
                    'k72',
                    'select'
                  )
                "
                ref="k72"
              >
                <el-option
                  v-for="item in settlementMethods_1"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="现付金额:" prop="senderAmount">
              <el-input
                :disabled="disabledSee || baseEdit || senderAmountDisable"
                v-model="financeInInfo.senderAmount"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
                @keyup.enter.native="
                  enterFns(financeInInfo.senderAmount, 'k73', 'select')
                "
                ref="k73"
              ></el-input>
            </el-form-item>
            <el-form-item label="到付金额:" prop="receivedAmount">
              <el-input
                :disabled="disabledSee || baseEdit || receivedAmountDisable"
                v-model="financeInInfo.receivedAmount"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
                @keyup.enter.native="
                  enterFns(financeInInfo.receivedAmount, 'k74', 'select')
                "
                ref="k74"
              ></el-input>
            </el-form-item>
            <el-form-item label="月结金额:" prop="monthlyAmount">
              <el-input
                :disabled="disabledSee || baseEdit || monthlyAmountDisable"
                v-model="financeInInfo.monthlyAmount"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
                @keyup.enter.native="
                  enterFns(financeInInfo.monthlyAmount, 'k75', 'select')
                "
                ref="k75"
              ></el-input>
            </el-form-item>
            <el-form-item label="到付月结金额:" prop="receivedMonthlyAmount">
              <el-input
                :disabled="
                  disabledSee || baseEdit || receivedMonthlyAmountDisable
                "
                v-model="financeInInfo.receivedMonthlyAmount"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
                @keyup.enter.native="
                  enterFns(
                    financeInInfo.receivedMonthlyAmount,
                    'k755',
                    'select'
                  )
                "
                ref="k755"
              ></el-input>
            </el-form-item>
            <el-form-item label="回单付金额:" prop="rnorderAmount">
              <el-input
                :disabled="disabledSee || baseEdit || rnorderAmountDisable"
                v-model="financeInInfo.rnorderAmount"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
                @keyup.enter.native="
                  enterFns(financeInInfo.rnorderAmount, 'k76', 'select')
                "
                ref="k76"
              ></el-input>
            </el-form-item>
            <el-form-item label="贷款扣运费:" prop="goodsDeductedAmoun">
              <el-input
                :disabled="disabledSee || baseEdit || goodsDeductedAmounDisable"
                v-model="financeInInfo.goodsDeductedAmoun"
                placeholder="请输入"
                clearable
                type="number"
                @mousewheel.native.prevent
                @change="getTotalFreight()"
                @keyup.enter.native="
                  enterFns(financeInInfo.goodsDeductedAmoun, 'k77', 'select')
                "
                ref="k77"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="是否开票:"
              prop="isInvoice"
              :required="!baseEdit"
            >
              <el-switch
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.isInvoice"
                active-text="是"
                inactive-text="否"
                :active-value="1"
                :inactive-value="0"
                @keyup.enter.native="
                  enterFns(financeInInfo.isInvoice, 'k78', 'select')
                "
                ref="k78"
              ></el-switch>
            </el-form-item>
            <el-form-item label="到付月结客户:" prop="receivedCustomerId">
              <el-select
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.receivedCustomerId"
                placeholder="请选择"
                clearable
                filterable
                @change="changeReceivedCustomer($event, 'k79')"
                @keyup.enter.native="
                  enterFns(financeInInfo.receivedCustomerId, 'k79', 'select')
                "
                ref="k79"
              >
                <el-option
                  v-for="item in CustomerLists"
                  :key="item.customerId"
                  :label="item.customerName"
                  :value="item.customerId"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="代收货款账号:" prop="agentAccount">
              <el-input
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.agentAccount"
                placeholder="请输入"
                clearable
                
                @mousewheel.native.prevent
                @keyup.enter.native="
                  enterFns(financeInInfo.agentAccount, 'k94', 'select')
                "
                ref="k94"
              ></el-input>
            </el-form-item>
            <el-form-item label="代收货款账号名称:" prop="agentAccountName" label-width="120" class="long-parse">
              <el-input
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.agentAccountName"
                placeholder="请输入"
                clearable
                
                @mousewheel.native.prevent
                @keyup.enter.native="
                  enterFns(financeInInfo.agentAccountName, 'k95', 'select')
                "
                ref="k95"
              ></el-input>
            </el-form-item>
            <el-form-item label="代收款开户行:" prop="agentAccountAddress" label-width="120" class="long-parse">
              <el-input
                :disabled="disabledSee || baseEdit"
                v-model="financeInInfo.agentAccountAddress"
                placeholder="请输入"
                clearable
                @mousewheel.native.prevent
                @keyup.enter.native="
                  enterFns(financeInInfo.agentAccountAddress, 'k96', 'select')
                "
                ref="k96"
              ></el-input>
            </el-form-item>
            <el-form-item
              class="textArea"
              style="width: 100%; margin-right: 0"
              label="财务备注:"
              prop="financeRemarks"
            >
              <el-input
                :disabled="disabledSee || baseEdit"
                type="textarea"
                placeholder="请输入"
                rows="2"
                v-model="financeInInfo.financeRemarks"
                @keyup.enter.native="
                  enterFns(financeInInfo.financeRemarks, 'k80', 'textarea')
                "
                ref="k80"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <!-- 其他收入 -->
      <div class="infoDiv" v-if="feeCheckIn">
        <div class="h3title">其他收入</div>
        <div class="formbox goodsItmes">
          <div style="width: 100%; margin-bottom: 10px">
            <el-button
              class="glo_bgcMainColor saveBtnsAddGG"
              @click="addOtherShouRu"
              v-if="feeCheckIn || !waybillSplitId"
              >添加其他收入</el-button
            >
            <!-- <el-button
              class="saveBtnsAddGG"
              @click="updateWaybillFinanceInService"
              v-if="feeCheckIn || !waybillSplitId"
              >保存应收费项</el-button
            > -->
          </div>
          <div class="glo_Table goodsTable">
            <!-- 货物表格 -->
            <el-table
              :data="financeOtherInfos_2"
              border
              ref="feesPayableTable"
              show-summary
              :summary-method="getFeesPaySummaries"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="itemCategoryName"
                label="费项类型"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.itemCategoryName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="itemServiceName"
                label="费项"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.itemServiceName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="amount"
                label="金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.amount }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                show-overflow-tooltip
                align="center"
                prop="urrency"
                label="币种"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.urrency }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="objectStatusTypeName"
                label="结算对象类型"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.objectStatusTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="objectName"
                label="结算对象"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.objectName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="paymentMethod"
                label="付款方式"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.paymentMethod }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="financeNumber"
                label="财务收支单号"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.financeNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="remarks"
                label="备注"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remarks }}</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="140"
                v-if="feeCheckIn || !waybillSplitId"
              >
                <template slot-scope="scope">
                  <div class="iconList">
                    <el-button
                      class="tbBtns"
                      @click="editShouRu(scope.row, scope.$index)"
                      >编辑</el-button
                    >

                    <el-popconfirm
                      title="确定删除该行费项信息吗"
                      @confirm="delShouRu(scope.row, scope.$index)"
                    >
                      <el-button slot="reference" class="tbBtns"
                        >删除</el-button
                      >
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 应付费用 -->
      <div class="infoDiv">
        <div class="h3title">应付费用</div>
        <div class="formbox goodsItmes">
          <div style="width: 100%; margin-bottom: 10px">
            <el-button
              class="glo_bgcMainColor saveBtnsAddGG"
              @click="addYinFu"
              v-if="feeCheckIn || !waybillSplitId"
              ref="k92"
              >添加应付</el-button
            >
            <!-- <el-button
              class="saveBtnsAddGG"
              @click="updateWaybillFinanceOut"
              v-if="feeCheckIn || !waybillSplitId"
              >保存应付费项</el-button
            > -->
          </div>
          <div class="glo_Table goodsTable">
            <!-- 货物表格 -->
            <el-table
              :data="financeOutInfos_2"
              border
              ref="feesPayableTable"
              show-summary
              :summary-method="getFeesPaySummaries"
            >
              <el-table-column
                fixed="left"
                align="center"
                label="序号"
                type="index"
                width="60"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="itemCategoryName"
                label="费项类型"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.itemCategoryName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="itemServiceName"
                label="费项"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.itemServiceName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="amount"
                label="金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.amount }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column
                show-overflow-tooltip
                align="center"
                prop="urrency"
                label="币种"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.urrency }}</span>
                </template>
              </el-table-column> -->
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="objectStatusTypeName"
                label="结算对象类型"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.objectStatusTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="objectName"
                label="结算对象"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.objectName }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="paymentMethod"
                label="付款方式"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.paymentMethod }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="financeNumber"
                label="财务收支单号"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.financeNumber }}</span>
                </template>
              </el-table-column>
              <el-table-column
                show-overflow-tooltip
                align="center"
                prop="remarks"
                label="备注"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remarks }}</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="140"
                v-if="feeCheckIn || !waybillSplitId"
              >
                <template slot-scope="scope">
                  <div class="iconList">
                    <el-button
                      class="tbBtns"
                      @click="editFeiXian(scope.row, scope.$index)"
                      >编辑</el-button
                    >

                    <el-popconfirm
                      title="确定删除该行费项信息吗"
                      @confirm="delFeiXian(scope.row, scope.$index)"
                    >
                      <el-button slot="reference" class="tbBtns"
                        >删除</el-button
                      >
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 其他信息 -->
      <div class="infoDiv" style="border-bottom: 1px solid #f59a23">
        <div class="h3title">其他信息</div>
        <div class="formbox">
          <el-form
            label-width="100px"
            class="head_formBox glo_formBox"
            ref="form6"
          >
            <el-form-item label="业务员:" prop="businessId">
              <el-select
                filterable
                clearable
                v-model="otherInfo.businessId"
                placeholder="请选择"
                @change="changeBusinessMan($event, 'k81')"
                :disabled="disabledSee || feeCheckIn"
                @keyup.enter.native="
                  enterFns(otherInfo.businessId, 'k81', 'select')
                "
                ref="k81"
              >
                <el-option
                  v-for="emp in emps"
                  :key="emp.employeeId"
                  :label="emp.employeeName"
                  :value="emp.employeeId"
                >
                  <span style="float: left">{{ emp.jobNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    emp.employeeName
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务员提成:" prop="businessCostRate">
              <div class="glo_disFlex" style="padding-right: 3px">
                <el-input
                  :disabled="disabledSee || feeCheckIn"
                  v-model="otherInfo.businessCostRate"
                  placeholder="请输入"
                  clearable
                  type="number"
                  @mousewheel.native.prevent
                  @keyup.enter.native="
                    enterFns(otherInfo.businessCostRate, 'k82', 'select')
                  "
                  ref="k82"
                ></el-input>
                %
              </div>
            </el-form-item>
            <el-form-item label="跟单员:" prop="merchandiserEmployeeId">
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="otherInfo.merchandiserEmployeeId"
                placeholder="请选择"
                @change="changeMerchandiserEmployee($event, 'k83')"
                @keyup.enter.native="
                  enterFns(otherInfo.merchandiserEmployeeId, 'k83', 'select')
                "
                ref="k83"
              >
                <el-option
                  v-for="emp in emps"
                  :key="emp.employeeId"
                  :label="emp.employeeName"
                  :value="emp.employeeId"
                >
                  <span style="float: left">{{ emp.jobNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    emp.employeeName
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="装卸员:" prop="handlingEmployeeId">
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="otherInfo.handlingEmployeeId"
                placeholder="请选择"
                @change="changeHandlingEmployee($event, 'k84')"
                @keyup.enter.native="
                  enterFns(otherInfo.handlingEmployeeId, 'k84', 'select')
                "
                ref="k84"
              >
                <el-option
                  v-for="emp in emps"
                  :key="emp.employeeId"
                  :label="emp.jobNumber"
                  :value="emp.employeeId"
                >
                  <span style="float: left">{{ emp.jobNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    emp.employeeName
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="结算员:" prop="personInChargeId">
              <el-select
                :disabled="disabledSee || feeCheckIn"
                filterable
                clearable
                v-model="otherInfo.personInChargeId"
                placeholder="请选择"
                @change="changeHandlingEmployee($event, 'k93')"
                @keyup.enter.native="
                  enterFns(otherInfo.personInChargeId, 'k93', 'select')
                "
                ref="k93"
              >
                <el-option
                  v-for="emp in emps"
                  :key="emp.employeeId"
                  :label="emp.jobNumber"
                  :value="emp.employeeId"
                >
                  <span style="float: left">{{ emp.jobNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    emp.employeeName
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="录单员:" prop="aaa">
              <!-- :disabled="disabledSee || feeCheckIn" -->
              <el-input
                disabled
                v-model="financeInInfo.aaa"
                placeholder="保存自动记录账号"
                readonly
                @mousewheel.native.prevent
              ></el-input>
            </el-form-item>
            <el-form-item label="录单时间:" prop="bbb">
              <el-input
                disabled
                v-model="financeInInfo.bbb"
                placeholder="保存自动记录"
                readonly
                @mousewheel.native.prevent
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <myDialog
      :diaWidth="diaWidth1"
      :dialogTitle="dialogTitle1"
      :isShowDialog="isShowDialog1"
      :showCacel="false"
      @handleCloseDia="handleCloseDia1"
      @diaCancelBtn="handleCloseDia1"
      @diaConfirmBtn="diaConfirmBtn1"
    >
      <div class="glo_dialogForm">
        <el-table :data="specifications_1" border style="width: 100%">
          <el-table-column label="*长" prop="length">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].length"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee || feeCheckIn"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*宽" prop="wide">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].wide"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee || feeCheckIn"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*高" prop="height">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].height"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee || feeCheckIn"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="*件数" prop="packageCout">
            <template slot-scope="scope">
              <el-input
                v-model="specifications_1[scope.$index].packageCout"
                @input="onInput(scope.$index)"
                type="number"
                placeholder="请输入"
                clearable
                :disabled="disabledSee || feeCheckIn"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            v-if="!disabledSee && !feeCheckIn"
          >
            <template slot-scope="scope">
              <div class="iconList">
                <i
                  v-if="specifications_1.length == scope.$index + 1"
                  class="el-icon-circle-plus iconSize"
                  @click="clickAdd"
                ></i>
                <el-popconfirm
                  v-if="specifications_1.length > 1"
                  title="确定删除该行规格吗"
                  @confirm="clickDel(scope.$index)"
                >
                  <i slot="reference" class="el-icon-remove iconSize"></i>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </myDialog>
    <!-- 弹窗 添加应收其他费用 -->
    <myDialog
      diaWidth="900px"
      dialogTitle="其他费用"
      :isShowDialog="isShowDialog6"
      @handleCloseDia="handleCloseYingShou"
      @diaCancelBtn="handleCloseYingShou"
      @diaConfirmBtn="handleConfirmYingShouu"
    >
      <div
        class="glo_dialogForm"
        style="display: flex; flex-flow: column; overflow: hidden"
      >
        <el-form
          class="diaForm"
          ref="dialogForm6Ref"
          :model="dialogForm6"
          label-width="100px"
        >
          <div
            style="
              display: flex;
              width: 100%;
              align-item: center;
              justify-content: space-between;
            "
          >
            <!-- <el-form-item
              class="dialogFormItems"
              prop="itemCategoryId"
              label="费项与金额:"
              style="flex: 1; margin-bottom: 0px"
            >
              <div class="multipleSelect item-category-container">
                <el-select
                  filterable
                  clearable
                  v-model="dialogForm6.itemCategoryId"
                  placeholder="请选择费项类型"
                  @change="changeItemCategoryIdYF6"
                >
                  <el-option
                    v-for="(item, index) in categoryNameList"
                    :key="index"
                    :label="item.categoryName"
                    :value="item.categoryId"
                  ></el-option>
                </el-select>
                <el-select
                  allow-create
                  filterable
                  clearable
                  v-model="dialogForm6.itemServiceId"
                  placeholder="请选择费项"
                  @change="changeItemServiceId6"
                >
                  <el-option
                    v-for="(item, index) in CategoryServiceList"
                    :key="index"
                    :label="item.title"
                    :value="item.itemServiceId"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="dialogForm6.amount"
                  type="number"
                  placeholder="请输入金额"
                ></el-input>
              </div>
            </el-form-item> -->
            <el-button
              class="glo_bgcMainColor"
              style="margin-bottom: 0px"
              @click="addOtherFeeInfo"
              >添加费项</el-button
            >
          </div>
        </el-form>
        <div style="flex: 1">
          <el-table :data="otherFeeInfos_1" height="400">
            <el-table-column
              label="序号"
              prop="index"
              type="index"
            ></el-table-column>
            <el-table-column label="费项类型" prop="itemCategoryName">
              <template #default="scope">
                <el-select
                  filterable
                  clearable
                  v-model="scope.row.itemCategoryId"
                  placeholder="请选择费项类型"
                  @change="changeItemCategory(scope.row, scope.$index)"
                >
                  <el-option
                    v-for="(item, index) in categoryNameList"
                    :key="index"
                    :label="item.categoryName"
                    :value="item.categoryId"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="费项" prop="itemServiceName">
              <template #default="scope">
                <el-select
                  allow-create
                  filterable
                  clearable
                  v-model="scope.row.itemServiceId"
                  placeholder="请选择费项"
                  @change="changeItemService(scope.row, scope.$index)"
                >
                  <el-option
                    v-for="(item, index) in scope.row.CategoryServiceList"
                    :key="index"
                    :label="item.title"
                    :value="item.itemServiceId"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="金额" prop="amount">
              <template #default="{ row }">
                <el-input
                  v-model="row.amount"
                  type="number"
                  placeholder="请输入金额"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template #default="{ row }">
                <!-- <el-button plain type="text" @click="changeOtherFeeInfo(row)"
                  >编辑</el-button
                > -->
                <el-button plain type="text" @click="delOtherFeeInfo(row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>
    <!-- 弹窗 服务费用 -->
    <myDialog
      diaWidth="900px"
      dialogTitle="服务费"
      :isShowDialog="isShowDialog7"
      @handleCloseDia="handleCloseService"
      @diaCancelBtn="handleCloseService"
      @diaConfirmBtn="handleCloseService"
    >
      <div
        class="glo_dialogForm"
        style="display: flex; flex-flow: column; overflow: hidden"
      >
        <el-table :data="serviceFees" height="100%" show-summary>
          <el-table-column
            label="序号"
            prop="index"
            type="index"
          ></el-table-column>
          <el-table-column label="费项类型" prop="itemCategoryName">
          </el-table-column>
          <el-table-column label="费项" prop="itemServiceName">
          </el-table-column>
          <el-table-column label="金额" prop="amount"> </el-table-column>
        </el-table>
      </div>
    </myDialog>
    <!-- 弹窗 添加应付 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog2"
      @handleCloseDia="handleCloseDia2"
      @diaCancelBtn="handleCloseDia2"
      @diaConfirmBtn="diaConfirmBtn2('dialogForm2Ref')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm2Ref"
          v-if="isShowDialog2"
          :model="dialogForm2"
          label-width="100px"
        >
          <el-form-item
            style="width: 500px"
            class="dialogFormItems"
            prop="objectStatusType"
            label="结算对象:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectStatusConfDictId"
                placeholder="请选择"
                @change="changeObjestStatus"
              >
                <el-option
                  v-for="item in objectStatusList"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectName"
                placeholder="请选择"
                :allow-create="dialogForm2.objectStatusType == 'other'"
                remote
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            style="width: 100px"
            class="dialogFormItems"
            prop="paymentMethodConfDictId"
            label="付款方式:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm2.paymentMethodConfDictId"
              placeholder="请选择"
              @change="changePayMent"
            >
              <el-option
                v-for="item in settlementMethods"
                :key="item.id"
                :label="item.val"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="width: 100%">
            <el-form-item
              style="width: 300px"
              class="dialogFormItems"
              prop="preparerEmployeeId"
              label="垫付人:"
            >
              <el-select
                filterable
                clearable
                v-model="dialogForm2.preparerEmployeeId"
                placeholder="请选择"
              >
                <el-option
                  v-for="emp in emps"
                  :key="emp.employeeId"
                  :label="emp.employeeName"
                  :value="emp.employeeId"
                >
                  <span style="float: left">{{ emp.jobNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    emp.employeeName
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div
            style="display: flex; width: 95%"
            v-for="(financeOutInfo, index) in financeOutInfos_1"
            :key="index"
          >
            <el-form-item
              style="flex: 1"
              :style="index == 0 ? '' : 'margin-left:100px;'"
              class="dialogFormItems"
              prop="itemCategoryId"
              :label="index == 0 ? '费项与金额:' : ''"
              :label-width="index == 0 ? '100px' : '0px'"
            >
              <div class="multipleSelect item-category-container">
                <el-select
                  filterable
                  clearable
                  v-model="financeOutInfo.itemCategoryId"
                  placeholder="请选择费项类型"
                  @change="changeItemCategoryIdYS(financeOutInfo, index)"
                >
                  <el-option
                    v-for="(item, index) in categoryNameList"
                    :key="index"
                    :label="item.categoryName"
                    :value="item.categoryId"
                  ></el-option>
                </el-select>
                <el-select
                  allow-create
                  filterable
                  clearable
                  v-model="financeOutInfo.itemServiceId"
                  placeholder="请选择费项"
                  @change="changeItemServiceId2(financeOutInfo)"
                >
                  <el-option
                    v-for="(item, index) in financeOutInfo.CategoryServiceList"
                    :key="index"
                    :label="item.title"
                    :value="item.itemServiceId"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="financeOutInfo.amount"
                  type="number"
                  @mousewheel.native.prevent
                  placeholder="请输入金额"
                ></el-input>
              </div>
            </el-form-item>
            <div
              class="iconList"
              style="
                margin-bottom: 22px;
                width: 80px;
                display: flex;
                justify-content: space-between;
              "
              v-show="dialogType2 === 'add'"
            >
              <el-popconfirm
                v-if="financeOutInfos_1.length > 1"
                title="确定删除该行费项信息吗"
                @confirm="delCategory(index)"
              >
                <i
                  slot="reference"
                  class="el-icon-remove iconSize"
                  style="margin-left: 10px"
                ></i>
              </el-popconfirm>
              <i
                v-if="index == financeOutInfos_1.length - 1"
                class="el-icon-circle-plus iconSize"
                @click="addCategory(index)"
              ></i>
            </div>
          </div>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm2.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片">
            <my-image-upload
              @input="changeFileList2"
              :fileNameLists="dialogForm2.files"
              :limit="9"
              :disabled="disabledSee && !feeCheckIn"
            ></my-image-upload>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 应收 -->
    <myDialog
      :diaWidth="diaWidth2"
      :dialogTitle="dialogTitle2"
      :isShowDialog="isShowDialog22"
      @handleCloseDia="handleCloseDia22"
      @diaCancelBtn="handleCloseDia22"
      @diaConfirmBtn="diaConfirmBtn22('dialogForm2Ref')"
    >
      <div class="glo_dialogForm">
        <el-form
          class="diaForm"
          ref="dialogForm2Ref"
          v-if="isShowDialog22"
          :model="dialogForm2"
          label-width="100px"
        >
          <el-form-item
            style="width: 500px"
            class="dialogFormItems"
            prop="objectStatusType"
            label="结算对象:"
          >
            <div class="multipleSelect">
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectStatusConfDictId"
                placeholder="请选择"
                @change="changeObjestStatus"
              >
                <el-option
                  v-for="item in objectStatusList"
                  :key="item.id"
                  :label="item.val"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select
                filterable
                clearable
                v-model="dialogForm2.objectName"
                placeholder="请选择"
                :allow-create="dialogForm2.objectStatusType == 'other'"
                remote
                :remote-method="getObjectUserDownListYf"
                @change="changeobjectName"
              >
                <el-option
                  v-for="(item, index) in CustomerListsYF"
                  :key="index"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            style="width: 100px"
            class="dialogFormItems"
            prop="paymentMethodConfDictId"
            label="付款方式:"
          >
            <el-select
              filterable
              clearable
              v-model="dialogForm2.paymentMethodConfDictId"
              placeholder="请选择"
              @change="changePayMent"
            >
              <el-option
                v-for="item in settlementMethods"
                :key="item.id"
                :label="item.val"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <div style="width: 100%">
            <el-form-item
              style="width: 300px"
              class="dialogFormItems"
              prop="preparerEmployeeId"
              label="垫付人:"
            >
              <el-select
                filterable
                clearable
                v-model="dialogForm2.preparerEmployeeId"
                placeholder="请选择"
              >
                <el-option
                  v-for="emp in emps"
                  :key="emp.employeeId"
                  :label="emp.employeeName"
                  :value="emp.employeeId"
                >
                  <span style="float: left">{{ emp.jobNumber }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{
                    emp.employeeName
                  }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div
            style="display: flex; width: 95%"
            v-for="(financeOutInfo, index) in financeOtherInfos_1"
            :key="index"
          >
            <el-form-item
              style="flex: 1"
              :style="index == 0 ? '' : 'margin-left:100px;'"
              class="dialogFormItems"
              prop="itemCategoryId"
              :label="index == 0 ? '费项与金额:' : ''"
              :label-width="index == 0 ? '100px' : '0px'"
            >
              <div class="multipleSelect item-category-container">
                <el-select
                  filterable
                  clearable
                  v-model="financeOutInfo.itemCategoryId"
                  placeholder="请选择费项类型"
                  @change="changeItemCategoryIdYF(financeOutInfo, index)"
                >
                  <el-option
                    v-for="(item, index) in categoryNameList"
                    :key="index"
                    :label="item.categoryName"
                    :value="item.categoryId"
                  ></el-option>
                </el-select>
                <el-select
                  allow-create
                  filterable
                  clearable
                  v-model="financeOutInfo.itemServiceId"
                  placeholder="请选择费项"
                  @change="changeItemServiceId2(financeOutInfo)"
                >
                  <el-option
                    v-for="(item, index) in financeOutInfo.CategoryServiceList"
                    :key="index"
                    :label="item.title"
                    :value="item.itemServiceId"
                  ></el-option>
                </el-select>
                <el-input
                  v-model="financeOutInfo.amount"
                  type="number"
                  @mousewheel.native.prevent
                  placeholder="请输入金额"
                ></el-input>
              </div>
            </el-form-item>
            <div
              class="iconList"
              style="
                margin-bottom: 22px;
                width: 80px;
                display: flex;
                justify-content: space-between;
              "
              v-show="dialogType2 === 'add'"
            >
              <el-popconfirm
                v-if="financeOtherInfos_1.length > 1"
                title="确定删除该行费项信息吗"
                @confirm="delCategory22(index)"
              >
                <i
                  slot="reference"
                  class="el-icon-remove iconSize"
                  style="margin-left: 10px"
                ></i>
              </el-popconfirm>
              <i
                v-if="index == financeOtherInfos_1.length - 1"
                class="el-icon-circle-plus iconSize"
                @click="addCategory22(index)"
              ></i>
            </div>
          </div>
          <el-form-item class="dislogFormTextarea" prop="remarks" label="备注:">
            <el-input
              type="textarea"
              rows="2"
              v-model="dialogForm2.remarks"
            ></el-input>
          </el-form-item>
          <el-form-item label="图片">
            <my-image-upload
              @input="changeFileList2"
              :fileNameLists="dialogForm2.files"
              :limit="9"
              :disabled="disabledSee && !feeCheckIn"
            ></my-image-upload>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 弹窗 收件人地址 -->
    <myDialog
      :diaWidth="diaWidth3"
      :dialogTitle="dialogTitle3"
      :isShowDialog="isShowDialog3"
      :showConfirm="false"
      @handleCloseDia="handleCloseDia3"
      @diaCancelBtn="handleCloseDia3"
      @diaConfirmBtn="diaConfirmBtn3"
    >
      <div class="glo_dialogForm" ref="myDialogRef_as">
        <!-- 查询条件 -->
        <div ref="queryForm">
          <el-form
            v-if="isShowDialog3"
            :model="queryData"
            class="glo_form"
            label-position="left"
          >
            <el-form-item class="queryItems" label="联系人:">
              <el-input
                clearable
                v-model="queryData.personnelName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="联系电话:">
              <el-input
                clearable
                v-model="queryData.phone"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-form-item class="queryItems" label="单位/仓库:">
              <el-input
                clearable
                v-model="queryData.deptName"
                placeholder="请输入"
                @keyup.enter.native="getCustomerAddrList()"
              ></el-input>
            </el-form-item>
            <el-button
              class="glo_btnItems glo_bgcMainColor"
              @click="getCustomerAddrList"
              >查询</el-button
            >
          </el-form>
        </div>
        <div class="glo_Table" style="height: 300px; display: flex">
          <el-table
            height="100%"
            header-align="center"
            ref="mytable"
            @row-click="rowclick"
            :data="tableData"
            border
            stripe
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column label="操作" min-width="100px">
              <template slot-scope="scope">
                <div class="tabRightBtns">
                  <el-button
                    class="rbtns"
                    @click.stop="changeAddress(scope.row)"
                    >选择</el-button
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>
            <template v-for="(item, index) in addressTableHeard">
              <el-table-column
                :key="index"
                :label="item.name"
                :prop="item.field"
                align="center"
                sortable
                :show-overflow-tooltip="true"
                :min-width="item.width"
                :data-isTotal="item.isTotal"
                v-if="item && item.isShow"
              ></el-table-column>
            </template>
          </el-table>
        </div>
        <!-- 分页 -->
        <paging
          :pageNum="pageStart_as"
          :total="pageCount_as"
          :size="pageTotal_as"
          @handleSizeChange="handleSizeChange_as"
          @handleCurrentChange="handleCurrentChange_as"
        ></paging>
      </div>
    </myDialog>
    <myDialog
      diaWidth="40%"
      dialogTitle="地址识别"
      :isShowDialog="isShowDialogAI"
      :showConfirm="true"
      @handleCloseDia="handleCloseDiaAI"
      @diaCancelBtn="handleCloseDiaAI"
      @diaConfirmBtn="diaConfirmBtnAI"
    >
      <el-card
        shadow="never"
        style="margin-top: 5px; margin-bottom: 5px; border: none"
        body-style="padding:0;"
      >
        <el-input
          type="textarea"
          class="address-ai-input"
          ref="addressAIInput"
          rows="6"
          v-model="addressAI.addressBefore"
        ></el-input>
        <div class="address-ai-button-container">
          <el-button type="primary" size="mini" @click="clearAddressAIText"
            >清空</el-button
          >
          <el-button type="primary" size="mini" @click="analysisAddress"
            >识别</el-button
          >
        </div>
      </el-card>
      <el-card
        shadow="never"
        style="border: 1px solid #cccccc"
        body-style="padding:8px;"
      >
        <el-form
          label-position="left"
          label-width="90px"
          class="address-ai-form"
        >
          <el-form-item label="姓名：">
            {{ addressAI.username }}
          </el-form-item>
          <el-form-item label="电话：">
            {{ addressAI.phone }}
          </el-form-item>
          <el-form-item label="省市区：">
            {{ addressAI.province }}-{{ addressAI.city }}-{{ addressAI.area }}
          </el-form-item>
          <el-form-item label="详细地址：">
            {{ addressAI.address }}
          </el-form-item>
        </el-form>
      </el-card>
    </myDialog>
    <myDialog
      diaWidth="1100px"
      dialogTitle="选择地址"
      :isShowDialog="isShowDialogMap"
      :dialogFooter="false"
      @handleCloseDia="handleCloseDiaMap"
      @diaCancelBtn="handleCloseDiaMap"
      @diaConfirmBtn="diaConfirmBtnMap"
      class="amp-map-dialog"
    >
      <AMPMAP @choose-it="chooseAddress" v-if="isShowDialogMap"></AMPMAP>
    </myDialog>
    <my-print
      :classNameArr="classNameArr"
      :modelClassName.sync="modelClassName"
      :getApiType.sync="getApiType"
      modelTypeVal="运单打印模板"
      ref="myPrint"
      :dataSource="printDataSource"
    ></my-print>

    <!-- 回车顺序设置 -->
    <myDialog
      :diaWidth="diaWidth_enter"
      :dialogTitle="dialogTitle_enter"
      :isShowDialog="isShowDialog_enter"
      @handleCloseDia="handleCloseDia_enter"
      @diaCancelBtn="handleCloseDia_enter"
      @diaConfirmBtn="diaConfirmBtn_enter()"
    >
      <div class="tranfserTb glo_Table">
        <!-- 左边 -->
        <div class="tranfser_item">
          <div class="tranfser_tit">页面所有输入框字段</div>
          <el-table
            ref="tableLeft"
            :data="tableDataLeft"
            border
            :height="tfHeight"
            @row-click="handleRowClick"
            @selection-change="handleSelectionChangeLeft"
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            ></el-table-column>
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="group" label="功能模板"> </el-table-column>
            <el-table-column prop="label" label="操作框"> </el-table-column>
          </el-table>
        </div>
        <div class="tranfser_center" :style="'height:' + tfHeight">
          <el-button class="glo_bgcMainColor btnA" @click="toRight"
            >选定并右移 ></el-button
          >
        </div>
        <!-- 右边 -->
        <div class="tranfser_item">
          <div class="tfRTop">
            <div class="tranfser_tit">需要回车控制的输入框字段</div>
            <el-button class="btnB" @click="HFMRFn">恢复默认 </el-button>
            <el-button class="btnB" @click="delRight">清空 </el-button>
          </div>

          <div :style="'height:' + tfHeight" class="draggableClass">
            <div class="daraStyle_1 daraStyle_H">
              <div class="daraNum_1">回车顺序</div>
              <div class="cloWidth_1">功能模板</div>
              <div class="cloWidth_1">操作框</div>
              <div class="icon_del">操作</div>
            </div>
            <!-- 可拖拽区域 -->
            <draggable v-model="tableDataRight">
              <transition-group>
                <div
                  class="daraStyle_1"
                  v-for="(element, index) in tableDataRight"
                  :key="element.FileKey"
                >
                  <div class="daraNum_1">{{ index + 1 }}</div>
                  <div class="cloWidth_1">{{ element.group }}</div>
                  <div class="cloWidth_1">{{ element.label }}</div>
                  <div class="icon_del" @click="delRows(index)">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>
      </div>
    </myDialog>

    <!-- 客户报价列表 -->
    <my-dialog
      diaWidth="800px"
      dialogTitle="报价维护"
      :isShowDialog="isShowDialog8"
      @handleCloseDia="handleCloseDia8"
      @diaCancelBtn="handleCloseDia8"
      @diaConfirmBtn="diaConfirmBtn8('dialogFormRef')"
    >
      <!-- 表格 -->
      <div class="glo_Table">
        <el-table
          header-align="center"
          ref="mytable"
          @row-click="rowclick"
          :data="tableDataBJ"
          border
          stripe
          :highlight-current-row="true"
          show-summary
          :summary-method="getSummaries"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            fixed="left"
            align="center"
            label="序号"
            type="index"
            width="60"
          ></el-table-column>
          <el-table-column
            fixed="left"
            align="center"
            type="selection"
            width="60"
          ></el-table-column>
          <template v-for="(item, index) in myTableHeard">
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-if="item && item.isShow"
            ></el-table-column>
          </template>
          <el-table-column fixed="right" label="操作" min-width="100px">
            <template slot-scope="scope">
              <div class="tabRightBtns">
                <el-button class="rbtns" @click.stop="BJEdit(scope.row)"
                  >查看详情</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </my-dialog>

    <!-- 报价维护 -->
    <my-dialog
      diaWidth="800px"
      :dialogTitle="dialogTitle9"
      :isShowDialog="isShowDialog9"
      :showConfirm="false"
      @handleCloseDia="isShowDialog9 = false"
      @diaCancelBtn="isShowDialog9 = false"
      @diaConfirmBtn="isShowDialog9 = false"
    >
      <div class="offerContentDT" v-html="dialogFormBJ.offerContent"></div>
    </my-dialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
import MyImageUpload from "@/components/MyImageUpload.vue";
import paging from "@/components/pagings.vue"; //分页组件
import AddressParse from "address-parse";
import AMPMAP from "@/components/AMPMAP.vue";
import MyPrint from "@/components/print/MyPrint.vue";
import draggable from "vuedraggable";
import calculator from "@/assets/img/tmsIcon/Calculator.png";
export default {
  inject: ["reload"],
  components: {
    myDialog,
    paging,
    MyImageUpload,
    AMPMAP,
    MyPrint,
    draggable,
  },
  props: {
    commandIds: {
      type: String,
      require: false,
      default() {
        return "[]";
      },
    },
    waybillSplitId: {
      type: String,
      require: false,
      default() {
        return null;
      },
    },
    isSee: {},
    type: {
      type: String,
      require: false,
      default: "add",
    },
  },
  data() {
    return {
      dialogTitle9: "",
      isShowDialog9: false,
      isShowDialog8: false,
      dialogFormBJ: {
        offerContent: "",
      },
      myTableHeard: [
        {
          field: "channelName",
          name: "报价名称",
          isShow: 1,
          width: "150",
        },
        {
          field: "offerContent",
          name: "报价内容",
          isShow: 1,
          width: "150",
        },
        {
          field: "comment",
          name: "报价备注",
          isShow: 1,
          width: "150",
        },
      ],

      delArrsFInList: [], //已删除的应收
      delArrsFOutList: [], //已删除的应付

      calculator,
      tenantConfList: "",
      pageStart_as: 1, //  页码
      pageCount_as: 0, //  总条数
      pageTotal_as: this.$COMMON.pageTotals, //
      TBHeight_as: 500,
      saveKeys: "",
      //disabledSee: false,
      loadingDetail: false,
      volumeDivisor: "",
      baseInfo: {
        waybillSplitId: null,
        //	基础信息
        waybillNumber: "",
        transferNumber: "",
        customerOrderNumber: "",
        businessDate: this.$moment().format("YYYY-MM-DD"),
        destCity: "",
        transportLineId: null,
        endDeptId: null,
        receiveMethodConfDictId: null,
        transportMethodConfDictId: null,
        sendMethodConfDictId: null,
        rnRequireConfDictId: null,
        rnRequireName: "",
        rnRequireCount: null,
        commandToWaybillType: 0,
        commandId: null,
        commandIds: [],
        customerType: 1, //1==常客 0==散客
        isAddCustomer: 0, //1==收录 0==不收录
        isOutTake: 0, //1==外提 0==不外提
        customerId: null,
        customerName: null,
        remarks: null,
        businessDeptId: this.$TOOLS.getUserInfo().departmentId || "",
        customerPhone: null,
        customerContacts: null,
        driverOneName: null,
        receiveObjectName: null,
      },
      sendAddr: {
        addrId: null,
        serialNumber: 1,
        contacts: "",
        company: "",
        tel: "",
        idNumber: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
        operationType: "UNCHANGED",
      },
      sendAddrs: [
        {
          itemId: null,
          serialNumber: "1",
          goodsNumber: "",
          goodsName: "",
          itemCategoryCode: "",
          itemCategoryName: "",
          packageName: "",
          packageCout: null,
          grossWeight: null,
          netWeight: null,
          volumeWeight: null,
          weightVolume: null,
          billingWeight: null,
          volume: null,
          specs: null,
          volumeDivisor: null,
          heavyCargoConfDictId: null,
          operationType: "UNCHANGED",
          itemSpecss: [
            {
              specsId: null,
              packageCout: null,
              length: null,
              wide: null,
              height: null,
              operationType: "UNCHANGED",
            },
          ],
          CategoryList: [],
        },
      ],
      sendAddrs_1: [],
      receiveAddr: {
        addrId: null,
        serialNumber: "1",
        contacts: "",
        company: "",
        tel: "",
        idNumber: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
      },
      takeAddr: {
        addrId: null,
        serialNumber: "1",
        contacts: "",
        company: "",
        tel: "",
        idNumber: "",
        provinceName: "",
        cityName: "",
        areaName: "",
        address: "",
      },
      transportInfo: {
        takeTime: null,
        deliveryTime: null,
        isIntoStorage: 0,
        intoStorageNumber: null,
        markNumber: null,
        intoStorageName: null,
        receiveStorageNumber: null,
        specialRequireConfDictId: null,
        isUrgent: 0,
        isValuable: 0,
        isWaitNoticeSend: 0,
        declaredValue: null,
        declaredValueRate: null,
      },
      files: [
        {
          fileId: null,
          fileName: null,
        },
      ],
      otherInfo: {
        businessId: null,
        businessCostRate: null,
        merchandiserEmployeeId: null,
        merchandiserEmployeeName: null,
        handlingEmployeeId: null,
        personInChargeId: null,
        personChargeName: null,
      },
      financeInInfo: {
        waybillSplitId: null,
        formulaBillingWeightId: null,
        formulaBillingWeightName: null,
        unitPrice: null,
        basicFreight: null,
        takeFee: null,
        sendFee: null,
        transferFee: null,
        agentAmount: null,
        agentServiceRate: null,
        agentServiceFee: null,
        insuranceFee: null,
        allOtherFee: null,
        serviceFee: null,
        totalFreight: null,
        settlementMethodConfDictId: null,
        senderAmount: null,
        receivedAmount: null,
        monthlyAmount: null,
        receivedMonthlyAmount: null,
        rnorderAmount: null,
        goodsDeductedAmoun: null,
        isInvoice: 0,
        receivedCustomerId: null,
        financeRemarks: null,
        isInsure: 0,
        declaredValue: null,
        declaredValueRate: null,
        agentAccount: null,
        agentAccountName: null,
        agentAccountAddress: null,
        otherFeeInfos: [],
      },
      financeOtherInfos: [],
      financeOtherInfos_1: [
        {
          id: null,
          itemCategoryId: null,
          itemCategoryName: null,
          itemServiceId: null,
          itemServiceName: null,
          amount: null,
          remarks: null,
          inoutStatus: null,
          objectStatusConfDictId: null,
          objectNumber: null,
          objectName: null,
          paymentMethodConfDictId: null,
          paymentMethod: null,
          CategoryServiceList: [],
        },
      ],
      financeOtherInfos_2: [],
      financeOutInfos: [],
      financeOutInfos_1: [
        {
          id: null,
          itemCategoryId: null,
          itemCategoryName: null,
          itemServiceId: null,
          itemServiceName: null,
          amount: null,
          remarks: null,
          inoutStatus: null,
          objectStatusConfDictId: null,
          objectNumber: null,
          objectName: null,
          paymentMethodConfDictId: null,
          paymentMethod: null,
        },
      ],
      financeOutInfos_2: [],
      formulasBillingWeight: [],
      inoutStatusList: [
        {
          name: "收入",
          val: "shou_ru:deal_status",
        },
        {
          name: "支出",
          val: "zhi_chu:deal_status",
        },
      ],
      isPosting: 0,
      isAutoAddr_sj: true,
      isAutoAddr_jj: true,
      SuperiorRegionList: [], //省
      cityNameList: [], //市
      areaNameList: [], //区
      isAutoAddr_sj_1: false,
      cityNameList_1: [], //市
      areaNameList_1: [], //区

      cityNameList_2: [], //市
      areaNameList_2: [], //区

      sendPhoneLists: [], //
      SJPhoneLists: [], //
      CustomerLists: [], //客户列表
      addressNaemList: [], //客户档案列表
      OUTsendMethodList: [], //送货方式
      OUTTakeMethodList: [], //外发提货
      packageNameList: [], //货物信息
      car_type_list: [], //车型
      employeeList: [], // 开单接收人
      employeeList_1: [], //调度接收人
      storageList: [], //入仓仓库
      businessDepts: [],
      CarrierDeptListList: [], //网点
      changeCarrierList: [], //外发承运商

      // 目的城市
      destCitys: [],
      destCityLoading: false,
      //线路
      lines: [],
      transportLineLoading: false,
      // 发货方式
      receMethods: [],
      transportMethods: [],
      sendMethods: [],
      rnRequirements: [],
      settlementMethods: [],
      specialRequirements: [],
      baseInfoRemarksList: [],
      heavyCargos: [],
      // 弹窗===添加应付
      isShowDialog2: false,
      isShowDialog22: false,
      dialogTitle2: "",
      dialogType2: "",
      editYfIdx: 0,
      editYfRow: undefined,
      diaWidth2: "900px",
      dialogForm2: {
        // 弹窗表单数据
        amount: null,
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        objectName: null,
        objectNumber: null,
        objectStatusConfDictId: null,
        paymentMethodConfDictId: null,
        remarks: null,
        objectStatusType: null, //对象类型(我自己加的)
        paymentMethod: null, //付款方式名称(我自己加的)
        files: [],
        preparerEmployeeId: this.$TOOLS.getUserInfo().employeeId,
      },
      // 地址弹窗
      isShowDialog3: false,
      isShowDialogAI: false,
      isShowDialogMap: false,
      addressAI: {
        addressType: "",
        addressText: "",
      },
      addressMap: {
        addressType: "",
      },
      dialogTitle3: "",
      diaWidth3: "80%",
      tableData: [],
      tableDataBJ: [],
      addressTableHeard: [
        {
          name: "单位",
          field: "deptName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系人",
          field: "personnelName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "身份证号",
          field: "idNumber",
          width: "180",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "省份",
          field: "provinceName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "城市",
          field: "cityName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "区县",
          field: "areaName",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "详细地址",
          field: "address",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "备注",
          field: "remarks",
          width: "160",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      selectTableData: [], //收发地址 表格选择
      queryData: {
        //收发地址 查询条件
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      },

      //弹框 规格尺寸
      specIndex1: 0,
      isShowDialog1: false,
      dialogTitle1: "规格尺寸",
      diaWidth1: "60%",
      specifications: [
        {
          height: "",
          length: null,
          packageCout: null,
          wide: null,
          specsId: null,
          operationType: "UNCHANGED",
        },
      ], //规格尺寸 数据
      specifications_1: [],
      totalArr: [
        "packageCout",
        "grossWeight",
        "netWeight",
        "volume",
        "volumeWeight",
        "weightVolume",
        "billingWeight",
      ], //  表格需要合计的字段
      waybillStatus: "未审核",
      fileNameLists: [],
      rules1: {},
      emps: [],
      // 应付费用表格数据
      feesPayableTableTo: ["total"],
      commands: [],
      objectStatusList: [], //结算对象类型
      CustomerListsYF: [], //对象列表
      categoryNameList: [], //费项类型
      CategoryServiceList: [], //费项
      // 应收费项
      isShowDialog6: false,
      dialogTitle6: "新增应收",
      dialogForm6: {
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        remarks: null,
        amount: null,
      },
      otherFeeInfos: [],
      otherFeeInfos_1: [],
      isShowDialog7: false,
      serviceFees: [
        {
          itemCategoryName: "服务费",
          itemServiceName: "开单服务费",
          amount: 1,
          sort: 1,
        },
      ],
      serviceFees_1: this.serviceFees,
      senderAmountDisable: true,
      receivedAmountDisable: true,
      rnorderAmountDisable: true,
      monthlyAmountDisable: true,
      receivedMonthlyAmountDisable: true,
      goodsDeductedAmounDisable: true,
      rule1: {
        businessDate: [
          {
            required: true,
            message: "业务日期不能为空",
            trigger: "change",
          },
        ],
        businessDeptId: [
          {
            required: true,
            message: "开单网点不能为空",
            trigger: "change",
          },
        ],
      },
      // 基本信息校验规则
      rule2: {
        destCity: [
          {
            required: true,
            message: "目的城市不能为空",
            trigger: "change",
          },
        ],
        transportLineId: [
          {
            required: true,
            message: "线路不能为空",
            trigger: "change",
          },
        ],
        endDeptId: [
          {
            required: true,
            message: "终端网点不能为空",
            trigger: "change",
          },
        ],
        receiveMethodConfDictId: [
          {
            required: true,
            message: "发货方式不能为空",
            trigger: "change",
          },
        ],
        transportMethodConfDictId: [
          {
            required: true,
            message: "运输方式不能为空",
            trigger: "change",
          },
        ],
        sendMethodConfDictId: [
          {
            required: true,
            message: "交货方式不能为空",
            trigger: "change",
          },
        ],
        rnRequireCount: [
          {
            validator: (rule, value, callback) => {
              if (this.baseInfo.rnRequireConfDictId) {
                if (!value) {
                  callback(new Error("回单份数不能为空"));
                }
              }
              callback();
            },
            trigger: "chagne",
          },
        ],
      },
      rule4: {},
      rule5: {
        formulaBillingWeightId: [
          {
            required: true,
            message: "计费方式不能为空",
            trigger: "change",
          },
        ],
        serviceFee: [
          {
            required: true,
            message: "服务费不能为空",
            trigger: "change",
          },
        ],
        totalFreight: [
          {
            required: true,
            message: "运费合计不能为空",
            trigger: "change",
          },
        ],
        settlementMethodConfDictId: [
          {
            required: true,
            message: "结算方式不能为空",
            trigger: "change",
          },
        ],
        isInvoice: [
          {
            required: true,
            message: "是否开票不能为空",
            trigger: "change",
          },
        ],
        receivedCustomerId: [
          {
            validator: (rule, value, callback) => {
              if (this.financeInInfo.settlementMethodConfDictId) {
                let val;
                this.settlementMethods.forEach((item) => {
                  if (
                    item.id == this.financeInInfo.settlementMethodConfDictId
                  ) {
                    val = item.key;
                  }
                });
                if (val === "dao_fu_yue_jie") {
                  if (!value) {
                    callback(new Error("到付月结客户不能为空"));
                  }
                }
              }
              callback();
            },
            trigger: "chagne",
          },
        ],
      },
      rule7: {
        customerName: [
          {
            validator: (rule, value, callback) => {
              if (this.baseInfo.customerType) {
                if (!value) {
                  callback(new Error("客户不能为空"));
                }
              }
              callback();
            },
            trigger: "chagne",
          },
        ],
      },
      rule8: {
        isInsure: [
          {
            required: true,
            message: "是否投保不能为空",
            trigger: "change",
          },
        ],
        declaredValue: [
          {
            validator: (rule, value, callback) => {
              if (this.financeInInfo.isInsure === 1) {
                if (!value) {
                  callback(new Error("必须填写声明价值"));
                }
              }
              callback();
            },
            trigger: "change",
          },
        ],
      },
      settlementMethods_1: this.settlementMethods || [],
      goodsList: [],
      classNameArr: [
        // {
        //   name: "全打",
        //   val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillQdPrintDataV5VO",
        // },
        // {
        //   name: "套打",
        //   val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillTdPrintDataV5VO",
        // },
        // {
        //   name: "标签打印",
        //   val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillBqPrintDataV5VO",
        // },
        {
          name: "套打",
          val: "print_tao_da_waybill_data",
        },
        {
          name: "全打",
          val: "print_quan_da_waybill_data",
        },
        {
          name: "标签打印",
          val: "print_waybill_table_data",
        },
        {
          name: "回扣打印",
          val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillHkPrintDataV5VO",
        },
        {
          name: "信封打印",
          val: "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillXfPrintDataV5VO",
        },
      ], // 默认的模板类型
      modelClassName:
        "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillTdPrintDataV5VO",
      getApiType: false,
      // 弹窗===回车设置
      isShowDialog_enter: false,
      dialogTitle_enter: "运单界面光标设置配置",
      diaWidth_enter: "90%",
      tfHeight: "60vh",
      tableDataLeft: [
        {
          group: "页头", //所在分组
          label: "运单号", //输入框标题
          field: "waybillNumber", //字段名
          FileKey: "k1", //唯一值
          opType: "",
          sort: 1, //排序
          isShow: true, //是否展示
        },
        {
          group: "页头",
          label: "中转单号",
          field: "transferNumber",
          FileKey: "k2",
          opType: "",
          sort: 2,
          isShow: true,
        },
        {
          group: "页头",
          label: "客户单号",
          field: "customerOrderNumber",
          FileKey: "k3",
          opType: "",
          sort: 3,
          isShow: true,
        },
        {
          group: "页头",
          label: "业务日期",
          field: "businessDate",
          FileKey: "k4",
          opType: "",
          sort: 4,
          isShow: true,
        },
        {
          group: "页头",
          label: "开单网点",
          field: "businessDeptId",
          FileKey: "k5",
          opType: "",
          sort: 5,
          isShow: true,
        },
        // 基础信息
        {
          group: "基础信息",
          label: "目的城市",
          field: "destCity",
          FileKey: "k6",
          opType: "",
          sort: 6,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "运输路线",
          field: "transportLineId",
          FileKey: "k7",
          opType: "",
          sort: 7,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "终端网点",
          field: "endDeptId",
          FileKey: "k8",
          opType: "",
          sort: 8,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "发货方式",
          field: "receiveMethodConfDictId",
          FileKey: "k9",
          opType: "",
          sort: 9,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "运输方式",
          field: "transportMethodConfDictId",
          FileKey: "k10",
          opType: "",
          sort: 10,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "交货方式",
          field: "sendMethodConfDictId",
          FileKey: "k11",
          opType: "",
          sort: 11,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "回单要求",
          field: "rnRequireConfDictId",
          FileKey: "k12",
          opType: "",
          sort: 12,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "回单要求份数",
          field: "rnRequireCount",
          FileKey: "k13",
          opType: "",
          sort: 13,
          isShow: true,
        },
        {
          group: "基础信息",
          label: "订单指令",
          field: "commandId",
          FileKey: "k14",
          opType: "",
          sort: 14,
          isShow: true,
        },

        {
          group: "基础信息",
          label: "是否外提",
          field: "isOutTake",
          FileKey: "k97",
          opType: "",
          sort: 14,
          isShow: true,
        },

        {
          group: "基础信息",
          label: "备注",
          field: "remarks",
          FileKey: "k15",
          opType: "",
          sort: 15,
          isShow: true,
        },
        // 收发信息
        {
          group: "收发信息",
          label: "开单客户",
          field: "sendAddr_customerId",
          FileKey: "k16",
          opType: "",
          sort: 1,
          isShow: true,
        },
        // {
        //   group: "收发信息",
        //   label: "是否收录客户档案",
        //   field: "sendAddr_isAddCustomer",
        //   FileKey: "k161",
        //   opType: "",
        //   sort: 1,
        //   isShow: true,
        // },
        // {
        //   group: "收发信息",
        //   label: "客户名称",
        //   field: "sendAddr_isAddCustomer",
        //   FileKey: "k162",
        //   opType: "",
        //   sort: 1,
        //   isShow: true,
        // },
        // {
        //   group: "收发信息",
        //   label: "客户联系人",
        //   field: "sendAddr_customerContacts",
        //   FileKey: "k163",
        //   opType: "",
        //   sort: 1,
        //   isShow: true,
        // },
        // {
        //   group: "收发信息",
        //   label: "客户手机号",
        //   field: "sendAddr_customerPhone",
        //   FileKey: "k164",
        //   opType: "",
        //   sort: 1,
        //   isShow: true,
        // },
        {
          group: "收发信息",
          label: "发货单位",
          field: "sendAddr_company",
          FileKey: "k18",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "发货人",
          field: "sendAddr_contacts",
          FileKey: "k17",
          opType: "",
          sort: 1,
          isShow: true,
        },

        {
          group: "收发信息",
          label: "发货人联系电话",
          field: "sendAddr_tel",
          FileKey: "k19",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "发货人身份证号码",
          field: "sendAddr_idNumber",
          FileKey: "k20",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "发货省份",
          field: "sendAddr_provinceName",
          FileKey: "k21",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "发货城市",
          field: "sendAddr_cityName",
          FileKey: "k22",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "发货区/县",
          field: "sendAddr_areaName",
          FileKey: "k23",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "发货详细地址",
          field: "sendAddr_address",
          FileKey: "k24",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "收货单位",
          field: "receiveAddr_company",
          FileKey: "k26",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "收货人",
          field: "receiveAddr_contacts",
          FileKey: "k25",
          opType: "",
          sort: 1,
          isShow: true,
        },

        {
          group: "收发信息",
          label: "收件人联系电话",
          field: "receiveAddr_tel",
          FileKey: "k27",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "收件人身份证号码",
          field: "receiveAddr_idNumber",
          FileKey: "k28",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "收件省份",
          field: "receiveAddr_provinceName",
          FileKey: "k29",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "收件城市",
          field: "receiveAddr_cityName",
          FileKey: "k30",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "收件区/县",
          field: "receiveAddr_areaName",
          FileKey: "k31",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "收件详细地址",
          field: "receiveAddr_address",
          FileKey: "k32",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "自提电话",
          field: "takeAddr_tel",
          FileKey: "k33",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "自提省份",
          field: "takeAddr_provinceName",
          FileKey: "k34",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "自提城市",
          field: "takeAddr_cityName",
          FileKey: "k35",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "自提区/县",
          field: "takeAddr_areaName",
          FileKey: "k36",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "收发信息",
          label: "自提详细地址",
          field: "takeAddr_address",
          FileKey: "k37",
          opType: "",
          sort: 1,
          isShow: true,
        },
        // 货物信息
        {
          group: "货物信息",
          label: "货物编号",
          field: "goods_goodsNumber",
          FileKey: "k38",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "货物信息",
          label: "品名",
          field: "goods_goodsName",
          FileKey: "k39",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "货物信息",
          label: "包装",
          field: "goods_packageName",
          FileKey: "k40",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "货物信息",
          label: "件数",
          field: "goods_packageCout",
          FileKey: "k41",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "货物信息",
          label: "毛重",
          field: "goods_grossWeight",
          FileKey: "k42",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "货物信息",
          label: "净重",
          field: "goods_netWeight",
          FileKey: "k43",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "货物信息",
          label: "体积",
          field: "goods_volume",
          FileKey: "k44",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "货物信息",
          label: "体积系数",
          field: "goods_volumeDivisor",
          FileKey: "k45",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "货物信息",
          label: "体积重量",
          field: "goods_volumeWeight",
          FileKey: "k46",
          opType: "",
          sort: 1,
          isShow: true,
        },
        // {
        //   group: "货物信息",
        //   label: "计费重量",
        //   field: "goods_billingWeight",
        //   FileKey: "k47",
        //   opType: "",
        //   sort: 1,
        //   isShow: true,
        // },
        {
          group: "货物信息",
          label: "规格",
          field: "goods_specs",
          FileKey: "k48",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "货物信息",
          label: "重/泡货",
          field: "goods_heavyCargoConfDictId",
          FileKey: "k49",
          opType: "",
          sort: 1,
          isShow: true,
        },
        // 运输要求
        {
          group: "运输要求",
          label: "预计提货时间",
          field: "transportInfo_takeTime",
          FileKey: "k50",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "运输要求",
          label: "预计送货时间",
          field: "transportInfo_deliveryTime",
          FileKey: "k51",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "运输要求",
          label: "是否入仓",
          field: "transportInfo_isIntoStorage",
          FileKey: "k52",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "运输要求",
          label: "入仓仓库",
          field: "transportInfo_intoStorageName",
          FileKey: "k531",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "运输要求",
          label: "入仓号",
          field: "transportInfo_intoStorageNumber",
          FileKey: "k53",
          opType: "",
          sort: 1,
          isShow: true,
        },

        {
          group: "运输要求",
          label: "唛头",
          field: "transportInfo_markNumber",
          FileKey: "k532",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "运输要求",
          label: "收货仓号",
          field: "transportInfo_receiveStorageNumber",
          FileKey: "k54",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "运输要求",
          label: "特殊要求",
          field: "transportInfo_specialRequire",
          FileKey: "k55",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "运输要求",
          label: "是否投保",
          field: "financeInInfo_isInsure",
          FileKey: "k56",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "运输要求",
          label: "声明价值",
          field: "financeInInfo_declaredValue",
          FileKey: "k57",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "运输要求",
          label: "保费税率",
          field: "financeInInfo_declaredValueRate",
          FileKey: "k58",
          opType: "",
          sort: 1,
          isShow: true,
        },
        // 财务应收
        {
          group: "财务应收",
          label: "计费方式",
          field: "financeInInfo_formulaBillingWeightId",
          FileKey: "k59",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "单价",
          field: "financeInInfo_unitPrice",
          FileKey: "k60",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "基本运费",
          field: "financeInInfo_basicFreight",
          FileKey: "k61",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "提货费",
          field: "financeInInfo_takeFee",
          FileKey: "k62",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "送货费",
          field: "financeInInfo_sendFee",
          FileKey: "k63",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "中转费",
          field: "financeInInfo_transferFee",
          FileKey: "k64",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "代收货款",
          field: "financeInInfo_agentAmount",
          FileKey: "k65",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "贷款手续费率",
          field: "financeInInfo_agentServiceRate",
          FileKey: "k66",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "贷款手续费",
          field: "financeInInfo_agentServiceFee",
          FileKey: "k67",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "保险费",
          field: "financeInInfo_insuranceFee",
          FileKey: "k68",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "其他费用",
          field: "financeInInfo_allOtherFee",
          FileKey: "k69",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "服务费",
          field: "financeInInfo_serviceFee",
          FileKey: "k70",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "运费合计",
          field: "financeInInfo_totalFreight",
          FileKey: "k71",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "结算方式",
          field: "financeInInfo_settlementMethodConfDictId",
          FileKey: "k72",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "现付金额",
          field: "financeInInfo_senderAmount",
          FileKey: "k73",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "到付金额",
          field: "financeInInfo_receivedAmount",
          FileKey: "k74",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "月结金额",
          field: "financeInInfo_monthlyAmount",
          FileKey: "k75",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "回单付金额",
          field: "financeInInfo_rnorderAmount",
          FileKey: "k76",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "贷款扣运费",
          field: "financeInInfo_goodsDeductedAmoun",
          FileKey: "k77",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "是否开票",
          field: "financeInInfo_isInvoice",
          FileKey: "k78",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "到付月结客户",
          field: "financeInInfo_receivedCustomerId",
          FileKey: "k79",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "代收货款账号",
          field: "financeInInfo_agentAccount",
          FileKey: "k94",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "代收货款账号名称",
          field: "financeInInfo_agentAccountName",
          FileKey: "k95",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "财务应收",
          label: "代收开户行地址",
          field: "financeInInfo_agentAccountAddress",
          FileKey: "k96",
          opType: "",
          sort: 1,
          isShow: true,
        },

        {
          group: "财务应收",
          label: "财务备注",
          field: "financeInInfo_financeRemarks",
          FileKey: "k80",
          opType: "",
          sort: 1,
          isShow: true,
        },
        // 其他信息
        {
          group: "其他信息",
          label: "业务员",
          field: "otherInfo_businessId",
          FileKey: "k81",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "其他信息",
          label: "业务员提成",
          field: "otherInfo_businessCostRate",
          FileKey: "k82",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "其他信息",
          label: "跟单员",
          field: "otherInfo_merchandiserEmployeeId",
          FileKey: "k83",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "其他信息",
          label: "装卸员",
          field: "otherInfo_handlingEmployeeId",
          FileKey: "k84",
          opType: "",
          sort: 1,
          isShow: true,
        },
        {
          group: "其他信息",
          label: "结算员",
          field: "otherInfo_personInChargeId",
          FileKey: "k93",
          opType: "",
          sort: 1,
          isShow: true,
        },
        // 按钮
        {
          group: "按钮",
          label: "保存",
          field: "btn_b1",
          FileKey: "k85",
          opType: "button",
          sort: 1,
          isShow: true,
        },
        {
          group: "按钮",
          label: "保存并套打",
          field: "btn_b2",
          FileKey: "k86",
          opType: "button",
          sort: 1,
          isShow: true,
        },
        {
          group: "按钮",
          label: "保存并全打",
          field: "btn_b3",
          FileKey: "k87",
          opType: "button",
          sort: 1,
          isShow: true,
        },
        {
          group: "按钮",
          label: "打印标签",
          field: "btn_b4",
          FileKey: "k88",
          opType: "button",
          sort: 1,
          isShow: true,
        },
        {
          group: "按钮",
          label: "打印回扣凭证",
          field: "btn_b5",
          FileKey: "k89",
          opType: "button",
          sort: 1,
          isShow: true,
        },
        {
          group: "按钮",
          label: "打印信封",
          field: "btn_b6",
          FileKey: "k90",
          opType: "button",
          sort: 1,
          isShow: true,
        },
        {
          group: "按钮",
          label: "保存并过账",
          field: "btn_b7",
          FileKey: "k91",
          opType: "button",
          sort: 1,
          isShow: true,
        },
        {
          group: "按钮",
          label: "添加应付",
          field: "btn_b8",
          FileKey: "k92",
          opType: "button",
          sort: 1,
          isShow: true,
        },
        // k93,k94,k95,k96 已用
      ],
      tableDataRight: [],
      selectTableDataLeft: [],
      pageEnterSortList: [], //设置好的排序
      pageEnterSortData: [], //接口返回的排序
      pageEnterSortMap: {},
      //初始化的排序
      initSortList: [],
      saveed:false,
      loading:false,
    };
  },
  watch: {
    serviceFees: {
      deep: true,
      immediate: true,
      handler(val) {
        this.getService();
      },
    },
  },
  created() {
    this.sendAddrs_1 = this.sendAddrs.filter(
      (item) => item.operationType != "DEL"
    );
    this.specifications_1 = this.specifications.filter(
      (item) => item.operationType != "DEL"
    );
  },
  computed: {
    editable() {
      return this.isSee != 1;
    },
    disabledSee() {
      return !this.editable;
    },
    feeCheckIn() {
      return this.type === "feeCheckIn";
    },
    baseEdit() {
      return this.type === "baseEdit";
    },
    waybillNumberEditable() {
      return this.type === "add";
    },
  },
  mounted() {
    // 根据字典类型获取字典值下拉列表
    this.getConfDictValDownList("package_name", "packageNameList"); //获取包装
    this.getConfDictValDownList(
      "receive_method",
      "receMethods",
      "receiveMethodConfDictId"
    );
    this.getConfDictValDownList(
      "transport_method",
      "transportMethods",
      "transportMethodConfDictId"
    );
    this.getConfDictValDownList(
      "send_method",
      "sendMethods",
      "sendMethodConfDictId"
    );
    this.getConfDictValDownList("rn_order_require", "rnRequirements");
    this.getConfDictValDownList("settlement_method", "settlementMethods");
    this.getConfDictValDownList("special_order_require", "specialRequirements");
    this.getConfDictValDownList("heavy_cargo", "heavyCargos");
    //发货方式

    // 获取接单网点
    this.getBusinessDepts();
    this.getDestCities();
    // 获取线路
    this.getTransportLine();

    // 城市信息
    this.getProvince();
    //this.getCityName();
    //this.getAreaName();
    // 这个不能注释，否则编辑找不到名称显示ID
    this.remoteMethodCustomer();
    this.getFormulasBillingWeight(true, "df");
    this.getCommands();
    // 员工
    this.getEmps();
    this.wtl_getItemList();
    this.getRemarkList();
    this.getServiceFeeGetMethod(); //代收货款手续费收取方式

    this.$nextTick(() => {
      this.$API
        .getUserCustomizedConfInfo({
          configType: "pageEnterSort",
        })
        .then((res) => {
          let datas = res.data.result?.configJson || "";

          if (datas) {
            let pageEnterSortData = JSON.parse(datas) || [];

            this.pageEnterSortData = pageEnterSortData || [];
            if (pageEnterSortData && pageEnterSortData.length > 0) {
              this.pageEnterSortList = pageEnterSortData;
              for (let i = 0; i < this.pageEnterSortList.length; i++) {
                const item = this.pageEnterSortList[i];
                item.next = this.pageEnterSortList[i + 1];
                this.pageEnterSortMap[item.FileKey] = item;
              }
              // if (this.baseInfo.customerType == 0) {
              //   this.hidePageEnterSortKey("k16");
              //   this.showPageEnterSortKey("k161");
              //   this.showPageEnterSortKey("k162");
              //   this.showPageEnterSortKey("k163");
              //   this.showPageEnterSortKey("k164");
              // } else {
              //   this.showPageEnterSortKey("k16");
              //   this.hidePageEnterSortKey("k161");
              //   this.hidePageEnterSortKey("k162");
              //   this.hidePageEnterSortKey("k163");
              //   this.hidePageEnterSortKey("k164");
              // }
            }

            let refval =
              this.pageEnterSortList.length > 0
                ? this.pageEnterSortList[0].FileKey
                : "k1";
            if (this.type === "edit") {
              refval = "k85";
            }
            // const firstOne = this.$refs[refval];
            // try {
            //   firstOne.focus();
            // } catch (err) {
            //   firstOne.$el.focus();
            // }
          }
        });
    });
  },
  activated() {
    console.log("this.waybillSplitId",this.waybillSplitId);
    console.log("this.baseInfo.waybillSplitId",this.baseInfo.waybillSplitId);
    if (
      this.waybillSplitId &&
      this.baseInfo.waybillSplitId !== this.waybillSplitId
    ) {
      console.log("进入详情",this.baseInfo.waybillSplitId);
      this.getWaybillDetail();
      return;
    }
    if (this.commandIds) {
      if (!this.baseInfo.commandIds || this.baseInfo.commandIds.length == 0) {
        const commandIds = JSON.parse(this.commandIds);
        if (commandIds.length > 0) {
          this.baseInfo.commandIds = commandIds;
          this.baseInfo.commandId = commandIds[0];
          this.transformWaybillFromCommands();
        }
      }
      return;
    }
  },
  destroyed() {},
  methods: {
    // 修改报价
    BJEdit(row) {
      let that = this;

      this.isShowDialog9 = true;
      this.dialogFormBJ.offerContent = row.offerContent;
      this.dialogTitle9 = row.channelName + "报价内容";
    },
    diaConfirmBtn8() {
      this.isShowDialog8 = false;
      this.dialogFormBJ = {
        offerContent: "",
      };
    },
    handleCloseDia8() {
      this.isShowDialog8 = false;
      this.dialogFormBJ = {
        offerContent: "",
      };
    },
    // 查看客户报价
    getCBJ() {
      // this.baseInfo.customerId

      let params = {
        conditionReqs: [
          {
            conditonKey: "customerId",
            conditonVal: this.baseInfo.customerId,
          },
        ],
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        number: "customer_channel_list_v5",
      };
      this.$API.runPageReport(params).then((res) => {
        if (res.data.status === "success") {
          let datas = res.data.result?.datas?.data || [];
          this.tableDataBJ = datas;
          if (this.tableDataBJ.length > 0) {
            this.isShowDialog8 = true;
          } else {
            this.$message.error("暂无客户报价").showClose = true;
          }
        } else {
        }
      });
    },
    // 修改保存应收
    updateWaybillFinanceInService() {
      // 运单财务应付信息
      if (this.financeOtherInfos_2.length == 0) {
        this.$message.error("请添加应付信息");
        return false;
      }
      let financeOtherInfos = JSON.parse(
        JSON.stringify(this.financeOtherInfos_2)
      );
      financeOtherInfos.forEach((item) => {
        delete item.objectStatusType;
        delete item.paymentMethod;
        item.amount = item.amount || 0;
      });
      financeOtherInfos = [...financeOtherInfos, ...this.delArrsFInList];
      let param = {
        financeOtherInfos: financeOtherInfos || [],
        financeOutInfos: [],
        waybillSplitId: this.waybillSplitId,
      };
      this.$API.updateWaybillFinanceInService(param).then((res) => {
        this.isShowDialog2 = false;
        this.$message.success(res.data.message || "操作成功").showClose = true;
        this.delArrsFInList = [];
        // 重新获取接口的应付数据
        //
        this.$API
          .runList({
            number: "admin_waybill_detail_finance_in_other_service_v5",
            waybillSplitId: this.waybillSplitId,
          })
          .then((resA) => {
            let listA = resA;
            listA.forEach((item) => {
              if (item.isExpense == 1) {
                item.operationType = "UNCHANGED";
              } else {
                item.operationType = "UPDATE";
              }
            });
            this.financeOtherInfos = listA;
            this.financeOtherInfos_2 = listA;
          });
      });
    },
    // 修改保存应付
    updateWaybillFinanceOut() {
      if (!this.waybillSplitId) {
        return false;
      }
      // 运单财务应付信息
      if (this.financeOutInfos_2.length == 0) {
        this.$message.error("请添加应付信息");
        return false;
      }
      let financeOutInfoReqs = JSON.parse(
        JSON.stringify(this.financeOutInfos_2)
      );

      financeOutInfoReqs.forEach((item) => {
        delete item.objectStatusType;
        delete item.paymentMethod;
        item.amount = item.amount || 0;
      });
      financeOutInfoReqs = [...financeOutInfoReqs, ...this.delArrsFOutList];
      let param = {
        financeOtherInfos: [],
        financeOutInfos: financeOutInfoReqs || [],
        waybillSplitId: this.waybillSplitId,
      };
      this.$API.updateWaybillFinanceOut(param).then((res) => {
        this.isShowDialog2 = false;
        this.$message.success(res.data.message || "操作成功").showClose = true;
        this.delArrsFOutList = [];
        // 重新获取接口的应付数据
        this.$API
          .runList({
            number: "admin_waybill_detail_finance_out_service_v5",
            waybillSplitId: this.waybillSplitId,
          })
          .then((resA) => {
            let listA = resA;
            listA.forEach((item) => {
              if (item.isExpense == 1) {
                item.operationType = "UNCHANGED";
              } else {
                item.operationType = "UPDATE";
              }
            });
            this.financeOutInfos = listA;
            this.financeOutInfos_2 = listA;
          });
      });
    },

    // ========================= 设置回车顺序弹窗 start =========================
    diaConfirmBtn_enter() {
      // if (this.tableDataRight.length == 0) {
      //   this.$message.error("请设置回车控制的字段").showClose = true;
      //   return false;
      // }
      let rightList = JSON.parse(JSON.stringify(this.tableDataRight)) || [];
      rightList.forEach((element, idx) => {
        element.sort = idx;
      });
      this.tableDataRight = rightList;
      // window.localStorage.setItem(
      //   "pageEnterSort",
      //   JSON.stringify(this.tableDataRight)
      // );
      this.$API
        .addUserCustomizedConf({
          configType: "pageEnterSort",
          configJson: JSON.stringify(this.tableDataRight),
        })
        .then((res) => {
          this.$message.success("设置成功,刷新页面后生效").showClose = true;
          this.handleCloseDia_enter();
        });
    },
    handleCloseDia_enter() {
      this.isShowDialog_enter = false;
    },
    // 点击设置按钮,弹窗
    setEnter() {
      this.isShowDialog_enter = true;

      let pageEnterSort = this.pageEnterSortData || [];
      if (pageEnterSort && pageEnterSort.length > 0) {
        this.pageEnterSortList = pageEnterSort;
        this.tableDataRight = this.pageEnterSortList;
      }
      if (this.pageEnterSortList.length == 0) {
        this.tableDataRight = this.initSortList;
      }
    },
    // 移除回车控制的字段
    delRows(idx) {
      this.$confirm("是否删除当前行?", "系统提示")
        .then((res) => {
          let listA = JSON.parse(JSON.stringify(this.tableDataRight)) || [];
          listA.splice(idx, 1);
          this.tableDataRight = listA;
        })
        .catch(() => {});
    },

    // 点击当前行选中数据
    handleRowClick(row, column, event) {
      // 清除所有选中项
      // this.$refs.tableLeft.clearSelection();
      // 选中当前行
      this.$refs.tableLeft.toggleRowSelection(row, true);
    },

    //
    handleSelectionChangeLeft(e) {
      this.selectTableDataLeft = e;
    },
    // 右移
    toRight() {
      // tableDataLeft
      // tableDataRight
      let listA = this.selectTableDataLeft || [];
      if (listA.length < 1) {
        this.$message.error("请选择左边表格的数据").showClose = true;
        return false;
      }
      let rigthList = JSON.parse(JSON.stringify(this.tableDataRight)) || [];
      let newList = [...rigthList];
      listA.forEach((item2) => {
        // 检查item2是否已存在于newList数组中
        const AA = rigthList.find(
          (itemA) => itemA["FileKey"] === item2["FileKey"]
        );
        if (!AA) {
          newList.push(item2);
        }
      });

      this.tableDataRight = newList;
      this.$message.success("添加成功,已自动过滤重复项").showClose = true;

      // 清除所有选中项
      this.$refs.tableLeft.clearSelection();
    },
    // 选择时间
    changeTimes(e, key, type) {
      this.enterFns("", key, type);
    },
    // 输入框回车  enterFnsA
    enterFns(val, key, type) {
      let _this = this;
      // 零的时候不挑
      if (type === "select" && !val && val !== 0) {
        // 选择框 没有内容的时候不要跳转下一步
        // this.$message.error("还没有选择内容哦").showClose = true;
        return false;
      }
      let refKey = "";
      if (this.pageEnterSortList.length > 0) {
        const item = this.pageEnterSortMap[key];
        let nextItem = item.next ? item.next : null;
        while (nextItem && nextItem.isShow === false) {
          nextItem = nextItem.next ? nextItem.next : null;
        }
        // console.log("nextItem", nextItem);
        if (nextItem) {
          // const instance = _this.$refs[nextItem.FileKey];
          // 需要加上这个才能让开单客户这个选择框跳出，因为选择框了的时间还有其他请求逻辑，这里如果不等的话，没有效果
          setTimeout(() => {
            try {
              _this.$refs[key].blur();
              _this.$refs[nextItem.FileKey].focus();
            } catch (err) {
              _this.$refs[key].$el.blur();
              _this.$refs[nextItem.FileKey].$el.focus();
            }
          }, 10);
        }
      }
    },

    delRight() {
      this.tableDataRight = [];
    },
    HFMRFn() {
      this.$confirm("是否恢复默认设置", "系统提示")
        .then((res) => {
          this.tableDataRight = this.initSortList;
        })
        .catch(() => {});
    },

    // ========================= 设置回车顺序弹窗 end =========================

    // 代收货款手续费收取方式:
    getServiceFeeGetMethod() {
      this.$API
        .runList({
          number: "tenant_conf_list",
          key: "waybill_agent_amount_service_fee_get_method",
        })
        .then((res) => {
          //  waybillAmount = 加入运单运费中收取;
          //  agentAmountOut = 在代收货款应付中扣除;
          //  agentAmountIn = 加入代收货款应收中收取

          if (res.length > 0) {
            let val = res[0].value;
            this.tenantConfList = val;
            // if (val === "waybillAmount") {
            //   //  waybillAmount = 加入运单运费中收取;
            // } else if (val === "agentAmountOut") {
            //   //  agentAmountOut = 在代收货款应付中扣除;
            // } else if (val === "agentAmountIn") {
            //   //  agentAmountIn = 加入代收货款应收中收取
            // }
          }
        });
    },
    async getRemarkList(e) {
      //
      this.$API.wtl_getConfDictValDownListV5("waybill_remarks").then((res) => {
        this.baseInfoRemarksList = res || [];
      });
    },

    querySearch(queryString, cb) {
      cb(this.baseInfoRemarksList);
    },

    // 获取物品品类
    wtl_getItemList(categoryName) {
      this.$API.goods().then((res) => {
        this.goodsList = res || [];
      });
    },

    getService() {
      let serviceFee = 0;
      this.serviceFees.map((item) => (serviceFee += parseFloat(item.amount)));
      this.financeInInfo.serviceFee = serviceFee > 9 ? 9 : serviceFee;
      this.getTotalFreight();
      return this.financeInInfo.serviceFee;
    },
    async getCommands() {
      this.commands = await this.$API.runList({
        number: "admin_command_list_v5",
      });
    },
    // (应付弹窗)根据对象类型获取对象的下拉列表
    getObjectUserDownListYf(name) {
      this.$API
        .wtl_getObjectUserDownList({
          key: this.dialogForm2.objectStatusType || "",
          name: name || "",
          pageStart: 1,
          pageTotal: 1000,
        })
        .then((res) => {
          this.CustomerListsYF = res.data.result.data || [];
        });
    },
    changeobjectName(e) {
      if (!e) {
        this.getObjectUserDownListYf();
      } else {
        this.CustomerListsYF.forEach((item) => {
          if (item.name === e) {
            this.dialogForm2.objectNumber = item.number;
            // this.dialogForm2.objectStatusConfDictId = item.documentId;
          }
        });
      }
    },
    //选择费项(应付弹窗)
    changeItemService(row, idx) {
      console.log("row,idx");
      console.log(row, idx);
      if (row.itemServiceId) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == row.itemServiceId) {
            row.amount = item.unitPrice;
            row.itemServiceName = item.title;
          }
        });
      } else {
        row.amount = null;
        row.itemServiceName = null;
      }
    },
    //选择费项(应付弹窗)
    changeItemServiceId2(feiService) {
      const e = feiService.itemServiceId;
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm2.amount = item.unitPrice;
            this.dialogForm2.itemServiceName = item.title;
            feiService.amount = item.unitPrice;
            feiService.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm2.amount = null;
        this.dialogForm2.itemServiceName = null;
        feiService.amount = null;
        feiService.itemServiceName = null;
      }
    },
    changeItemServiceId6(e) {
      if (e) {
        this.CategoryServiceList.forEach((item) => {
          if (item.itemServiceId == e) {
            this.dialogForm6.amount = parseFloat(item.unitPrice);
            this.dialogForm6.itemServiceName = item.title;
          }
        });
      } else {
        this.dialogForm6.amount = null;
        this.dialogForm6.itemServiceName = null;
      }
    },
    async changeItemCategory(row, idx) {
      console.log("row", row, idx);
      row.itemServiceId = null;
      // row.amount = null;
      row.itemServiceName = null;
      if (row.itemCategoryId) {
        await this.wtl_itemServiceListAll(row.itemCategoryId, "", row);
        // this.wtl_itemServiceListAll(row.itemCategoryId, "fu:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == row.itemCategoryId) {
            row.itemCategoryName = item.categoryName;
          }
        });
      } else {
      }

      // 更新表格数据
      let datas = JSON.parse(JSON.stringify(this.otherFeeInfos_1)) || [];
      datas[idx] = row;
      this.otherFeeInfos_1 = datas;
    },
    //选择费项类型(应付)
    async changeItemCategoryIdYF(feiItem, idx) {
      const e = feiItem.itemCategoryId;
      this.dialogForm2.itemServiceId = null;
      this.dialogForm2.amount = null;
      this.dialogForm2.itemServiceName = null;
      feiItem.itemServiceId = null;
      feiItem.amount = null;
      feiItem.itemServiceName = null;
      if (e) {
        await this.wtl_itemServiceListAll(e, "fu:direction_status", feiItem);
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm2.itemCategoryName = item.categoryName;
            feiItem.itemCategoryName = item.categoryName;
          }
        });

        // 更新表格数据
        let datas = JSON.parse(JSON.stringify(this.financeOtherInfos_1)) || [];
        datas[idx] = feiItem;
        this.financeOtherInfos_1 = datas;
      } else {
        // this.dialogForm2.itemServiceId = null;
        // this.dialogForm2.amount = null;
        // this.dialogForm2.itemServiceName = null;
        // feiItem.itemServiceId = null;
        // feiItem.amount = null;
        // feiItem.itemServiceName = null;
      }
    },
    //选择费项类型(应收)
    async changeItemCategoryIdYS(feiItem, idx) {
      const e = feiItem.itemCategoryId;
      this.dialogForm2.itemServiceId = null;
      this.dialogForm2.amount = null;
      this.dialogForm2.itemServiceName = null;
      feiItem.itemServiceId = null;
      feiItem.amount = null;
      feiItem.itemServiceName = null;
      if (e) {
        await this.wtl_itemServiceListAll(e, "fu:direction_status", feiItem);
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm2.itemCategoryName = item.categoryName;
            feiItem.itemCategoryName = item.categoryName;
          }
        });
        // 更新表格数据
        let datas = JSON.parse(JSON.stringify(this.financeOutInfos_1)) || [];
        datas[idx] = feiItem;
        this.financeOutInfos_1 = datas;
      } else {
        // this.dialogForm2.itemServiceId = null;
        // this.dialogForm2.amount = null;
        // this.dialogForm2.itemServiceName = null;
        // feiItem.itemServiceId = null;
        // feiItem.amount = null;
        // feiItem.itemServiceName = null;
      }
    },
    changeItemCategoryIdYF6(e) {
      if (e) {
        this.wtl_itemServiceListAll(e, "shou:direction_status");
        this.categoryNameList.forEach((item) => {
          if (item.categoryId == e) {
            this.dialogForm6.itemCategoryName = item.categoryName;
          }
        });
      } else {
        this.dialogForm6.itemServiceId = null;
        this.dialogForm6.amount = null;
        this.dialogForm6.itemServiceName = null;
      }
    },
    // 根据类别和费项类型获取费项
    async wtl_itemServiceListAll(e, directionStatus, dataItem) {
      const res = await this.$API.wtl_getCategoryServiceList({
        categoryId: e || null,
        directionStatus: directionStatus || null,
      });
      this.CategoryServiceList = res.data.result || [];
      if (dataItem) {
        dataItem.CategoryServiceList = res.data.result || [];
      }
    },
    //选择付款方式(应付弹窗)
    changePayMent(e) {
      if (e) {
        this.settlementMethods.forEach((item) => {
          if (item.id == e) {
            this.dialogForm2.paymentMethod = item.val;
          }
        });
      } else {
        this.dialogForm2.amount = null;
        this.dialogForm2.itemServiceName = null;
      }
    },
    // 选择图片
    changeFileList(array) {
      this.fileNameLists = array;
    },
    // 选择图片
    changeFileList2(array) {
      this.dialogForm2.files = array;
    },
    handleSizeChange_as(val) {
      //  分页
      this.pageTotal_as = val;
      this.getCustomerAddrList();
    },
    handleCurrentChange_as(val) {
      //  分页
      this.pageStart_as = val;
      this.getCustomerAddrList();
    },

    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.add(prev, curr);
                  // return this.$TOOLS.mathToFixed(
                  //   this.$TOOLS.add(prev, curr),
                  //   2
                  // );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += null;
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable1.doLayout();
      });
      return sums;
    },

    async getEmps() {
      const res = await this.$API.runList({
        number: "down_list_employee",
      });
      this.emps = res;
    },

    // 接口获取详情
    async getWaybillDetail() {
      //this.loadingDetail = true
      const res = await this.$API.getWaybillDetail(this.waybillSplitId);
      this.baseInfo = res.baseInfo || {};
      this.baseInfo.businessDeptId = res.baseInfo.receiveOrderDeptId;
      this.financeInfo = res.financeInfo || {};
      this.receiveAddr = res.receiveAddr || {};
      this.waybillStatus = this.baseInfo.examineStatusShow;
      this.financeOtherInfos = res.financeOtherInfos || [];
      this.financeOtherInfos_2 = res.financeOtherInfos || [];
      this.financeOtherInfos.map(
        (item) =>
          (item.objectStatusConfDictId = parseInt(item.objectStatusConfDictId))
      );
      if (res.sendAddrs) {
        this.sendAddr = {
          ...res.sendAddrs[0],
          operationType: "UNCHANGED",
        };
        this.sendAddrs = res.sendAddrs[0].items;
        this.sendAddrs.forEach((item) => {
          item.operationType = "UNCHANGED";
          if (item.itemSpecss) {
            item.itemSpecss.forEach((spec) => {
              spec.operationType = "UNCHANGED";
            });
            item.CategoryList = [];
          }
        });
        this.sendAddrs_1 = this.sendAddrs.filter(
          (item) => item.operationType != "DEL"
        );
      } else {
        this.sendAddr = {};
        this.sendAddrs = [];
      }
      //this.sendAddrs = res.sendAddrs
      this.takeAddr = res.takeAddr || {};
      this.takeAddr.operationType = "UNCHANGED";
      this.transportInfo = res.transportInfo || {};
      this.fileNameLists = res.files || [];
      this.financeInInfo = res.financeInInfo || {
        waybillSplitId: null,
        formulaBillingWeightId: null,
        formulaBillingWeightName: null,
        unitPrice: null,
        basicFreight: null,
        takeFee: null,
        sendFee: null,
        transferFee: null,
        agentAmount: null,
        agentServiceRate: null,
        agentServiceFee: null,
        insuranceFee: null,
        allOtherFee: null,
        serviceFee: 1,
        totalFreight: 1,
        settlementMethodConfDictId: null,
        senderAmount: null,
        receivedAmount: null,
        monthlyAmount: null,
        rnorderAmount: null,
        goodsDeductedAmoun: null,
        isInvoice: 0,
        receivedCustomerId: null,
        financeRemarks: null,
        isInsure: 0,
        declaredValue: null,
        declaredValueRate: null,
        otherFeeInfos: [],
      };
      this.financeInInfo.isInvoice = this.financeInInfo.isInvoice || 0;
      this.financeOutInfos = res.financeOutInfos || [];
      this.financeOutInfos.map(
        (item) =>
          (item.objectStatusConfDictId = parseInt(item.objectStatusConfDictId))
      );
      this.financeOutInfos_2 = this.financeOutInfos;
      this.otherInfo = res.otherInfo || {};
      //this.loadingDetail = false
      if (this.type == "copy") {
        this.baseInfo.id = null;
        this.baseInfo.waybillNumber = null;
        this.baseInfo.number = null;
      }
      this.financeInInfo.totalFreight = 0;
      // 基本服务费
      if (!this.financeInInfo.serviceFee) {
        this.financeInInfo.serviceFee = 1;
      }
      if (this.baseInfo.rnRequireConfDictId) {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "回单费",
          amount: 1,
          sort: 2,
        });
      }
      if (this.transportInfo.isIntoStorage) {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "入仓费",
          amount: 9,
          sort: 3,
        });
      }

      if (this.financeInInfo && this.financeInInfo.otherFeeInfos.length > 0) {
        this.financeInInfo.otherFeeInfos.forEach((item) => {
          this.wtl_itemServiceListAll(item.itemCategoryId, "", item);
          // item.CategoryServiceList = [
          //   {
          //     itemServiceId:item.itemServiceId,
          //     title:item.itemServiceName,
          //   }
          // ]
        });
      }

      this.changeCustomerType(false);
      // 触发结算方式修改
      this.changeSettlementMethod(true);
    },

    async transformWaybillFromCommands() {
      const res = await this.$API.getCommandDetail(this.baseInfo.commandIds[0]);
      // this.baseInfo = res.commandInfo || {};

      this.baseInfo = this.baseInfo || {};
      Object.assign(this.baseInfo, res.commandInfo || {});
      this.baseInfo.businessDeptId = res.commandInfo.receiveOrderDeptId;
      this.baseInfo.commandToWaybillType =
        this.type === "transferFromCommandPart" ? 0 : 1;
      this.baseInfo.businessDate =
        this.baseInfo.businessDate || this.$moment().format("YYYY-MM-DD");
      // this.baseInfo.isAddCustomer = this.baseInfo.isAddCustomer === undefined ? 1 : this.baseInfo.isAddCustomer

      // 发货方式固定默认上门取货
      this.receMethods.forEach((item) => {
        if (item.key == "上门取货") {
          this.baseInfo.receiveMethod = item.val;
          this.baseInfo.receiveMethodConfDictId = item.id;
        }
      });

      this.financeInfo = this.financeInfo || {};
      Object.assign(this.financeInfo, res.financeInfo || {});
      this.receiveAddr = res.receiveAddr || {};
      if (res.sendAddrs) {
        this.sendAddr = {
          ...res.sendAddrs[0],
          operationType: "UNCHANGED",
        };
        this.sendAddrs = res.sendAddrs[0].itemReqs;
        this.sendAddrs.forEach((item) => {
          item.operationType = "UNCHANGED";
          if (item.itemSpecsReqs) {
            item.itemSpecsReqs.forEach((spec) => {
              spec.operationType = "UNCHANGED";
            });
            item.itemSpecss = item.itemSpecsReqs;
            item.CategoryList = [];
          }
        });
        this.sendAddrs_1 = this.sendAddrs.filter(
          (item) => item.operationType != "DEL"
        );
      } else {
        this.sendAddr = {};
        this.sendAddrs = [];
      }

      let baseInfoData = JSON.parse(JSON.stringify(this.baseInfo));

      baseInfoData.customerType = baseInfoData.customerId ? 1 : 0;
      baseInfoData.isAddCustomer = baseInfoData.customerId ? 0 : 1;

      if (baseInfoData.isAddCustomer === 1 && res.sendAddrs.length > 0) {
        baseInfoData.customerName =
          baseInfoData.customerName || res.sendAddrs[0].contacts || "";
        baseInfoData.customerContacts =
          baseInfoData.customerName || res.sendAddrs[0].contacts || "";
        baseInfoData.customerPhone =
          baseInfoData.customerPhone || res.sendAddrs[0].tel || "";
      }
      this.baseInfo = baseInfoData;

      //this.sendAddrs = res.sendAddrs
      this.takeAddr = res.takeAddr || {};
      this.takeAddr.operationType = "UNCHANGED";
      const transportInfo = res.transportInfo || {};
      if (res.files) {
        res.files.forEach((item) => {
          this.fileNameLists.push({
            name: item.fileId,
            url: item.fileUrl,
          });
        });
      }
      this.financeInInfo = res.financeInfo || {};
      this.financeInInfo = {
        ...this.financeInInfo,
        isInsure: transportInfo.isInsure || 0,
        declaredValue: transportInfo.declaredValue || 0,
        declaredValueRate: transportInfo.declaredValueRate || 0,
      };
      this.transportInfo = transportInfo;
      this.financeOutInfos = res.financeOutInfos || [];
      this.financeOutInfos.map(
        (item) =>
          (item.objectStatusConfDictId = parseInt(item.objectStatusConfDictId))
      );
      this.financeOutInfos_2 = this.financeOutInfos;
      this.otherInfo = res.otherInfo || {};
      let totalFreight = 0;
      // 基本服务费
      if (!this.financeInInfo.serviceFee) {
        this.financeInInfo.serviceFee = 1;
        totalFreight = 1;
      }
      if (this.baseInfo.rnRequireConfDictId) {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "回单费",
          amount: 1,
          sort: 2,
        });
        totalFreight += 1;
      }
      if (this.transportInfo.isIntoStorage) {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "入仓费",
          amount: 9,
          sort: 3,
        });
      }
      this.financeInInfo.totalFreight =
        this.financeInInfo.totalFreight || totalFreight;
      this.financeInInfo.isInvoice = this.financeInInfo.isInvoice || 0;
      this.changeCustomerType(false);
      // 触发结算方式修改
      this.changeSettlementMethod(true);
    },

    runPageReportDetailsitemId(conditonVal, i) {
      this.$API
        .runPageReportDetails({
          conditionReqs: [
            {
              conditonKey: "itemId",
              conditonVal,
            },
          ],
          number: "command_item_specs_list",
        })
        .then((res) => {
          if (res.data.status === "success") {
            let datas = res.data.result.datas || [];
            datas.forEach((n, i) => {
              n.operationType = "UNCHANGED";
            });
            this.takeAddr[i].itemSpecss = datas;
          } else {
            this.$message.error(`${res.data.message}---综合查询列表`);
          }
        });
    },

    //员工、部门、外发网点
    focusMethod(key, keys) {
      if (this[keys].length == 0) {
        this.remoteMethod("", key, keys);
      }
    },
    //员工、部门、外发网点
    changeMethod(e, arrs, keys) {
      let curs = this[arrs].filter((item) => item.documentId == e);
      if (keys == "intoDeptName") {
        this.rukuPlanReq[keys] = (curs.length && curs[0].name) || "";
      } else {
        this.baseInfo[keys] = (curs.length && curs[0].name) || "";
      }
    },
    changeSpecialRequire(e, refKey) {
      const selectedSpecialRequirements = this.specialRequirements.filter(
        (item) => item.val === this.transportInfo.specialRequire
      );
      if (selectedSpecialRequirements.length > 0) {
        this.transportInfo.specialRequireConfDictId =
          selectedSpecialRequirements[0].id;
      }
      this.enterFns(e, refKey, "select");
    },
    changeremarks(e, refKey) {
      // const selectedbaseInfoRemarksList = this.baseInfoRemarksList.filter(
      //   (item) => item.val === this.baseInfo.remarks
      // );
      // if (selectedbaseInfoRemarksList.length > 0) {
      //   this.transportInfo.specialRequireConfDictId =
      //     selectedbaseInfoRemarksList[0].id;
      // }
      if (refKey) {
        this.baseInfo.remarks = e;
        this.baseInfo.remarkTemp = "";
        this.enterFns(e, refKey, "select");
      }
    },
    // 员工、部门、外发网点
    remoteMethod(name, key, keys) {
      // employee 员工
      // dept 部门
      // storage 外发网点
      this.$API
        .wtl_getObjectUserDownList({
          name,
          key,
          pageStart: 1,
          pageTotal: 1000,
        })
        .then((res) => {
          let arrs = res.data.result.data || [];
          this[keys] = arrs;
        });
    },

    //外发承运商
    focusMethodCarrier() {
      if (this.changeCarrierList.length == 0) {
        this.remoteMethodCarrier("");
      }
    },
    //外发承运商
    changeMethodCarrier(e) {
      let curs = this.changeCarrierList.filter((item) => item.carrierId == e);
      this.financeInfo.carrierName = (curs.length && curs[0].carrierName) || "";
      if (e) {
        // 获取承运商——网点
        this.$COMAPI.CarrierDeptList(e).then((res) => {
          this.CarrierDeptListList = res || [];
        });
      }
    },
    //外发承运商 carrierId carrierName
    remoteMethodCarrier(carrierName) {
      this.$API
        .CarrierList({
          carrierName,
          pageStart: 1,
          pageTotal: 1000,
        })
        .then((res) => {
          this.changeCarrierList = res.data.result.data || [];
        });
    },

    //品类
    focusMethodCategory(index) {
      // if (this.sendAddrs[index].CategoryList.length == 0) {
      //   this.remoteMethodCategory("", index);
      // }
    },
    //品类
    changeMethodCategory(e, index, refKey) {
      this.sendAddrs_1[index].operationType = "UPDATE";
      if (this.sendAddrs_1[index].CategoryList) {
        let curs = this.sendAddrs_1[index].CategoryList.filter(
          (item) => item.itemCategoryName == e
        );
        this.sendAddrs_1[index].itemCategoryName = e;
        this.sendAddrs_1[index].itemCategoryCode =
          (curs.length && curs[0].itemCategoryCode) || "";
      }

      this.enterFns(e, refKey, "select");
    },
    //品类
    remoteMethodCategory(categoryName, index) {
      this.$API
        .wtl_getCategoryList({
          categoryName,
          pageStart: 1,
          pageTotal: 1000,
        })
        .then((res) => {
          this.sendAddrs_1[index].CategoryList = res.data.result.data || [];
        });
    },

    // 根据字典类型获取字典值下拉列表 包装 车型 外发提货 外发送货方式
    async getConfDictValDownList(dictType, field, realFileName) {
      const res = await this.$API.wtl_getConfDictValDownListV5(dictType);
      let arrs = res || [];
      // 其他情况
      this[field] = arrs;
      if (realFileName && arrs.length > 0) {
        this.baseInfo[realFileName] = arrs[0].id;
      }
      if (this.baseInfo.customerType == 0) {
        this.settlementMethods
          .filter((item) => item.key === "ji_fu_yue_jie")
          .map((item) => (item.disabled = true));
      }
      this.settlementMethods_1 = this.settlementMethods.filter(
        (item) => !(item.disabled == true)
      );
    },

    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },

    //货物信息 添加一行货物信息
    AddGoods(idx) {
      // 最大序号
      const serialNumber = Math.max(
        this.sendAddrs.map((item) =>
          item.serialNumber ? parseInt(item.serialNumber) : 0
        )
      );
      let objs = {
        itemId: null,
        serialNumber: serialNumber,
        goodsNumber: null,
        goodsName: null,
        itemCategoryCode: null,
        itemCategoryName: null,
        packageName: null,
        packageCout: null,
        grossWeight: null,
        netWeight: null,
        volumeWeight: null,
        weightVolume: null,
        billingWeight: null,
        volumeDivisor: this.volumeDivisor,
        volume: null,
        specs: null,
        heavyCargoConfDictId: null,
        operationType: "ADD",
        itemSpecss: [
          {
            specsId: null,
            packageCout: null,
            length: null,
            wide: null,
            height: null,
            operationType: "ADD",
          },
        ],
        CategoryList: [],
      };
      if (this.saveKeys == 2 && this.commandId) {
        objs.operationType = "ADD";
      }
      this.sendAddrs.push(objs);
      this.sendAddrs_1 = this.sendAddrs.filter(
        (item) => item.operationType != "DEL"
      );
    },
    //货物信息 删除一行货物信息
    delGoods(idx) {
      this.sendAddrs_1[idx].operationType = "DEL";
      this.sendAddrs_1 = this.sendAddrs.filter(
        (item) => item.operationType != "DEL"
      );
    },
    onInputHW(index, e, refKey) {
      this.sendAddrs_1[index].operationType = "UPDATE";
      if (e) {
        this.enterFns(e, refKey, "select");
      }
    },
    //设置规格
    clickSet(index) {
      this.specIndex1 = index;
      this.sendAddrs[index].operationType = "UPDATE";
      this.specifications = this.sendAddrs[index].itemSpecss || [];
      this.specifications_1 = this.specifications.filter(
        (item) => item.operationType != "DEL"
      );
      this.isShowDialog1 = true;
    },
    handleCloseDia1() {
      this.isShowDialog1 = false;
    },
    //设置规格  确认保存
    diaConfirmBtn1() {
      this.sendAddrs[this.specIndex1].itemSpecss = this.specifications;
      this.isShowDialog1 = false;
    },

    //设置规格 添加规格
    clickAdd() {
      this.specifications.push({
        specsId: null,
        height: null,
        length: null,
        packageCout: null,
        wide: null,
        operationType: "ADD",
      });
      this.specifications_1 = this.specifications.filter(
        (item) => item.operationType != "DEL"
      );
    },
    //设置规格 删除一行规格
    clickDel(index) {
      this.specifications_1[index].operationType = "DEL";
      this.specifications_1 = this.specifications.filter(
        (item) => item.operationType != "DEL"
      );
    },
    onInput(index) {
      this.specifications_1[index].operationType = "UPDATE";
    },

    changeCustomer(e) {
      if (e) {
        this.remoteMethodCustomer();
      }
    },

    changeCustomerManual(e) {
      this.sendAddr.company = this.baseInfo.customerName;
      this.sendAddr.contacts = this.baseInfo.customerContacts;
      this.sendAddr.tel = this.baseInfo.customerPhone;
    },

    //客户
    async remoteMethodCustomer(customerName) {
      const res = await this.$API.runList({
        keyword: customerName,
        pageStart: 1,
        pageTotal: 100,
        approveStatus: "tong_guo:approve_status",
        number: "customer_down_list",
      });
      this.CustomerLists = res || [];
    },
    //寄件地址
    async remoteMethodPhoneJJ(val) {
      const res = await this.$API.runList({
        addrPhone: val,
        addressType: "ji_jian:address_type", //ji_jian:address_type   shou_jian:address_type
        // customerId: this.baseInfo.customerId || null,
        number: "down_list_customer_addr",
      });
      this.sendPhoneLists = res || [];
    },
    //收件地址
    async remoteMethodPhoneSJ(val) {
      const res = await this.$API.runList({
        addrPhone: val,
        addressType: "shou_jian:address_type", //ji_jian:address_type   shou_jian:address_type
        customerId: this.baseInfo.customerId || null,
        number: "down_list_customer_addr",
      });
      this.SJPhoneLists = res || [];
    },
    changeCustomerType(clearSettlement = true) {
      if (this.baseInfo.customerType == 0) {
        this.baseInfo.customerId = null;
        this.baseInfo.customerName = null;
        this.baseInfo.isAddCustomer = 1;
        // 散客默认不投保
        this.financeInInfo.isInsure = 0;

        // 普通客户不能选择月结
        if (clearSettlement) {
          this.financeInInfo.settlementMethodConfDictId = null;
        }
        this.changeSettlementMethod();
        this.settlementMethods
          .filter(
            (item) =>
              item.key === "ji_fu_yue_jie" || item.key === "dao_fu_yue_jie"
          )
          .map((item) => (item.disabled = true));
        // this.hidePageEnterSortKey("k16");
        // this.showPageEnterSortKey("k161");
        // this.showPageEnterSortKey("k162");
        // this.showPageEnterSortKey("k163");
        // this.showPageEnterSortKey("k164");
      } else {
        this.baseInfo.isAddCustomer = 0;
        this.settlementMethods
          .filter(
            (item) =>
              item.key === "ji_fu_yue_jie" || item.key === "dao_fu_yue_jie"
          )
          .map((item) => (item.disabled = false));
        // this.showPageEnterSortKey("k16");
        // this.hidePageEnterSortKey("k161");
        // this.hidePageEnterSortKey("k162");
        // this.hidePageEnterSortKey("k163");
        // this.hidePageEnterSortKey("k164");
      }
      this.settlementMethods_1 = this.settlementMethods.filter(
        (item) => !(item.disabled == true)
      );
    },
    hidePageEnterSortKey(field) {
      if (this.pageEnterSortMap[field]) {
        this.pageEnterSortMap[field].isShow = false;
      }
    },
    showPageEnterSortKey(field) {
      if (this.pageEnterSortMap[field]) {
        this.pageEnterSortMap[field].isShow = true;
      }
    },
    //客户
    focusMethodCustomer() {
      if (this.CustomerLists.length == 0) {
        this.remoteMethodCustomer("");
      }
    },
    changePhone(e) {
      if (!e) {
        this.sendPhoneLists = [];
      } else {
        // this.remoteMethodPhoneJJ()
      }
    },
    changePhoneSJ(e) {
      if (!e) {
        this.SJPhoneLists = [];
      } else {
        // this.remoteMethodPhoneSJ()
      }
    },
    changeMethodPhone(e, refKey) {
      if (!e) {
        return false;
      }

      if (typeof e == "string") {
        this.sendAddr.tel = e;
        // 查不到地址的则跳到发货单位
        this.$refs[refKey].blur();
        setTimeout(() => {
          try {
            this.$refs["k18"].focus();
          } catch (err) {
            this.$refs["k18"].$el.focus();
          }
        }, 10);
      } else if (typeof e == "object") {
        let jjAddressData = e;
        // this.sendAddr.tel = jjAddressData.addrPhone; customerName

        this.baseInfo.customerName = jjAddressData.customerName;
        this.baseInfo.customerId = jjAddressData.customerId;

        this.sendAddr.contacts = jjAddressData.personnelName || "";
        this.sendAddr.company = jjAddressData.companyName || "";
        this.sendAddr.tel = jjAddressData.addrPhone || "";
        this.sendAddr.addrId = jjAddressData.id || "";
        this.sendAddr.idNumber = jjAddressData.idNumber || "";
        this.sendAddr.provinceName = jjAddressData.provinceName || "";
        this.sendAddr.cityName = jjAddressData.cityName || "";
        this.sendAddr.areaName = jjAddressData.areaName || "";
        this.sendAddr.address = jjAddressData.address || "";

        if (jjAddressData.customerId) {
          this.baseInfo.customerId = jjAddressData.customerId;
          this.CustomerLists = [
            {
              phone: jjAddressData.phone,
              customerNumber: jjAddressData.customerNumber,
              customerName: jjAddressData.customerName,
              customerId: jjAddressData.customerId,
            },
          ];
        }

        this.enterFns(this.sendAddr.tel, refKey, "select");
      }
    },
    changeMethodPhoneSJ(e, refKey) {
      if (!e) {
        return false;
      }

      if (typeof e == "string") {
        this.receiveAddr.tel = e;
        // 查不到地址的则跳到发货单位
        this.$refs[refKey].blur();
        setTimeout(() => {
          try {
            this.$refs["k26"].focus();
          } catch (err) {
            this.$refs["k26"].$el.focus();
          }
        }, 10);
      } else if (typeof e == "object") {
        let jjAddressData = e;
        // this.receiveAddr.tel = jjAddressData.addrPhone;

        this.receiveAddr.contacts = jjAddressData.personnelName || "";
        this.receiveAddr.company = jjAddressData.customerName || "";
        this.receiveAddr.tel = jjAddressData.addrPhone || "";
        this.receiveAddr.addrId = jjAddressData.id || "";
        this.receiveAddr.idNumber = jjAddressData.idNumber || "";
        this.receiveAddr.provinceName = jjAddressData.provinceName || "";
        this.receiveAddr.cityName = jjAddressData.cityName || "";
        this.receiveAddr.areaName = jjAddressData.areaName || "";
        this.receiveAddr.address = jjAddressData.address || "";

        // if (jjAddressData.customerId) {
        //   this.baseInfo.customerId = jjAddressData.customerId;
        //   this.CustomerLists = [
        //     {
        //       phone: jjAddressData.phone,
        //       customerNumber: jjAddressData.customerNumber,
        //       customerName: jjAddressData.customerName,
        //       customerId: jjAddressData.customerId,
        //     },
        //   ];
        // }

        this.enterFns(this.receiveAddr.tel, refKey, "select");
      }
    },
    //客户名称  选择或者清除客户时触发
    changeMethodCustomer(e, refKey) {
      let curs = this.CustomerLists.filter((item) => item.customerName == e);
      let customerIds = (curs.length && curs[0].customerId) || null;
      this.baseInfo.customerId = customerIds;

      if (customerIds) {
        this.getCustomerDefaultAddrList(customerIds);
        // 设置结算方式
        const cur = curs[0];
        this.financeInInfo.settlementMethodConfDictId = parseInt(
          cur.settlementMethodConfDictId
        );
        this.financeInInfo.isInvoice = cur.isInvoicing;
        this.financeInInfo.isInsure = cur.isSure;
        this.financeInInfo.declaredValueRate = cur.insuranceRate;
        this.otherInfo.businessId = parseInt(cur.salemanId);

        this.otherInfo.merchandiserEmployeeId =
          cur.merchandiserEmployeeId || "";
        this.otherInfo.merchandiserEmployeeName =
          cur.merchandiserEmployeeName || "";
        this.otherInfo.personInChargeId = cur.personInChargeId * 1 || "";
        this.otherInfo.personChargeName = cur.personChargeName || "";
        this.financeInInfo.agentAccountName = cur.bankName || "";
        this.financeInInfo.agentAccount = cur.bankAccount || "";
        this.financeInInfo.agentAccountAddress = cur.bankAddress || "";
        // agentAccountName

        this.enterFns(e, refKey, "select");
      }
    },
    // //客户id  选择或者清除客户时触发
    // changeMethodCustomer(e, refKey) {
    //   let curs = this.CustomerLists.filter((item) => item.customerId == e);
    //   let customerName = (curs.length && curs[0].customerName) || null;
    //   this.baseInfo.customerName = customerName;
    //   if (e) {
    //     this.getCustomerDefaultAddrList(e);
    //     // 设置结算方式
    //     const cur = curs[0];
    //     this.financeInInfo.settlementMethodConfDictId = parseInt(
    //       cur.settlementMethodConfDictId
    //     );
    //     this.financeInInfo.isInvoice = cur.isInvoicing;
    //     this.financeInInfo.isInsure = cur.isSure;
    //     this.financeInInfo.declaredValueRate = cur.insuranceRate;
    //     this.otherInfo.businessId = parseInt(cur.salemanId);

    //     this.otherInfo.merchandiserEmployeeId =
    //       cur.merchandiserEmployeeId || "";
    //     this.otherInfo.merchandiserEmployeeName =
    //       cur.merchandiserEmployeeName || "";
    //     this.financeInInfo.agentAccountName = cur.bankName || "";
    //     this.financeInInfo.agentAccount = cur.bankAccount || "";
    //     this.financeInInfo.agentAccountAddress = cur.bankAddress || "";
    //     // agentAccountName

    //     this.enterFns(e, refKey, "select");
    //   }
    // },
    //客户 根据客户id获取客户默认地址
    getCustomerDefaultAddrList(id) {
      this.$API
        .runList({
          customerId: id,
          number: "customer_default_address_map",
        })
        .then((res) => {
          let datas = res || [];
          if (datas.length > 0) {
            let jjAddressData = {}; // 寄件默认地址;
            let sjAddressData = {}; // 收件默认地址;
            datas.forEach((item) => {
              if (item.addressType == "ji_jian:address_type") {
                jjAddressData = item;
              }
              if (item.addressType == "shou_jian:address_type") {
                sjAddressData = item;
              }
            });
            if (jjAddressData) {
              jjAddressData.contacts = jjAddressData.contactsName;
              jjAddressData.company =
                jjAddressData.companyName || jjAddressData.deptName || "";
              jjAddressData.tel = jjAddressData.tel || jjAddressData.phone;
              jjAddressData.addrId = null;
              this.sendAddr = JSON.parse(JSON.stringify(jjAddressData));
            } else {
              //this.sendAddr = {};
            }
            if (sjAddressData) {
              sjAddressData.contacts = sjAddressData.contactsName || null;
              sjAddressData.company =
                sjAddressData.companyName || sjAddressData.deptName || "";
              sjAddressData.tel = sjAddressData.tel || sjAddressData.phone;
              sjAddressData.addrId = null;
              this.receiveAddr = JSON.parse(JSON.stringify(sjAddressData));
            } else {
              //this.receiveAddr = {};
            }
          } else {
            //this.sendAddr = {};
            //this.receiveAddr = {};
          }
        });
    },

    // 发货地址 自动识别地址
    geocode(getAddress, getcity, refKey) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: getcity || "",
      };
      this.$API
        .geocode(param)
        .then((res) => {
          let result = res.data.result.geocodes || [];
          if (result.length == 0) {
            return false;
          }
          let datas = result[0] || "";
          let sj = JSON.parse(JSON.stringify(this.sendAddrs));
          sj.provinceName = datas.province;
          sj.cityName = datas.city;
          sj.areaName = datas.district;
          this.sendAddrs = sj;

          this.enterFns(getAddress, refKey, "select");
        })
        .catch(() => {
          this.enterFns(getAddress, refKey, "select");
        });
    },
    // 收货地址 自动识别地址
    geocode_1(getAddress, getcity) {
      if (!getAddress) {
        return false;
      }
      let param = {
        address: getAddress || "",
        city: getcity || "",
      };
      this.$API.geocode(param).then((res) => {
        let result = res.data.result.geocodes || [];
        if (result.length == 0) {
          return false;
        }
        let datas = result[0] || "";
        let sj = JSON.parse(JSON.stringify(this.receiveAddr));
        sj.provinceName = datas.province;
        sj.cityName = datas.city;
        sj.areaName = datas.district;
        this.receiveAddr = sj;
      });
    },
    async getDestCities(keyword) {
      this.destCityLoading = true;
      const data = await this.$API.runList({
        number: "admin_dest_city_downlist",
        keyword,
      });
      this.destCitys = data;
      this.destCityLoading = false;
    },
    async clearDestCity() {
      this.getDestCities();
    },
    changeDestCity() {
      this.getTransportLine();
    },
    async getTransportLine() {
      this.transportLineLoading = true;
      const data = await this.$API.runList({
        number: "down_list_transport_line_v4",
        city: this.baseInfo.destCity,
      });
      this.lines = data;
      this.transportLineLoading = false;
      if (this.lines.length > 0 && this.baseInfo.destCity) {
        this.baseInfo.transportLineId = this.lines[0].id;
        this.volumeDivisor = this.lines[0].volumeDivisor;
        this.baseInfo.endDeptId = this.lines[0].arriveDeptId;
        this.changeEndDept();
        if (this.sendAddrs.length > 0) {
          for (let sendAddr of this.sendAddrs) {
            if (!sendAddr.volumeDivisor) {
              sendAddr.volumeDivisor = this.volumeDivisor;
            }
          }
        }
      }
    },
    changeTransportLine(e, refKey) {
      if (!e) {
        return;
      }
      const line = this.lines.filter(
        (d) => d.id == this.baseInfo.transportLineId
      )[0];
      this.volumeDivisor = line.volumeDivisor;
      this.baseInfo.endDeptId = line.arriveDeptId;
      this.changeEndDept();
      if (this.sendAddrs.length > 0) {
        for (let sendAddr of this.sendAddrs) {
          if (!sendAddr.volumeDivisor) {
            sendAddr.volumeDivisor = this.volumeDivisor;
          }
        }
      }

      this.enterFns(e, refKey, "select");
    },
    changeisOutTake(e, refKey) {
      if (refKey) {
        this.enterFns(e, refKey, "select");
      }
    },
    // 默认查省级
    getProvince(e) {
      this.$API
        .district({
          parentId: 1,
        })
        .then((res) => {
          this.SuperiorRegionList = res || [];
        });
    },
    // 获取市 (收货地址)
    getCityName(e, type) {
      if (!e) {
        return false;
      }
      this.$API
        .district({
          parentName: e,
        })
        .then((res) => {
          const data = res || [];
          const fieldName = "cityNameList" + (type ? "_" + type : "");
          this[fieldName] = data;
        });
    },
    // 获取市 (收货地址)
    getAreaName(e, type) {
      if (!e) {
        return false;
      }
      this.$API
        .district({
          parentName: e,
        })
        .then((res) => {
          const data = res || [];
          const fieldName = "areaNameList" + (type ? "_" + type : "");
          this[fieldName] = data;
        });
    },
    // 选择省(收货地址)
    changeProvince(type, e, refKey) {
      let obj = this.sendAddr;
      if (type === 1) {
        obj = this.receiveAddr;
      }
      if (type === 2) {
        obj = this.takeAddr;
      }
      obj.cityName = "";
      obj.areaName = "";
      if (type) {
        this.cityNameList = [];
        this.areaNameList = [];
      } else {
        this["cityNameList_" + type] = [];
        this["areaNameList_" + type] = [];
      }
      const provinceName = obj.provinceName;
      if (provinceName) {
        this.getCityName(provinceName, type);
      }

      this.enterFns(e, refKey, "select");
    },
    // 选择市(收货)
    changeCity(type, e, refKey) {
      let obj = this.sendAddr;
      if (type === 1) {
        obj = this.receiveAddr;
      }
      if (type === 2) {
        obj = this.takeAddr;
      }
      obj.areaName = "";
      if (type) {
        this.areaNameList = [];
      } else {
        this["areaNameList_" + type] = [];
      }
      const cityName = obj.cityName;
      if (cityName) {
        this.getAreaName(cityName, type);
      }

      this.enterFns(e, refKey, "select");
    },

    changeArea(e, refKey) {
      this.$forceUpdate();

      this.enterFns(e, refKey, "select");
    },

    //收发货地址
    handleCloseDia3() {
      this.isShowDialog3 = false;
      this.queryData = {
        customerId: "",
        addressType: "",
        deptName: "",
        personnelName: "",
      };
    },
    handleCloseDiaAI() {
      this.isShowDialogAI = false;
    },
    handleCloseDiaMap() {
      this.isShowDialogMap = false;
    },
    //收发货地址  弹窗确认保存事件
    diaConfirmBtn3() {
      // 添加费项
      this.isShowDialog3 = false;
    },

    diaConfirmBtnAI() {
      this.isShowDialogAI = false;
      // 回填地址
      const address = {
        companyName: "",
        personnelName: this.addressAI.username,
        tel: this.addressAI.phone,
        provinceName: this.addressAI.province,
        cityName: this.addressAI.city,
        areaName: this.addressAI.area,
        address: this.addressAI.address,
        idNumber: this.addressAI.idNumber,
        addressType: this.addressAI.addressType,
      };
      this.changeAddress(address);
    },
    diaConfirmBtnMap() {},
    changeRnRquireConf(e, refKey) {
      if (!e) {
        this.baseInfo.rnRequireName = "";
        this.delService("回单费");
      }
      const rnQuirement = this.rnRequirements.filter(
        (item) => item.id == this.baseInfo.rnRequireConfDictId
      )[0];
      this.baseInfo.rnRequireName = rnQuirement.val;
      // 有回单要求，有回单要求为2元（含开单服务费）
      this.addService({
        itemCategoryName: "服务费",
        itemServiceName: "回单费",
        amount: 1,
        sort: 2,
      });
      this.enterFns(e, refKey, "select");
    },
    changeEndDept(e, refKey) {
      this.changeSendMethod();
      if (refKey) {
        this.enterFns(e, refKey, "select");
      }
    },
    changeSelectKey(e, refKey) {
      if (refKey) {
        this.enterFns(e, refKey, "select");
      }
    },

    changeSendMethod_Fn(e, refKey) {
      this.changeSendMethod();
      if (refKey) {
        this.enterFns(e, refKey, "select");
      }
    },
    changeSendMethod() {
      const sendMethods = this.sendMethods.filter(
        (item) => item.id === this.baseInfo.sendMethodConfDictId
      );
      if (sendMethods.length == 0) {
        return;
      }
      const sendMethod = sendMethods[0];
      if (sendMethod.key !== "客户自提") {
        return;
      }
      const depts = this.businessDepts.filter(
        (item) => item.deptId === this.baseInfo.endDeptId
      );
      if (depts.length === 0) {
        return;
      }
      const dept = depts[0];
      // 设置自提默认
      this.takeAddr = {
        addrId: this.takeAddr.addrId,
        serialNumber: "1",
        contacts: dept.chargePersonName || "",
        company: dept.deptName || "",
        tel: dept.takeGoodsTel || "",
        provinceName: dept.provinceName || "",
        cityName: dept.cityName || "",
        areaName: dept.areaName || "",
        address: dept.address || "",
        operationType: this.takeAddr.addrId ? "UPDATE" : "ADD",
      };
    },
    //收发货地址  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn3() {
      this.isShowDialog3 = false;
    },
    //收发货地址 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    //收发货地址 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    //收发货地址 选择收件人地址
    changeRecAddress(type) {
      if (type == 1) {
        this.dialogTitle3 = "选择发货地址";
        this.queryData.addressType = "ji_jian:address_type";
      } else {
        this.dialogTitle3 = "选择收货地址";
        this.queryData.addressType = "shou_jian:address_type";
      }
      this.queryData.customerId = this.baseInfo.customerId || "";
      if (this.baseInfo.customerId) {
        this.isShowDialog3 = true;
        this.getCustomerListAddress();
        this.getCustomerAddrList();
      } else {
        if (this.baseInfo.customerName) {
          this.$message.warning("当前客户没有客户档案").showClose = true;
        } else {
          this.$message.warning("请先选择客户").showClose = true;
        }

        return false;
      }
    },
    //收发货地址 选择地址
    changeAddress(row, ignorePersonInfo = false) {
      if (
        this.queryData.addressType == "ji_jian:address_type" ||
        row.addressType === "ji_jian:address_type"
      ) {
        //寄件
        if (!ignorePersonInfo) {
          this.sendAddr.company = row.companyName || row.deptName || "";
          this.sendAddr.contacts = row.personnelName || "";
          this.sendAddr.tel = row.tel || "";
          this.sendAddr.idNumber = row.idNumber || "";
        }
        this.sendAddr.provinceName = row.provinceName || "";
        this.sendAddr.cityName = row.cityName || "";
        this.sendAddr.areaName = row.areaName || "";
        this.sendAddr.address = row.address || "";
        this.isShowDialog3 = false;
        this.getCityName(row.provinceName);
        this.getAreaName(row.cityName);
      } else if (
        this.queryData.addressType == "shou_jian:address_type" ||
        row.addressType === "shou_jian:address_type"
      ) {
        //收件
        if (!ignorePersonInfo) {
          this.receiveAddr.company = row.companyName || row.deptName || "";
          this.receiveAddr.contacts = row.personnelName || "";
          this.receiveAddr.tel = row.tel || "";
          this.receiveAddr.idNumber = row.idNumber || "";
        }
        this.receiveAddr.provinceName = row.provinceName || "";
        this.receiveAddr.cityName = row.cityName || "";
        this.receiveAddr.areaName = row.areaName || "";
        this.receiveAddr.address = row.address || "";
        this.isShowDialog3 = false;
        this.getCityName(row.provinceName, 1);
        this.getAreaName(row.cityName, 1);
      } else {
        // 自提
        if (!ignorePersonInfo) {
          this.takeAddr.company = row.companyName || row.deptName || "";
          this.takeAddr.contacts = row.personnelName || "";
          this.takeAddr.tel = row.tel || "";
          this.takeAddr.idNumber = row.idNumber || "";
        }
        this.takeAddr.provinceName = row.provinceName || "";
        this.takeAddr.cityName = row.cityName || "";
        this.takeAddr.areaName = row.areaName || "";
        this.takeAddr.address = row.address || "";
        this.isShowDialog3 = false;
        this.getCityName(row.provinceName, 2);
        this.getAreaName(row.cityName, 2);
      }
    },
    //收发货地址 获取客户档案列表()
    getCustomerListAddress(name) {
      this.$API
        .wtl_getCustomerList({
          customerName: name || "",
          approveStatus: "tong_guo:approve_status", //审核通过
          pageStart: 1,
          pageTotal: 1000,
        })
        .then((res) => {
          this.addressNaemList = res.data.result.data || [];
        });
    },

    sumVolumeWeightBtns(data, idx) {
      this.$API
        .sumVolumeWeight({
          volume: data.volume || "0",
          volumeDivisor: data.volumeDivisor || "0",
          weight: data.grossWeight || "0",
          weightDivisor: "0",
        })
        .then((res) => {
          let num = res.data.result?.volumeWeight || 0;
          let list = JSON.parse(JSON.stringify(this.sendAddrs_1)) || [];
          list[idx].volumeWeight = num;
          this.sendAddrs_1 = list;
        });
    },
    //收发货地址 收-发货人列表
    getCustomerAddrList() {
      this.$API
        .wtl_getCustomerAddrList({
          customerId: this.queryData.customerId,
          addressType: this.queryData.addressType,
          deptName: this.queryData.deptName || "",
          personnelName: this.queryData.personnelName,
        })
        .then((res) => {
          this.tableData = res.data.result.data || [];
          this.pageCount_as = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            let Heigth = this.$refs.myDialogRef_as.offsetHeight || 0; //弹窗的高度
            this.TBHeight_as = Heigth * 1 - 51 - 54 - 40;
          });
        });
    },

    // 收录客户地址
    autoAddCustomerAddrApi(datas) {
      return this.$API
        .autoAddCustomerAddr({
          address: datas.address || "",
          addressType: datas.addressType || "",
          cityName: datas.cityName || "",
          contacts: datas.contacts || "",
          customerId: datas.customerId || "",
          provinceName: datas.provinceName || "",
          tel: datas.tel || "",
          addressName: datas.addressName || "",
          areaName: datas.areaName || "",
          phone: datas.tel || "",
          remarks: datas.remarks || "",
          deptName: datas.deptName || datas.companyName || "",
          idNumber: datas.idNumber || "",
        })
        .then((res) => {});
    },
    saveClick(key) {
      //新增
      this.saveKeys = key;
      this.disabledSee = false;
      // switch (key) {
      //   case 1:

      //     break;
      //   case 2:
      //     break;
      //   case 3:
      //     break;
      // }
    },
    async check() {
      let forms = [1, 2, 4, 5, 7, 8];
      if (this.feeCheckIn) {
        forms = [5];
      }
      if (this.baseEdit) {
        forms = [1, 2, 4, 7];
      }
      const promise = forms.map(async (i) => {
        let form = this.$refs["form" + i];
        if (!form) {
          return true;
        }
        const validate = form.validate();
        if (!validate) {
          return true;
        }
        const pro = await validate
          .then((res) => {
            return true;
          })
          .catch((err) => {
            return false;
          });
        return pro;
      });
      const result = await Promise.all(promise);
      const valid = result.filter((item) => !item).length === 0;
      if (!valid) {
        this.$message.warning("请完善信息");
      }
      return valid;
    },
    getOperationType(item) {
      const operationType = item.operationType;
      if (
        !operationType ||
        operationType === "UNCHANGE" ||
        operationType === "UNCHANGED"
      ) {
        return "UPDATE";
      }
      return operationType;
    },
    getOperationTypeParams(item) {
      return {
        ...item,
        operationType: this.getOperationType(item),
      };
    },

    // 提交
    async submit(back, refKey) {
      if(this.loading){
        return Promise.reject();
      }
      const this_ = this;
      const check = await this.check();
      if (!check) {
        return Promise.reject();
      }
      const files = this.fileNameLists;

      let baseInfoData = JSON.parse(JSON.stringify(this.baseInfo));
      if (baseInfoData.commandId) {
        baseInfoData.commandIds = [baseInfoData.commandId];
      }
      baseInfoData.customerType = baseInfoData.customerId ? 1 : 0;
      baseInfoData.isAddCustomer = baseInfoData.customerId ? 0 : 1;
      if (baseInfoData.isAddCustomer === 1) {
        baseInfoData.customerName =
          baseInfoData.customerName || baseInfoData.customerContacts;
        baseInfoData.customerContacts =
          baseInfoData.customerName || baseInfoData.customerContacts;
        baseInfoData.customerPhone = this.sendAddr.tel;
      }

      let params = {
        isPosting: this.isPosting,
        baseInfo: baseInfoData,
        sendAddrs: [
          {
            ...this.sendAddr,
            serialNumber: 1,
            operationType: this.getOperationType(this.sendAddr),
            items: this.sendAddrs.map((item) => {
              const aa = this.getOperationTypeParams(item);
              const itemSpecss = item.itemSpecss;
              if (itemSpecss) {
                aa.itemSpecss = itemSpecss.map((specs) => {
                  return this.getOperationTypeParams(specs);
                });
              }
              return aa;
            }),
          },
        ],
        receiveAddr: {
          ...this.receiveAddr,
          serialNumber: 1,
        },
        takeAddr: {
          ...this.takeAddr,
          serialNumber: 1,
        },
        transportInfo: this.transportInfo,
        financeInInfo: this.financeInInfo,
        financeOutInfos: this.financeOutInfos.map((item) => {
          return this.getOperationTypeParams(item);
        }),
        financeOtherInfos: this.financeOtherInfos.map((item) => {
          return this.getOperationTypeParams(item);
        }),
        files,
        otherInfo: this.otherInfo,
      };
      params = JSON.parse(JSON.stringify(params));

      if (this_.isAutoAddr_jj) {
        // 自动收录收件地址
        params.jiAddr = {
          customerId: this_.baseInfo.customerId || "",
          addressType: "ji_jian:address_type",
          address: this_.sendAddr.address || "",
          cityName: this_.sendAddr.cityName || "",
          contacts: this_.sendAddr.contacts || "",
          provinceName: this_.sendAddr.provinceName || "",
          tel: this_.sendAddr.tel || "",
          addressName: "", //地址简称
          areaName: this_.sendAddr.areaName || "",
          phone: this_.sendAddr.tel || "",
          deptName: this_.sendAddr.company || this_.sendAddr.companyName || "",
          idNumber: this_.sendAddr.idNumber,
          remarks: "",
        };
      }
      if (this_.isAutoAddr_sj) {
        // 自动收录收件地址
        params.shouAddr = {
          customerId: this_.baseInfo.customerId || "",
          addressType: "shou_jian:address_type",
          address: this_.receiveAddr.address || "",
          cityName: this_.receiveAddr.cityName || "",
          contacts: this_.receiveAddr.contacts || "",
          provinceName: this_.receiveAddr.provinceName || "",
          tel: this_.receiveAddr.tel || "",
          addressName: "", //地址简称
          areaName: this_.receiveAddr.areaName || "",
          phone: this_.receiveAddr.tel || "",
          deptName:
            this_.receiveAddr.company || this_.receiveAddr.companyName || "",
          idNumber: this_.receiveAddr.idNumber,
          remarks: "",
        };
      }
      // 特殊化处理
      this.preProcess(params);
      if (this.waybillSplitId && this.type !== "copy") {
        params.baseInfo.waybillSplitId = this.waybillSplitId;
        params.waybillSplitId = this.waybillSplitId;
        if (this.type === "edit" || this.baseEdit) {
          if (this.baseEdit) {
            this.loading = true
            this.$API.updateWaybillBase(params).then((res) => {
              this.loading = false
              this.$message.success(res.data.message || "修改成功");
              if (back === false) {
                return Promise.resolve();
              }
              this.reset();
              this.toList();
            }).catch(err => {
              this.loading = false
              return Promise.reject()
            })
          } else {
            this.loading = true
            this.$API.updateWaybill(params).then((res) => {
              this.loading = false
              this.$message.success(res.data.message || "修改成功");
              if (back === false) {
                return Promise.resolve();
              }
              this.reset();
              this.toList();
            }).catch(err=>{
              this.loading = false
              return Promise.reject()
            })
          }
        } else {
          this.loading = true
          this.$API.updateWaybillFinance(params).then((res) => {
            this.loading = false
            this.$message.success(res.data.message || "修改成功");
            if (back === false) {
              return Promise.resolve();
            }
            this.reset();
            this.toList();
          }).catch(err=>{
            this.loading = false
            return Promise.reject()
          })
        }
      } else {
        if(this.saveed){
          this_.$message.success("保存成功");
          return 
        }
        this.loading = true
        await this.$API.addWaybill(params).then((res) => {
          this.loading = false
          if (this_.baseInfo.customerId) {
            //this.autoSaveAddress();
          }
          this.baseInfo.waybillSplitId = res.data.result.waybillSplitId;
          if (back === false) {
            return this.$confirm("新建成功,确定打印？ ", "提示：", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            })
          }
          this.$confirm("新建成功 ", "提示：", {
            confirmButtonText: "查看列表",
            cancelButtonText: "继续新建",
          })
            .then(() => {
              this_.$message.success(res.data.message || "新增成功");
              this.reset();
              this.toList();
            })
            .catch(() => {
              this.reset();
            });
        }).catch(err=>{
          this.loading = false
          return Promise.reject()
        })
      }
      if (refKey) {
        this.enterFns("", refKey);
      }
    },
    submitAndPosting() {
      this.isPosting = 1;
      this.submit("", "k91");
    },
    async saveAndPrintIt(command, refKey) {
      try {
        await this.submit(false);
        this.printIt(command);

        if (refKey) {
          this.enterFns("", refKey);
        }
      }catch(err){

      }
    },
    multiple(a, b) {
      if (!b || !a) {
        return 0;
      }
      const al = a + "";
      const bl = b + "";
      const aa = al.split(".");
      const bb = bl.split(".");
      let ar = a;
      let br = b;
      let an = 0;
      let bn = 0;
      if (aa.length === 2) {
        ar = parseInt(al.replace(".", ""));
        an = aa[1].length;
      }
      if (bb.length === 2) {
        br = parseInt(bl.replace(".", ""));
        bn = bb[1].length;
      }
      return (ar * br) / Math.pow(10, an + bn);
    },
    devide(a, b) {
      if (!b) {
        return 0;
      }
      const al = a + "";
      const bl = b + "";
      const aa = al.split(".");
      const bb = bl.split(".");
      let ar = a;
      let br = b;
      let an = 0;
      let bn = 0;
      if (aa.length === 2) {
        ar = parseInt(al.replace(".", ""));
        an = aa[1].length;
      }
      if (bb.length === 2) {
        br = parseInt(bl.replace(".", ""));
        bn = bb[1].length;
      }
      return ar / br / Math.pow(10, an - bn);
    },
    autoSaveAddress() {
      const this_ = this;
      if (this_.isAutoAddr_jj) {
        // 自动收录收件地址
        this_.autoAddCustomerAddrApi({
          customerId: this_.baseInfo.customerId || "",
          addressType: "ji_jian:address_type",
          address: this_.sendAddr.address || "",
          cityName: this_.sendAddr.cityName || "",
          contacts: this_.sendAddr.contacts || "",
          provinceName: this_.sendAddr.provinceName || "",
          tel: this_.sendAddr.tel || "",
          addressName: "", //地址简称
          areaName: this_.sendAddr.areaName || "",
          phone: this_.sendAddr.tel || "",
          deptName: this_.sendAddr.company || this_.sendAddr.companyName || "",
          idNumber: this_.sendAddr.idNumber,
          remarks: "",
        });
      }
      if (this_.isAutoAddr_sj) {
        // 自动收录收件地址
        this_.autoAddCustomerAddrApi({
          customerId: this_.baseInfo.customerId || "",
          addressType: "shou_jian:address_type",
          address: this_.receiveAddr.address || "",
          cityName: this_.receiveAddr.cityName || "",
          contacts: this_.receiveAddr.contacts || "",
          provinceName: this_.receiveAddr.provinceName || "",
          tel: this_.receiveAddr.tel || "",
          addressName: "", //地址简称
          areaName: this_.receiveAddr.areaName || "",
          phone: this_.receiveAddr.tel || "",
          deptName:
            this_.receiveAddr.company || this_.receiveAddr.companyName || "",
          idNumber: this_.receiveAddr.idNumber,
          remarks: "",
        });
      }
    },
    preProcess(params) {
      if (params.baseInfo.customerId === "") {
        params.baseInfo.customerId = null;
      }
      let financeInInfo = params.financeInInfo;
      if (financeInInfo) {
        financeInInfo.unitPrice = this.dealZeroWhileEmpty(
          financeInInfo.unitPrice
        );
        financeInInfo.basicFreight = this.dealZeroWhileEmpty(
          financeInInfo.basicFreight
        );
        financeInInfo.takeFee = this.dealZeroWhileEmpty(financeInInfo.takeFee);
        financeInInfo.sendFee = this.dealZeroWhileEmpty(financeInInfo.sendFee);
        financeInInfo.transferFee = this.dealZeroWhileEmpty(
          financeInInfo.transferFee
        );
        financeInInfo.agentAmount = this.dealZeroWhileEmpty(
          financeInInfo.agentAmount
        );
        financeInInfo.agentServiceRate = this.dealZeroWhileEmpty(
          financeInInfo.agentServiceRate
        );
        financeInInfo.agentServiceFee = this.dealZeroWhileEmpty(
          financeInInfo.agentServiceFee
        );
        financeInInfo.insuranceFee = this.dealZeroWhileEmpty(
          financeInInfo.insuranceFee
        );
        financeInInfo.allOtherFee = this.dealZeroWhileEmpty(
          financeInInfo.allOtherFee
        );
        financeInInfo.serviceFee = this.dealZeroWhileEmpty(
          financeInInfo.serviceFee
        );
        financeInInfo.senderAmount = this.dealZeroWhileEmpty(
          financeInInfo.senderAmount
        );
        financeInInfo.receivedAmount = this.dealZeroWhileEmpty(
          financeInInfo.receivedAmount
        );
        financeInInfo.monthlyAmount = this.dealZeroWhileEmpty(
          financeInInfo.monthlyAmount
        );
        financeInInfo.rnorderAmount = this.dealZeroWhileEmpty(
          financeInInfo.rnorderAmount
        );
        financeInInfo.goodsDeductedAmoun = this.dealZeroWhileEmpty(
          financeInInfo.goodsDeductedAmoun
        );
        financeInInfo.declaredValue = this.dealZeroWhileEmpty(
          financeInInfo.declaredValue
        );
        financeInInfo.declaredValueRate = this.dealZeroWhileEmpty(
          financeInInfo.declaredValueRate
        );
      }
    },
    // 重置页面
    toList() {
      //this.$TOOLS.closePage();
      this.$BaseIndex.closeCurrentTab("/WaybillManage/ComprehensiveQuery");
    },
    reset() {
      this.saveed = false
      this.$emit("reset");
    },
    calcGoodsFreight(sendAddr) {
      if (!sendAddr.volumeWeight) {
        sendAddr.billingWeight = sendAddr.grossWeight;
        return;
      }
      if (!sendAddr.grossWeight) {
        sendAddr.billingWeight = sendAddr.volumeWeight;
        return;
      }
      sendAddr.billingWeight = Math.max(
        sendAddr.grossWeight,
        sendAddr.volumeWeight
      );
    },
    calcVolumeWeight(pos) {
      let sendAddr = {};
      const { volume, volumeDivisor } = (sendAddr = this.sendAddrs[pos]);
      if (volume && volumeDivisor) {
        const res = this.$TOOLS.divide(volume * 1000000, volumeDivisor);
        let aa = this.$TOOLS.mathToFixed(res, 3);
        if (res > aa) {
          aa = this.$TOOLS.add(aa, 0.001);
        }
        sendAddr.volumeWeight = aa;
      }
      this.calcGoodsFreight(sendAddr);
    },
    go2AddressAI(type) {
      this.isShowDialogAI = true;
      if (type == 1) {
        this.addressAI.addressType = "ji_jian:address_type";
      } else {
        this.addressAI.addressType = "shou_jian:address_type";
      }
    },
    go2Map(type) {
      this.isShowDialogMap = true;
      if (type == 1) {
        this.addressMap.addressType = "ji_jian:address_type";
      } else if (type == 2) {
        this.addressMap.addressType = "shou_jian:address_type";
      } else {
        this.addressMap.addressType = "self_take:address_type";
      }
    },
    chooseAddress(options) {
      this.isShowDialogMap = false;
      // 回填地址
      const address = {
        provinceName: options.province,
        cityName: options.city,
        areaName: options.district,
        address: options.address,
        addressType: this.addressMap.addressType,
      };
      this.changeAddress(address, true);
    },
    go2AddressBook(type) {
      this.isShowDialog3 = true;
    },
    clearAddressAIText() {
      this.addressAI.addressBefore = "";
    },
    analysisAddress() {
      const addressBefore = this.addressAI.addressBefore;
      const addressAfter = AddressParse.parse(addressBefore)[0];
      this.addressAI.username = addressAfter.name;
      this.addressAI.phone = addressAfter.mobile || addressAfter.phone;
      this.addressAI.province = addressAfter.province;
      this.addressAI.city = addressAfter.city;
      this.addressAI.area = addressAfter.area;
      this.addressAI.address = addressAfter.details;
      this.$forceUpdate();
    },
    // 获取计费方式
    async getFormulasBillingWeight(e, types) {
      if (e) {
        const res = await this.$API.runList({
          number: "formula_billing_weight_down_list",
        });
        this.formulasBillingWeight = res || [];
        if (types === "df" && this.formulasBillingWeight.length > 0) {
          this.financeInInfo.formulaBillingWeightId =
            this.formulasBillingWeight[0].formulaBillingWeightId;
          this.financeInInfo.formulaBillingWeightName =
            this.formulasBillingWeight[0].formulaBillingWeightName;
        }
      }
    },
    changeBILLMethode(e, refKey) {
      const item = this.formulasBillingWeight.filter(
        (item) => item.formulaBillingWeightId == e
      )[0];
      this.financeInInfo.formulaBillingWeightName =
        item.formulaBillingWeightName;

      this.enterFns(e, refKey, "select");
    },
    // 计算货物信息表格的运费
    getGoodsTable(a, b) {
      let num1 = this.financeInInfo.billingWeight || 0; //计费取值
      let num2 = this.financeInInfo.unitPrice || 0; //单价
      //this.goodsInfoList[a].itemReqs[b].freight = this.$TOOLS.mul(num1, num2);
      //this.getBasicFreight();
    },
    // 税金
    // getTaxes() {
    //   let num1 = this.CaiWuData.totalFreight || 0; //运费合计
    //   let num2 = this.CaiWuData.invoiceTaxPoint || 0; //税点
    //   let num3 = this.$TOOLS.divide(num2, 100);
    //   this.CaiWuData.taxes = this.$TOOLS.mul(num1, num3).toFixed(2);
    // },
    // 计算:基本运费
    getBasicFreight() {
      let num1 = this.financeInInfo.unitPrice || 0;
      let num2 = 0;

      let financeInInfoData = JSON.parse(JSON.stringify(this.financeInInfo));
      if (this.sendAddrs_1.length == 0) {
        return false;
      }

      switch (financeInInfoData.formulaBillingWeightId) {
        case 1:
          //按件数
          num2 = this.sendAddrs_1[0].packageCout || 0;
          financeInInfoData.basicFreight = this.$TOOLS
            .mul(num1, num2)
            .toFixed(2);
          break;
        case 2:
          //按体积
          num2 = this.sendAddrs_1[0].volume || 0;
          financeInInfoData.basicFreight = this.$TOOLS
            .mul(num1, num2)
            .toFixed(2);
          break;
        case 5:
          //按票数

          num2 = 1;
          financeInInfoData.basicFreight = this.$TOOLS
            .mul(num1, num2)
            .toFixed(2);

          break;
        case 3:
          //按毛重
          num2 = this.sendAddrs_1[0].grossWeight || 0;
          financeInInfoData.basicFreight = this.$TOOLS
            .mul(num1, num2)
            .toFixed(2);
          break;
        case 6:
          //按计费重量
          num2 = this.sendAddrs_1[0].billingWeight || 0;
          financeInInfoData.basicFreight = this.$TOOLS
            .mul(num1, num2)
            .toFixed(2);

          break;
      }

      this.financeInInfo = financeInInfoData;
    },
    // 计算:运费合计
    getTotalFreight() {
      const baseFee = parseFloat(this.financeInInfo.basicFreight || 0);
      const takeFee = parseFloat(this.financeInInfo.takeFee || 0);
      const sendFee = parseFloat(this.financeInInfo.sendFee || 0);
      const transferFee = parseFloat(this.financeInInfo.transferFee || 0);
      const insuranceFee = parseFloat(this.financeInInfo.insuranceFee || 0);
      const allOtherFee = parseFloat(this.financeInInfo.allOtherFee || 0);
      // const serviceFee = this.getService() || 0;
      const serviceFee = parseFloat(this.financeInInfo.serviceFee || 0);

      let num = 0;
      if (this.tenantConfList == "waybillAmount") {
        num = parseFloat(this.financeInInfo.agentServiceFee || 0);
      }

      const total =
        baseFee +
        takeFee +
        sendFee +
        transferFee +
        insuranceFee +
        allOtherFee +
        serviceFee +
        num;
      this.financeInInfo.totalFreight = total.toFixed(3);
      this.setupFee(true);
      this.$forceUpdate();
    },
    changeReceivedCustomer(e, refKey) {
      this.enterFns(e, refKey, "select");
    },

    // 费型类型下拉列表
    itemCategorChoose(categoryName) {
      this.$API
        .itemCategorChoose({ categoryName: categoryName })
        .then((res) => {
          this.categoryNameList = res.data.result || [];
        });
    },
    AddServiceFee() {
      this.isShowDialog7 = true;
    },
    // 其他费项明细
    AddFeiXian() {
      this.financeInInfo.otherFeeInfos = this.financeInInfo.otherFeeInfos || [];
      this.otherFeeInfos =
        JSON.parse(JSON.stringify(this.financeInInfo.otherFeeInfos)) || [];
      this.otherFeeInfos_1 = this.otherFeeInfos.filter(
        (item) => item.operationType != "DEL"
      );
      this.isShowDialog6 = true;
      // this.dialogTitle6 = "新建应收费项";
      this.dialogType = "add";
      this.itemCategorChoose(); //费型类型下拉列表
    },
    EditFeiXian(row, deitIdx) {
      this.isShowDialog6 = true;
      // this.dialogTitle6 = "编辑应收费项";
      this.dialogType = "edit";
      this.deitIdx = deitIdx;
      this.dialogForm2 = JSON.parse(JSON.stringify(row));
      this.financeOutInfos_1 = [
        {
          ...row,
        },
      ];
      this.itemCategorChoose(); //费型类型下拉列表
    },
    // 添加应付弹窗
    addYinFu() {
      this.isShowDialog2 = true;
      this.dialogTitle2 = "新建应付";
      this.dialogType2 = "add";
      this.financeType = "YinFu";
      this.financeOutInfos_1 = [
        {
          amount: null,
          inoutStatus: "zhi_chu:deal_status",
          itemCategoryId: null,
          itemCategoryName: null,
          itemServiceId: null,
          itemServiceName: null,
          objectName: null,
          objectNumber: null,
          objectStatusConfDictId: null,
          paymentMethodConfDictId: null,
          remarks: null,
          objectStatusType: null, //对象类型(我自己加的)
          paymentMethod: null, //付款方式名称(我自己加的)
          files: [],
          preparerEmployeeId: this.$TOOLS.getUserInfo().employeeId,
        },
      ];
      this.itemCategorChoose(); //费型类型下拉列表
      this.getConfDictValDownList("object_status", "objectStatusList"); //结算对象类型
    },
    addOtherShouRu() {
      this.isShowDialog22 = true;
      this.dialogTitle2 = "新建其他收入";
      this.dialogType2 = "add";
      this.financeType = "ShouRu";
      this.financeOtherInfos_1 = [
        {
          amount: null,
          inoutStatus: "shou_ru:deal_status",
          itemCategoryId: null,
          itemCategoryName: null,
          itemServiceId: null,
          itemServiceName: null,
          objectName: null,
          objectNumber: null,
          objectStatusConfDictId: null,
          paymentMethodConfDictId: null,
          remarks: null,
          objectStatusType: null, //对象类型(我自己加的)
          paymentMethod: null, //付款方式名称(我自己加的)
          files: [],
          preparerEmployeeId: this.$TOOLS.getUserInfo().employeeId,
          CategoryServiceList: [],
        },
      ];

      this.itemCategorChoose(); //费型类型下拉列表
      this.getConfDictValDownList("object_status", "objectStatusList"); //结算对象类型
    },
    // 删除一行应付
    delFeiXian(row, idx) { 
      row.operationType = "DEL";
      let objs = JSON.parse(JSON.stringify(row));
      let newdata = JSON.parse(JSON.stringify(this.financeOutInfos_2));
     
      // this.delArrsFOutList.push(JSON.parse(JSON.stringify(row)));
      // this.financeOutInfos_2 = this.financeOutInfos.filter(
      //   (item) => item.operationType != "DEL"
      // );

      if (!this.waybillSplitId) {
           
      this.financeOutInfos_2 = this.financeOutInfos_2.filter(
        (item) => item.operationType != "DEL"
      );
      }else {
        newdata[idx] = objs;
        this.financeOutInfos_2 = newdata;
        this.delArrsFOutList.push(objs);
        this.updateWaybillFinanceOut();
      }

     
    },
    delShouRu(row, idx) {
      row.operationType = "DEL";
      let objs = JSON.parse(JSON.stringify(row));
      let newdata = JSON.parse(JSON.stringify(this.financeOtherInfos_2));
      newdata[idx] = objs;
      this.financeOtherInfos_2 = newdata;
      this.delArrsFInList.push(objs);
      // this.financeOtherInfos_2 = this.financeOtherInfos.filter(
      //   (item) => item.operationType != "DEL"
      // );
      this.updateWaybillFinanceInService();
    },
    // 删除一行货物信息
    delFeiXian2(idx2) {
      this.financeOutInfoReqs.splice(idx2, 1);
    },
    editFeiXian(row, idx) {
      console.log(row);

      this.dialogForm2 = JSON.parse(JSON.stringify(row)); //如果不转表格跟弹窗的数据会一起变
      //this.dialogForm2.itemCategoryId = parseInt(row.itemCategoryId) || ''
      this.dialogForm2.objectStatusConfDictId =
        parseInt(row.objectStatusConfDictId) || null;
      this.dialogForm2.preparerEmployeeId =
        parseInt(row.preparerEmployeeId) || null;
      this.dialogForm2.paymentMethodConfDictId =
        parseInt(row.paymentMethodConfDictId) || null;
      this.dialogForm2.objectStatusTypeName = row.objectStatusTypeName;
      this.dialogForm2.objectStatusType = row.objectStatusType;
      this.dialogForm2.files = row.files;
      this.dialogForm2.id = row.id;
      this.financeOutInfos_1 = [
        {
          ...row,
          //回显问题
          CategoryServiceList: [
            {
              title: row.itemServiceName,
              itemServiceId: row.itemServiceId,
            },
          ],
        },
      ];
      this.isShowDialog2 = true;
      this.dialogTitle2 = "编辑应付";
      this.dialogType2 = "edit";
      this.editYfIdx = idx;
      // this.dialogForm2.objectStatusType
      this.itemCategorChoose(); //费型类型下拉列表
      this.getConfDictValDownList("object_status", "objectStatusList"); //结算对象类型
      this.getObjectUserDownListYf(); //获取结算对象
      this.wtl_itemServiceListAll(row.itemCategoryId, "fu:direction_status"); //获取费项(应收)

      this.$API
        .wtl_getFileList({
          documentNumber: row.fileDocumentNumber,
          documentStatus: row.fileDocumentStatus,
          documentType: row.fileDocumentType,
        })
        .then((res) => {
          this.dialogForm2.files = res.data.result || [];
        });
      this.editYfRow = row;
    },

    editShouRu(row, idx) {
      this.dialogForm2 = JSON.parse(JSON.stringify(row)); //如果不转表格跟弹窗的数据会一起变
      //this.dialogForm2.itemCategoryId = parseInt(row.itemCategoryId) || ''
      this.dialogForm2.objectStatusConfDictId =
        parseInt(row.objectStatusConfDictId) || null;
      this.dialogForm2.preparerEmployeeId =
        parseInt(row.preparerEmployeeId) || null;
      this.dialogForm2.paymentMethodConfDictId =
        parseInt(row.paymentMethodConfDictId) || null;
      this.dialogForm2.objectStatusTypeName = row.objectStatusTypeName;
      this.dialogForm2.objectStatusType = row.objectStatusType;
      this.dialogForm2.files = row.files;
      this.dialogForm2.id = row.id;

      this.financeOtherInfos_1 = [
        {
          ...row,
          //回显问题
          CategoryServiceList: [
            {
              title: row.itemServiceName,
              itemServiceId: row.itemServiceId,
            },
          ],
        },
      ];
      console.log("financeOtherInfos_1", this.financeOtherInfos_1);
      this.isShowDialog22 = true;
      this.dialogTitle2 = "编辑其他收入";
      this.dialogType2 = "edit";
      this.editYfIdx = idx;
      this.itemCategorChoose(); //费型类型下拉列表
      this.getConfDictValDownList("object_status", "objectStatusList"); //结算对象类型
      this.getObjectUserDownListYf(); //获取结算对象
      this.wtl_itemServiceListAll(row.itemCategoryId, "fu:direction_status"); //获取费项(应收)

      // 获取图片
      this.$API
        .wtl_getFileList({
          documentNumber: row.fileDocumentNumber,
          documentStatus: row.fileDocumentStatus,
          documentType: row.fileDocumentType,
        })
        .then((res) => {
          this.dialogForm2.files = res.data.result || [];
        });
      this.editYfRow = row;
    },
    /***
     * 应付
     */
    handleCloseDia2() {
      this.isShowDialog2 = false;
      this.dialogForm2 = {
        // 弹窗表单数据
        amount: null,
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        objectName: null,
        objectNumber: null,
        objectStatusConfDictId: null,
        paymentMethodConfDictId: null,
        remarks: null,
        objectStatusType: null, //对象类型(我自己加的)
        paymentMethod: null, //付款方式名称(我自己加的)
      };
    },
    handleCloseDia22() {
      this.isShowDialog22 = false;
      this.dialogForm2 = {
        // 弹窗表单数据
        amount: null,
        inoutStatus: "zhi_chu:deal_status",
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        objectName: null,
        objectNumber: null,
        objectStatusConfDictId: null,
        paymentMethodConfDictId: null,
        remarks: null,
        objectStatusType: null, //对象类型(我自己加的)
        paymentMethod: null, //付款方式名称(我自己加的)
      };
    },
    //  弹窗确认保存事件
    diaConfirmBtn2(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 编辑
          if (this.dialogForm2.id) {
            const row = this.financeOutInfos_1[0];
            Object.assign(
              this.editYfRow,
              this.financeOutInfos_1[0],
              this.dialogForm2,
              { operationType: "UPDATE" }
            );
            this.editYfRow.itemCategoryId = row.itemCategoryId;
            this.editYfRow.itemCategoryName = row.itemCategoryName;
            this.editYfRow.itemServiceId = row.itemServiceId;
            this.editYfRow.itemServiceName = row.itemServiceName;
            this.editYfRow.amount = row.amount;
          } else {
            this.financeOutInfos_1.map((item) => {
              if (item.operationType == "ADD") {
                Object.assign(this.editYfRow, item, this.dialogForm2, {
                  operationType: "ADD",
                });
                const row = item;
                this.editYfRow.itemCategoryId = row.itemCategoryId;
                this.editYfRow.itemCategoryName = row.itemCategoryName;
                this.editYfRow.itemServiceId = row.itemServiceId;
                this.editYfRow.itemServiceName = row.itemServiceName;
                this.editYfRow.amount = row.amount;
              } else {
                const newOne = {
                  ...item,
                  ...this.dialogForm2,
                  operationType: "ADD",
                };
                const row = item;
                newOne.itemCategoryId = row.itemCategoryId;
                newOne.itemCategoryName = row.itemCategoryName;
                newOne.itemServiceId = row.itemServiceId;
                newOne.itemServiceName = row.itemServiceName;
                newOne.amount = row.amount;
                this.financeOutInfos.push(newOne);
              }
            });
            this.financeOutInfos_2 = this.financeOutInfos.filter(
              (item) => item.operationType != "DEL"
            );
          }
          this.updateWaybillFinanceOut();
          this.isShowDialog2 = false;
          this.financeOutInfos_1 = [];
        }
      });
    },
    diaConfirmBtn22(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 编辑
          if (this.dialogForm2.id) {
            const row = this.financeOtherInfos_1[0];

            Object.assign(
              this.editYfRow,
              this.financeOtherInfos_1[0],
              this.dialogForm2,
              { operationType: "UPDATE" }
            );
            this.editYfRow.itemCategoryId = row.itemCategoryId;
            this.editYfRow.itemCategoryName = row.itemCategoryName;
            this.editYfRow.itemServiceId = row.itemServiceId;
            this.editYfRow.itemServiceName = row.itemServiceName;
            this.editYfRow.amount = row.amount;
          } else {
            this.financeOtherInfos_1.map((item) => {
              if (item.operationType == "ADD") {
                Object.assign(this.editYfRow, item, this.dialogForm2, {
                  operationType: "ADD",
                });
                const row = item;
                this.editYfRow.itemCategoryId = row.itemCategoryId;
                this.editYfRow.itemCategoryName = row.itemCategoryName;
                this.editYfRow.itemServiceId = row.itemServiceId;
                this.editYfRow.itemServiceName = row.itemServiceName;
                this.editYfRow.amount = row.amount;
              } else {
                const newOne = {
                  ...item,
                  ...this.dialogForm2,
                  operationType: "ADD",
                };
                const row = item;
                newOne.itemCategoryId = row.itemCategoryId;
                newOne.itemCategoryName = row.itemCategoryName;
                newOne.itemServiceId = row.itemServiceId;
                newOne.itemServiceName = row.itemServiceName;
                newOne.amount = row.amount;
                this.financeOtherInfos.push(newOne);
              }
            });
            this.financeOtherInfos_2 = this.financeOtherInfos.filter(
              (item) => item.operationType != "DEL"
            );
          }
          this.updateWaybillFinanceInService();
          this.isShowDialog22 = false;
          this.financeOtherInfos_1 = [];
        }
      });
    },
    // 选择结算方式
    changeSettlementMethod(donotCleaar = false, refKey) {
      let val = null;
      this.settlementMethods.forEach((item) => {
        if (item.id == this.financeInInfo.settlementMethodConfDictId) {
          val = item.key;
        }
      });
      this.amountIsAble = true;
      if (val === "ji_fu_yue_jie" || val === "dao_fu_yue_jie") {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "月结费",
          amount: 1,
          sort: 4,
        });
      } else {
        // 删除月结费
        this.delService("月结费");
      }
      this.senderAmountDisable = true;
      this.receivedAmountDisable = true;
      this.monthlyAmountDisable = true;
      this.receivedMonthlyAmountDisable = true;
      this.rnorderAmountDisable = true;
      this.goodsDeductedAmounDisable = true;
      if (!donotCleaar) {
        this.financeInInfo.senderAmount = 0;
        this.financeInInfo.receivedAmount = 0;
        this.financeInInfo.monthlyAmount = 0;
        this.financeInInfo.receivedMonthlyAmount = 0;
        this.financeInInfo.rnorderAmount = 0;
        this.financeInInfo.goodsDeductedAmoun = 0;
      }
      this.getTotalFreight();
      this.setupFee(donotCleaar);

      if (refKey) {
        this.enterFns(
          this.financeInInfo.settlementMethodConfDictId,
          refKey,
          "select"
        );
      }
    },
    setupFee(donotCleaar = false) {
      let val = null;
      this.settlementMethods.forEach((item) => {
        if (item.id == this.financeInInfo.settlementMethodConfDictId) {
          val = item.key;
        }
      });
      // 设置特殊输入规则
      switch (val) {
        // 现结
        case "ji_fu_xian_jie":
          this.financeInInfo.senderAmount = this.financeInInfo.totalFreight;
          this.senderAmountDisable = false;
          break;
        case "ji_fu_yue_jie":
          this.financeInInfo.monthlyAmount = this.financeInInfo.totalFreight;
          this.monthlyAmountDisable = false;
          break;
        case "ji_fu_hui_dan_jie":
          this.financeInInfo.rnorderAmount = this.financeInInfo.totalFreight;
          this.rnorderAmountDisable = false;
          break;
        case "dao_fu":
        case "dao_fu_xian_jie":
          this.financeInInfo.receivedAmount = this.financeInInfo.totalFreight;
          this.receivedAmountDisable = false;
          break;
        case "dao_fu_yue_jie":
          this.financeInInfo.receivedMonthlyAmount =
            this.financeInInfo.totalFreight;
          this.receivedMonthlyAmountDisable = false;
          // 选择月结客户
          break;
        case "duo_bi_fu":
          this.senderAmountDisable = false;
          this.receivedAmountDisable = false;
          this.monthlyAmountDisable = false;
          this.rnorderAmountDisable = false;
          this.goodsDeductedAmounDisable = false;
          this.receivedMonthlyAmountDisable = false;
          if (!donotCleaar) {
            this.financeInInfo.senderAmount = null;
            this.financeInInfo.receivedAmount = null;
            this.financeInInfo.monthlyAmount = null;
            this.financeInInfo.receivedMonthlyAmount = null;
            this.financeInInfo.rnorderAmount = null;
            this.financeInInfo.goodsDeductedAmoun = null;
          }
          break;
        case "dai_shou_huo_kuan_kou":
          this.financeInInfo.goodsDeductedAmoun =
            this.financeInInfo.totalFreight;
          this.goodsDeductedAmounDisable = false;
          break;
        case "mian_fei":
          break;
      }
    },
    changeInsure(e, refKey) {
      if (!this.financeInInfo.isInsure) {
        this.financeInInfo.declaredValue = 0;
        this.financeInInfo.declaredValueRate = 0;
      }
      this.getBXFee();
      this.enterFns(e, refKey, "select");
    },
    getBXFee() {
      let financeInInfoData = JSON.parse(JSON.stringify(this.financeInInfo));
      const declareVal = financeInInfoData.declaredValue;
      const rate = financeInInfoData.declaredValueRate;
      if (!declareVal || !rate) {
        financeInInfoData.insuranceFee = 0;
        return;
      }
      const isSure = financeInInfoData.isSure;
      if (isSure == 0) {
        financeInInfoData.insuranceFee = 0;
        return;
      }
      financeInInfoData.insuranceFee = ((declareVal * rate) / 1000).toFixed(2);
      if (financeInInfoData.insuranceFee < 0.01) {
        financeInInfoData.insuranceFee = 0.01;
      }

      this.financeInInfo = financeInInfoData;
    },
    // 应付费用表格合计
    getFeesPaySummaries(param) {
      let that = this;
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.feesPayableTableTo.length; i++) {
          if (column.property === that.feesPayableTableTo[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.add(prev, curr);
                  // return this.$TOOLS.mathToFixed(
                  //   this.$TOOLS.add(prev, curr),
                  //   2
                  // );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.feesPayableTable.doLayout();
      });
      return sums;
    },
    changeBusinessMan(e, refKey) {
      this.enterFns(e, refKey, "select");
    },
    changeMerchandiserEmployee(e, refKey) {
      this.otherInfo.merchandiserEmployeeName = "";
      this.emps.forEach((item) => {
        if (item.employeeId === e) {
          this.otherInfo.merchandiserEmployeeName = item.employeeName;
        }
      });
      this.enterFns(e, refKey, "select");
    },
    changeHandlingEmployee(e, refKey) {
      this.enterFns(e, refKey, "select");
    },
    // 选择结算对象类型
    changeObjestStatus(e) {
      this.dialogForm2.objectName = "";
      this.dialogForm2.objectNumber = "";
      this.dialogForm2.objectStatusType = "";
      this.dialogForm2.objectStatusTypeName = "";
      if (e) {
        this.objectStatusList.forEach((item) => {
          if (item.id == e) {
            this.dialogForm2.objectStatusType = item.key;
            this.dialogForm2.objectStatusTypeName = item.val;
          }
        });
        this.getObjectUserDownListYf();
      }
    },
    delService(name) {
      let pos = null;
      for (let i = 0; i < this.serviceFees.length; i++) {
        const serviceFee = this.serviceFees[i];
        if (name === serviceFee.itemServiceName) {
          pos = i;
          break;
        }
      }
      if (pos !== null) {
        this.serviceFees.splice(pos, 1);
      }
    },
    addService(serviceFee) {
      const exist =
        this.serviceFees.filter(
          (item) => item.itemServiceName === serviceFee.itemServiceName
        ).length > 0;
      if (exist) {
        return;
      }
      this.serviceFees.push(serviceFee);
      this.serviceFees_1 = this.serviceFees.sort((a, b) => {
        return a.sort - b.sort;
      });
    },
    addCategory() {
      this.financeOutInfos_1.push({
        itemCategoryId: null,
        itemServiceId: null,
        amount: 0,
      });
    },
    delCategory(pos) {
      this.financeOutInfos_1.splice(pos, 1);
    },
    addCategory22() {
      this.financeOtherInfos_1.push({
        itemCategoryId: null,
        itemServiceId: null,
        amount: 0,
      });
    },
    delCategory22(pos) {
      this.financeOtherInfos_1.splice(pos, 1);
    },
    handleConfirmYingShouu() {
      this.financeInInfo.otherFeeInfos = JSON.parse(
        JSON.stringify(this.otherFeeInfos)
      );
      let allOtherFee = 0;
      this.otherFeeInfos
        .filter((item) => item.operationType != "DEL")
        .forEach((item) => (allOtherFee += parseFloat(item.amount)));
      this.financeInInfo.allOtherFee = allOtherFee;
      this.isShowDialog6 = false;
      this.dialogForm6 = {
        itemCategoryId: "",
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        remarks: null,
        amount: null,
      };
      this.otherFeeInfos = [];
      this.otherFeeInfos_1 = this.otherFeeInfos.filter(
        (item) => item.operationType != "DEL"
      );
    },
    handleCloseYingShou() {
      this.isShowDialog6 = false;
      this.dialogForm6 = {
        itemCategoryId: null,
        itemCategoryName: null,
        itemServiceId: null,
        itemServiceName: null,
        remarks: null,
        amount: null,
      };
      this.otherFeeInfos = [];
      this.otherFeeInfos_1 = this.otherFeeInfos.filter(
        (item) => item.operationType != "DEL"
      );
    },
    addOtherFeeInfo() {
      let obj = {
        // CategoryServiceList: this.CategoryServiceList,
      };
      this.otherFeeInfos.push({
        ...this.dialogForm6,
        ...obj,
        operationType: "ADD",
      });
      this.otherFeeInfos_1 = this.otherFeeInfos.filter(
        (item) => item.operationType != "DEL"
      );
    },
    delOtherFeeInfo(row) {
      row.operationType = "DEL";
      this.otherFeeInfos_1 = this.otherFeeInfos.filter(
        (item) => item.operationType != "DEL"
      );
    },
    handleCloseService() {
      this.isShowDialog7 = false;
    },
    changeIntoStorage(e, refKey) {
      if (!e) {
        this.delService("入仓费");
      } else {
        this.addService({
          itemCategoryName: "服务费",
          itemServiceName: "入仓费",
          amount: 9,
          sort: 3,
        });
      }
      this.enterFns(e, refKey, "select");
    },
    changeisAddCustomer(e, refKey) {
      this.enterFns(e, refKey, "select");
    },
    calcAgentService() {
      const amount = this.financeInInfo.agentAmount || 0;
      const rate = this.financeInInfo.agentServiceRate || 0;
      const total = this.$TOOLS.mul(amount, rate);
      this.financeInInfo.agentServiceFee = this.$TOOLS
        .divide(total, 1000)
        .toFixed(2);

      // 向上取整
      this.financeInInfo.agentServiceFee = Math.ceil(
        this.financeInInfo.agentServiceFee
      );
      this.getTotalFreight();
    },
    printIt(command, refKey) {
      if (!this.baseInfo.waybillSplitId) {
        this.$message.warning("请先保存");
        return;
      }
      this.modelClassName = this.classNameArr.filter(
        (item) => item.name === command
      )[0].val;

      switch (this.modelClassName) {
        case "print_waybill_table_data":
          this.getApiType = true;
          break;
        case "print_quan_da_waybill_data":
          this.getApiType = true;
          break;
        case "print_tao_da_waybill_data":
          this.getApiType = true;
          break;
        default:
          this.getApiType = false;
          break;
      }
      this.printEvent();
      if (refKey) {
        this.enterFns("", refKey);
      }
    },
    printDataSource(rows) {
      if (
        this.modelClassName ===
        "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillHkPrintDataV5VO"
      ) {
        return new Promise((resolve, reject) => {
          this.$API
            .hkPrintData({
              waybillSplitIds: [this.baseInfo.waybillSplitId],
            })
            .then((res) => {
              const result = res.data.result;
              resolve(result);
            })
            .catch((err) => {});
        });
      } else {
        return new Promise((resolve, reject) => {
          this.$API
            .runList({
              number: this.modelClassName,
              waybillSplitIds: [this.baseInfo.waybillSplitId],
            })
            .then((res) => {
              const result = res;
              resolve(result);
            })
            .catch((err) => {});
        });
      }
      // return new Promise((resolve, reject) => {
      //   this.$API
      //     .runList({
      //       number: "admin_waybill_list_v5",
      //       waybillSplitIds: [this.baseInfo.waybillSplitId],
      //     })
      //     .then((res) => {
      //       const result = res;
      //       resolve(result);
      //     })
      //     .catch((err) => {});
      // });
    },
    async printEvent() {
      // 获取数据
      if (
        this.modelClassName ===
        "com.bami.service.tms.v5.admin.waybill.vo.print.AdminWaybillHkPrintDataV5VO"
      ) {
        this.$API
          .hkPrintData({
            waybillSplitIds: [this.baseInfo.waybillSplitId],
          })
          .then((res) => {
            const result = res.data.result;
            this.$refs.myPrint.printEvent(result);
          })
          .catch((err) => {});
      } else {
        this.$API
          .runList({
            number: this.modelClassName,
            waybillSplitIds: [this.baseInfo.waybillSplitId],
          })
          .then((res) => {
            const result = res;
            this.$refs.myPrint.printEvent(result);
          })
          .catch((err) => {});
      }
      // this.$API
      //   .runList({
      //     number: "admin_waybill_list_v5",
      //     waybillSplitIds: [this.baseInfo.waybillSplitId],
      //   })
      //   .then((res) => {
      //     const result = res;
      //     this.$refs.myPrint.printEvent(result);
      //   })
      //   .catch((err) => {});
    },
  },
};
</script>
<style scoped lang="less">
// 查询条件边框线
@borderColor: #cccccc;

.topBtns {
  width: calc(100% - 240px);
  position: fixed;
  z-index: 10;
  top: 60px;
  left: 210px;
  background-color: #fff;
  // box-shadow: 2px 2px 5px #ccc;
  padding-bottom: 10px;
  border-bottom: 1px solid #ccc;
  margin-right: 30px;
  height: 50px;
}
.contentBox {
  padding-bottom: 50px;
}

.form_head {
  .waybill_Type {
    margin-bottom: 10px;
    width: fit-content;
    color: #ff0000;
    font-weight: bold;
    border: 2px dashed transparent;
    border-radius: 5px;
    padding: 2px 12px;
    background: linear-gradient(#fff, #fff) padding-box,
      repeating-linear-gradient(
        -75deg,
        #ff0000 0,
        #ff0000 0.9em,
        #fff 0,
        #fff 1.2em
      );
  }
  .head_formBox {
    justify-content: space-between;
    .el-form-item {
      margin-bottom: 13x;
      width: 18%;
      min-width: unset;
      margin-right: unset;
      overflow: unset;
    }
  }
}
.all_div {
  border: 1px solid #f59a23;
}

.infoDiv {
  border-width: 1px 1px 0 1px;
  border-style: solid;
  border-color: #f59a23;
  display: flex;
  .h3title {
    background: #f9c99d;
    margin: 0;
    color: #fff;
    width: 40px;
    font-size: 18px;
    display: flex;
    align-items: center;
    // background-color: #f2f2f2;
    padding: 5px;
    // padding: 10px;
    // border-bottom: 1px solid @borderColor;
    font-weight: bold;
    // margin-bottom: 20px;
  }

  .formbox {
    // padding: 0 30px;
    padding: 0 10px;
    width: calc(100% - 70px);
    .glo_formBox {
      .double_item {
        /deep/.el-form-item__content {
          display: flex;
          .el-select {
            input {
              //padding-left: 5px;
            }
          }
          .second_ipt {
            input {
              padding-left: 5px;
              padding-right: 10px;
            }
          }
          .unit {
            margin-right: 5px;
          }
        }
      }
      .Divider {
        width: 100%;
        height: 1px;
        margin-bottom: 10px;
        border-top: 1px dashed transparent;
        background: linear-gradient(#fff, #fff) padding-box,
          repeating-linear-gradient(
            -75deg,
            #797979 0,
            #797979 0.9em,
            #fff 0,
            #fff 1.2em
          );
      }
    }
    .head_formBox {
      justify-content: flex-start;
      margin: 15px 0 5px 0;
      .el-form-item {
        // width: 18%;
        width: calc(24% - 2px);
        min-width: unset;
        margin-bottom: 13px;
        overflow: unset;
      }
    }
    .jsInput {
      .jsBtns {
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 10px;
        border: none;
      }
    }
  }

  .goodsItmes {
    margin: 10px 0;
    // margin-top: 30px;
    // border-bottom: 4px solid #ccc;
    // padding-bottom: 20px;
  }

  .formBtns {
    height: 30px;
    margin: 0;
    padding: 0 10px;
  }

  .miniInput {
    width: 80px;
    border-left: 1px solid #ccc;
    border-right: 1px solid #ccc;
    margin-right: 2px;

    text-align: center;

    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0 5px;
    }
  }
}

.disFlexs {
  display: flex;
  align-items: center;
  width: 100%;
}

.selectAddress {
  border: 1px solid #ccc;
  margin-right: 10px;
  width: 180px !important;
}
.addressDetails {
  //   width: 380px !important;
  flex: 1;
}

.btmBtns {
  text-align: center;
  margin-top: 50px;

  .saveBtns {
    font-size: 16px;
  }
}

.iconList {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  //   text-align: center;

  .iconSize {
    font-size: 26px;
    cursor: pointer;
  }

  .tbBtns {
    padding: 5px 10px;
    margin: 0;
    border: 1px solid #333;
  }
}

.addTiHuoDiZhi {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin: 20px 0;
}

.multipleSelect {
  display: flex;

  /deep/ .el-select {
    flex: 1;
  }
}

.textArea {
  height: 100%;
}

.glo_btnItems {
  height: 30px;
  line-height: 30px;
  padding: 0 20px;
}

.goodsTable {
  /deep/ .el-table {
    width: 100%;
    .cell {
      padding-right: 0;
      padding-left: 0;
    }
  }
}

// #tables {
//   .glo_formBox {
//     /deep/ .el-input__icon {
//       line-height: 30px !important;
//     }
//   }
// }
.linkTabel {
  text-align: center;
  cursor: pointer;
}
/deep/ .el-input__icon {
  line-height: 30px !important;
}

.disFlex {
  display: flex;
  align-items: center;
}

.checkBox {
  margin-left: 30px;
}

#tiHuoForm {
  padding: 10px;
  border: 1px dashed @borderColor;
  margin: 0 45px 10px 30px;
}
.address-ai-input {
  width: 100%;
  border: none;
}
.address-ai-button-container {
  text-align: right;
  padding: 5px 8px 5px 5px;
}
.address-ai-form {
  .el-form-item {
    margin-bottom: 1px;
    ::v-deep .el-form-item__label {
      text-align: right;
    }
  }
}
.item-category-container {
  ::v-deep .el-input__inner {
    width: 200px;
  }
}
.amp-map-dialog {
  /deep/ .el-dialog__body {
    max-height: calc(100vh - 120px);
  }
}

.tranfserTb {
  display: flex;
  justify-content: center;
  // align-items: center;

  .tranfser_tit {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .tranfser_item {
    flex: 1;
  }
  .tfRTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tranfser_center {
    width: 140px;

    display: flex;
    align-items: center;
    justify-content: center;

    .btnA {
      padding: 10px;
    }
  }
}

.btnB {
  padding: 6px;
}

@tbBorder: #ebeef5;
.daraStyle_H {
  background-color: #f0f0f0;
}
// 拖拽
.daraStyle_1 {
  height: 34px;
  line-height: 34px;
  border-bottom: none;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid @tbBorder;
  cursor: grab;

  .daraNum_1 {
    width: 60px;
    text-align: center;
  }

  .cloWidth_1 {
    flex: 1;
    text-align: left;
    border-left: 1px solid @tbBorder;
    border-right: 1px solid @tbBorder;
    padding: 0 20px;
  }
  .icon_del {
    width: 50px;
    text-align: center;
    cursor: pointer;
  }

  .el-icon-delete {
    font-size: 20px;
  }
}
.daraStyle_1:hover {
  background-color: #f2f2f2;
}

// .daraStyle_1:last-of-type {
//   border-bottom: 1px solid @tbBorder;
// }

.draggableClass {
  border: 1px solid @tbBorder;
}

/deep/ .el-input__inner:focus {
  // border-color: #409eff; /* 你可以自定义这个颜色 */
  box-shadow: inset 0px 0px 0 2px #ef7c0a; /* 聚焦时的阴影效果 */
}

.appendInputs {
  /deep/ .el-input-group__append {
    padding: 0 4px !important;
  }
}

.lookBJ {
  height: 35px;
  line-height: 35px;
  // border: 1px solid #ccc;
  padding: 0 10px;
  border-radius: 4px;
  color: #6984fa;
  cursor: pointer;
}

.offerContentDT {
  height: 50vh;
  overflow: auto;
}
.long-parse{
  /deep/ .el-form-item__content{
    margin-left:130px;
  }
}
</style>
